import { createSvgIcon } from './svg-icon';

export const AdIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M18.087 60.8247C22.294 62.859 27.0136 64 32 64s9.706-1.141 13.913-3.1753L48.6956 32 45.913 3.1753C41.706 1.141 36.9864 0 32 0s-9.706 1.141-13.913 3.1753L15.3044 32z"
      />
      <path
        fill="#d80027"
        d="M45.913 60.8236C56.6169 55.6479 64 44.6866 64 32S56.6169 8.3521 45.913 3.1764z"
      />
      <path
        fill="#0052b4"
        d="M18.087 60.8236V3.1764C7.3831 8.352 0 19.3133 0 32c0 12.6868 7.3831 23.6479 18.087 28.8236"
      />
      <path
        fill="#d80027"
        d="M32 43.1304V32h8.3479v4.1739c0 .7251-1.3913 3.3821-4.8254 5.5652-1.3006.827-2.647 1.093-3.5225 1.3913m-8.3479-19.4783H32V32h-8.3479z"
      />
      <path
        fill="#ff9811"
        d="M36.1739 20.8697c0-1.5369-1.2459-2.7827-2.7826-2.7827-.5075 0-.9818.138-1.3913.3753a2.765 2.765 0 0 0-1.3912-.3753c-1.5368 0-2.7827 1.2458-2.7827 2.7827h-6.9565v13.9128c0 5.1795 4.1133 8.1749 7.3389 9.7277-.2414.4122-.3824.8906-.3824 1.403 0 1.5368 1.2459 2.7826 2.7827 2.7826A2.765 2.765 0 0 0 32 48.3205a2.766 2.766 0 0 0 1.3913.3753c1.5367 0 2.7826-1.2458 2.7826-2.7826 0-.5124-.141-.9908-.3825-1.403 3.2256-1.5528 7.339-4.548 7.339-9.7277V20.8697zm2.7826 13.9128c0 .7252 0 2.9315-3.434 5.1148-1.3007.827-2.647 1.3632-3.5225 1.6614-.8755-.2982-2.2217-.8344-3.5225-1.6614-3.434-2.1833-3.434-4.3896-3.434-5.1148v-9.739h13.913z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ad',
  64
);

export const AeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="m18.087 43.1304 2.7826 18.8795C24.3361 63.2962 28.0857 64 32 64c13.7587 0 25.4882-8.684 30.0095-20.8696z"
      />
      <path
        fill="#6da544"
        d="m18.087 20.8696 2.7826-18.8795C24.3361.7037 28.0857 0 32 0c13.7587 0 25.4882 8.684 30.0095 20.8696z"
      />
      <path
        fill="#a2001d"
        d="M0 32.0001C0 45.759 8.6841 57.4884 20.8696 62.0097V1.9905C8.6841 6.5119 0 18.2412 0 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ae',
  64
);

export const AfIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M45.913 3.1753C41.706 1.141 36.9863 0 32 0s-9.706 1.141-13.913 3.1753L15.3044 32l2.7826 28.8247C22.294 62.859 27.0138 64 32 64s9.706-1.141 13.913-3.1753L48.6956 32z"
      />
      <path
        fill="#000"
        d="M18.087 3.1764C7.3833 8.3523 0 19.3134 0 32s7.3833 23.6478 18.087 28.8236z"
      />
      <path
        fill="#496e2d"
        d="M45.913 3.1764v57.6472C56.6168 55.6478 64 44.6866 64 32S56.6168 8.3523 45.913 3.1764"
      />
      <path
        fill="#ffda44"
        d="M32 20.8696c-6.1472 0-11.1304 4.9833-11.1304 11.1304S25.8529 43.1304 32 43.1304 43.1304 38.1471 43.1304 32 38.1473 20.8696 32 20.8696m0 18.0869c-3.842 0-6.9565-3.1146-6.9565-6.9565S28.1581 25.0435 32 25.0435 38.9565 28.1581 38.9565 32 35.842 38.9565 32 38.9565"
      />
      <path
        fill="#ffda44"
        d="M32 27.8261c-1.5368 0-2.7826 1.2458-2.7826 2.7826v4.1739h5.5653v-4.1739c0-1.5368-1.2458-2.7826-2.7827-2.7826"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Af',
  64
);

export const AgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M0 32c0 2.1919.221 4.3321.6409 6.4L32 40.3478 63.3592 38.4c.42-2.0679.6408-4.2081.6408-6.4s-.221-4.3321-.6408-6.4L32 23.6521.6409 25.6A32.14 32.14 0 0 0 0 32"
      />
      <path
        fill="#fff"
        d="M63.3592 38.4H.6409C3.6058 53.0063 16.5189 64 32 64s28.3942-10.9937 31.3592-25.6"
      />
      <path
        fill="#000"
        d="M.6409 25.6h62.7185C60.3942 10.9938 47.4814 0 32 0S3.6058 10.9938.6409 25.6"
      />
      <path
        fill="#ffda44"
        d="M45.913 25.6H18.087l5.685-2.6743-3.0274-5.5056 6.1731 1.1806.7825-6.2361L32 16.9514l4.3-4.5868.782 6.2361 6.1734-1.1806-3.0272 5.5059z"
      />
      <path
        fill="#a2001d"
        d="M0 32c0 17.673 14.327 32 32 32L6.3995 12.7988C2.3815 18.1475 0 24.7953 0 32m32 32c17.673 0 32-14.327 32-32 0-7.2047-2.3815-13.8525-6.3995-19.2012z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ag',
  64
);

export const AiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 32.0001H32v-.0857q-.0427.043-.0856.0857" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1658 7.0107-12.0155 12.0155V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32 28.0648 20.6306 16.6957h-3.935v.0002l15.3042 15.304H32z"
      />
      <path
        fill="#f3f3f3"
        d="M54.1174 36.6843c.9201-1.266 1.5347-2.812 1.5347-4.6843V18.087c-1.1627.8735-2.6077 1.3913-4.1738 1.3913-2.2758 0-4.2962-1.0929-5.5653-2.7824-1.2692 1.6895-3.2896 2.7824-5.5652 2.7824-1.5663 0-3.0113-.5179-4.1739-1.391V32c0 1.8723.6146 3.4183 1.5347 4.6843z"
      />
      <path
        fill="#ff9811"
        d="M51.2231 29.4189c.443-1.0807.7875-2.6603.7875-3.4465 0-1.2631-1.6467-2.287-1.6467-2.287s-1.6468 1.0239-1.6468 2.287c0 .7863.3447 2.3659.7874 3.4465l-.9506 2.1464a4.79 4.79 0 0 0 1.8101.3535 4.8 4.8 0 0 0 1.8101-.3535zm-6.4363-6.9499c-1.157.1568-2.6974.6486-3.3782 1.0416-1.0938.6317-1.1573 2.5695-1.1573 2.5695s1.7102.9142 2.8039.2827c.681-.3932 1.8765-1.4812 2.5907-2.4052l2.3345-.25a4.8 4.8 0 0 0-.599-1.744 4.8 4.8 0 0 0-1.2112-1.391zm-2.8003 9.0493c.7141.9235 1.91 2.0114 2.591 2.4046 1.0939.6315 2.804-.2823 2.804-.2823s-.0637-1.9382-1.1574-2.5698c-.6811-.3931-2.2212-.8845-3.3785-1.041l-1.3833-1.8966a4.8 4.8 0 0 0-1.211 1.3906 4.8 4.8 0 0 0-.5992 1.7444z"
      />
      <path
        fill="#338af3"
        d="M37.3645 36.1742c2.5985 4.1694 8.5486 5.565 8.5486 5.565s5.95-1.3956 8.5487-5.565z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ai',
  64
);

export const AlIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="M50.087 23.7512H38.4962c.7155-.7493 1.1559-1.7636 1.1559-2.8815 0-2.3051-1.8687-4.1739-4.1739-4.1739-1.4522 0-2.7306.742-3.4782 1.8671-.7476-1.1251-2.0261-1.8671-3.4783-1.8671-2.3051 0-4.1738 1.8688-4.1738 4.1739 0 1.1179.4403 2.1324 1.1558 2.8815H13.9131c0 3.0736 2.6771 5.5651 5.7505 5.5651h-.1855c0 3.0738 2.4916 5.5654 5.5654 5.5654 0 .9955.2624 1.9287.7204 2.7367l-4.6163 4.6164 3.5418 3.5415 5.024-5.0239c.1967.0722.4003.13.6106.1694l-3.0359 6.8544L32 52.8697l4.7119-5.0938-3.0359-6.8543a3.8 3.8 0 0 0 .6106-.1694l5.024 5.0239 3.5418-3.5417-4.6164-4.6163a5.53 5.53 0 0 0 .7205-2.7368c3.0736 0 5.5652-2.4915 5.5652-5.5654h-.1853c3.0733.0003 5.7506-2.4911 5.7506-5.5647"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Al',
  64
);

export const AmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0-3.9143-.704-7.6639-1.9904-11.1304L32 19.4782 1.9904 20.8695C.704 24.3361 0 28.0857 0 32s.7041 7.6639 1.9904 11.1304L32 44.5217l30.0096-1.3912C63.296 39.6639 64 35.9142 64 32"
      />
      <path
        fill="#ff9811"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#d80027"
        d="M1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0S6.5117 8.684 1.9904 20.8696"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Am',
  64
);

export const AoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32c-1.3913 0-32 4.1739-32 4.1739z"
      />
      <path fill="#000" d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32" />
      <path
        fill="#ffda44"
        d="m27.6122 25.4515 2.7128 1.9687-1.0338 3.1885 2.7108-1.972 2.713 1.9688-1.0378-3.1875 2.7105-1.9718-3.3518.002-1.0379-3.1873-1.0339 3.1885z"
      />
      <path
        fill="#ffda44"
        d="M40 18.1436c-2.5216-1.4558-5.2788-2.143-8-2.1382v4.173c2.0114-.0036 4.0491.5039 5.913 1.5801 5.6472 3.2605 7.5891 10.5075 4.3285 16.1548-3.2604 5.6472-10.5073 7.5891-16.1546 4.3286a11.75 11.75 0 0 1-3.9524-3.728L18.65 40.8144c1.3246 2.0136 3.1241 3.757 5.35 5.042C31.6405 50.2676 41.4451 47.6405 45.8562 40 50.2675 32.3595 47.6405 22.5549 40 18.1436"
      />
      <path
        fill="#ffda44"
        d="M22.7737 29.2174c-1.1062 2.0224-.3635 4.5588 1.6588 5.665l13.5561 7.4075c-.9219 1.6851-.4322 3.7363 1.2529 4.6581l3.6619 2.0032c1.6851.922 3.799.303 4.7208-1.3823l2.0032-3.6617z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ao',
  64
);

export const ArIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#338af3"
        d="M32 0C19.3133 0 8.3513 7.3831 3.1753 18.087h57.6493C55.6488 7.3831 44.6866 0 32 0m0 64c12.6866 0 23.6488-7.3831 28.8248-18.087H3.1753C8.3513 56.6169 19.3133 64 32 64"
      />
      <path
        fill="#ffda44"
        d="m41.5644 32-3.9081 1.8384 2.0811 3.7848-4.2438-.8118-.5377 4.287L32 37.9454l-2.956 3.153-.5376-4.287-4.2438.8117 2.081-3.7849L22.4356 32l3.9082-1.8384-2.0812-3.7847 4.2437.8117.5378-4.287L32 26.0546l2.956-3.153.5376 4.287 4.2439-.8117-2.0811 3.7848z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ar',
  64
);

export const AsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M47.5245 4.014C42.9265 1.458 37.6338 0 32 0 14.3283 0 .0023 14.3248 0 31.9963l22.2609-11.1267zM0 32.0038C.0023 49.6753 14.3283 64 32 64c5.6338 0 10.9265-1.4577 15.5245-4.014L22.2609 43.1304z"
      />
      <path
        fill="#d80027"
        d="M50.1912 5.6728a32 32 0 0 0-2.6678-1.6583L0 31.9963v.0075l47.5235 27.9816a32.1 32.1 0 0 0 2.6679-1.6582L5.4778 32z"
      />
      <path
        fill="#a2001d"
        d="M55.6521 30.8066h-3.8117c.9911-1.19.93-2.9604-.1867-4.0768 1.1828-1.1826 1.1828-3.1002 0-4.2831l-.0712.0715c1.1826-1.1826 1.254-3.1718.0712-4.3544l-17.132 17.132c1.1828 1.1829 3.0668 1.1688 4.2494-.014l.3298-.3014 8.2035-.7457v3.5282h2.7826v-3.7812l4.1739-.3794z"
      />
      <path
        fill="#ffda44"
        d="M34.7836 38.9565 32 37.5652l2.7836-1.3914h18.0869v2.7827z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'As',
  64
);

export const AtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M62.0096 43.1304C63.296 39.6639 64 35.9143 64 32s-.704-7.6636-1.9904-11.1304L32 18.087 1.9904 20.8696C.704 24.3364 0 28.0858 0 32s.7041 7.6639 1.9904 11.1304L32 45.913z"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7588 0 25.4883-8.684 30.0095-20.8696H1.9903C6.5118 55.316 18.241 64 32 64m0-64C18.241 0 6.5118 8.684 1.9903 20.8696h60.0193C57.4883 8.684 45.7588 0 32 0"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'At',
  64
);

export const AuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0075 32 .0036 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="m32 0-.0054.0001zm-.0856 32H32v-.0856z" />
      <path
        fill="#fff"
        d="M32 16.6957V.0001h-.0054C14.324.003 0 14.3286 0 32h16.6956v-9.4015L26.0971 32h5.8174l.0856-.0856v-5.817l-9.4016-9.4017z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1739c-5.0049 2.8499-9.1656 7.0106-12.0155 12.0155V32h8.3479V12.5218H32v-8.348z"
      />
      <path
        fill="#d80027"
        d="m32 28.0649-11.3691-11.369h-3.9352L31.9999 32H32z"
      />
      <path
        fill="#fff"
        d="m19.2994 37.5652 1.7562 3.6723 3.9659-.9166-1.776 3.6627 3.1893 2.5291-3.9709.895.0111 4.0705-3.1756-2.5466-3.1755 2.5466.0111-4.0705-3.971-.895 3.1894-2.5291-1.7763-3.6627 3.9662.9166zm28.6111 6.9566.8781 1.8361 1.983-.4584-.8881 1.8314 1.5948 1.2646-1.9855.4475.0055 2.0353-1.5878-1.2734-1.5877 1.2734.0055-2.0353-1.9854-.4475 1.5946-1.2646-.888-1.8314 1.9829.4584zm-8.1689-19.4783.878 1.8362 1.983-.4585-.888 1.8314 1.5947 1.2646-1.9854.4475L41.3293 32l-1.5877-1.2734L38.1539 32l.0054-2.0353-1.9854-.4475 1.5946-1.2646-.888-1.8314 1.983.4585zm8.1689-11.1305.8781 1.8362 1.983-.4583-.888 1.8313 1.5945 1.2645-1.9853.4477.0055 2.0352-1.5878-1.2734-1.5877 1.2734.0055-2.0352-1.9854-.4477 1.5945-1.2645-.8879-1.8313 1.9829.4583zm7.1355 8.3479.878 1.8362 1.983-.4585-.888 1.8314 1.5946 1.2646-1.9855.4476.0055 2.0352-1.5876-1.2733-1.5877 1.2733.0053-2.0352-1.9853-.4476 1.5946-1.2646-.888-1.8314 1.9829.4585zM49.9438 32l.6906 2.1258h2.2352l-1.8083 1.3138.6908 2.1257-1.8083-1.3138-1.8083 1.3138.6906-2.1257-1.8082-1.3138h2.2351z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Au',
  64
);

export const AwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#338af3"
        d="M32 64c9.6989 0 18.3892-4.3155 24.2576-11.1304H7.7424C13.6107 59.6845 22.301 64 32 64m32-32C64 14.327 49.673 0 32 0S0 14.327 0 32c0 2.8884.385 5.6861 1.1024 8.3479h61.7954C63.615 37.6861 64 34.8884 64 32M2.5436 44.5217a31.9 31.9 0 0 0 2.1532 4.1739h54.6065a31.95 31.95 0 0 0 2.1533-4.1739z"
      />
      <path
        fill="#fff"
        d="m14.6646 20.1829-6.252-2.7593 6.252-2.7592 2.7591-6.2519 2.7591 6.2519 6.2519 2.7592-6.2519 2.7593-2.7591 6.2519z"
      />
      <path
        fill="#d80027"
        d="m17.4238 11.8584 1.7038 3.8611 3.8613 1.7041-3.8613 1.704-1.7038 3.8611-1.7042-3.8611-3.8611-1.704 3.8611-1.7041z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Aw',
  64
);

export const AxIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M62.8976 40.3478C63.615 37.6861 64 34.8883 64 32c0-2.8884-.385-5.6862-1.1024-8.3479L29.2174.1217c-6.2526.5388-11.9905 2.875-16.6956 6.4901L1.1024 23.6521C.385 26.3138 0 29.1116 0 32c0 2.8715.3804 5.6538 1.0898 8.3016l11.4318 17.0865c4.7051 3.6151 10.443 5.9515 16.6957 6.4901z"
      />
      <path
        fill="#0052b4"
        d="M1.1024 40.3479c1.8515 6.8699 5.932 12.8241 11.4193 17.0403V40.3479zm28.1149 23.5304A32.4 32.4 0 0 0 32 64c14.7848 0 27.2256-10.0276 30.8976-23.6521H29.2173zm33.6803-40.2262C59.2256 10.0276 46.7848 0 32 0a32.4 32.4 0 0 0-2.7827.1218V23.652zM12.5217 6.6118C7.0345 10.8281 2.9539 16.7822 1.1024 23.6521h11.4193z"
      />
      <path
        fill="#d80027"
        d="M63.7291 27.8261H25.0435V.7606a31.78 31.78 0 0 0-8.3479 3.1303V27.826H.2709A32.3 32.3 0 0 0 0 32c0 1.4146.0928 2.8076.2709 4.1739h16.4247V60.109a31.78 31.78 0 0 0 8.3479 3.1302V36.174h38.6856A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1739"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ax',
  64
);

export const AzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M64 32c0-3.9143-.704-7.6639-1.9904-11.1304L32 19.4782 1.9904 20.8695C.704 24.3361 0 28.0857 0 32s.7041 7.6639 1.9904 11.1304L32 44.5217l30.0096-1.3912C63.296 39.6639 64 35.9142 64 32"
      />
      <path
        fill="#6da544"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#338af3"
        d="M1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0S6.5117 8.684 1.9904 20.8696"
      />
      <path
        fill="#fff"
        d="M32.6956 41.0435c-4.9945 0-9.0435-4.049-9.0435-9.0435s4.049-9.0435 9.0435-9.0435c1.5572 0 3.0226.3938 4.3019 1.087-2.007-1.9626-4.7515-3.174-7.7801-3.174-6.1473 0-11.1304 4.9833-11.1304 11.1304s4.9832 11.1304 11.1304 11.1304c3.0287 0 5.7732-1.2114 7.7801-3.174-1.2793.6935-2.7447 1.0872-4.3019 1.0872"
      />
      <path
        fill="#fff"
        d="M39.6521 25.7391 40.85 29.108l3.2292-1.5352-1.5351 3.2292L45.913 32l-3.3689 1.198 1.5351 3.2293L40.85 34.892l-1.1979 3.3689-1.1977-3.3689-3.2294 1.5353 1.5352-3.2293L33.3912 32l3.369-1.198-1.5352-3.2292 3.2294 1.5352z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Az',
  64
);

export const BaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M32 0C20.6537 0 10.6875 5.9054 5.0055 14.8099l43.3949 44.6712C57.7432 53.8934 64 43.6779 64 32 64 14.327 49.673 0 32 0"
      />
      <path
        fill="#0052b4"
        d="M64 32c0-8.3028-3.1623-15.8663-8.3479-21.5535v43.1071C60.8377 47.8662 64 40.3027 64 32M39.9736 60.2341l3.3519-.0021 1.034-3.1887 1.0378 3.1874 1.6812-.001a32 32 0 0 0 2.9875-1.8161L5.5861 13.9338a32 32 0 0 0-2.0026 3.3438l.3952 1.214 3.352-.0021L4.62 20.4613l1.0378 3.1874-2.713-1.9685-1.6181 1.177C.464 25.7542 0 28.8228 0 32c0 17.673 14.327 32 32 32 3.7365 0 7.3229-.6415 10.6562-1.819zM7.1374 30.6087l1.0337-3.1885-2.7127-1.9687 3.3519-.0022 1.0338-3.1886 1.0378 3.1874 3.3519-.0021-2.7107 1.9718 1.0378 3.1874-2.713-1.9685zm6.9031 6.9565 1.0338-3.1885-2.7128-1.9687 3.3519-.0022 1.0338-3.1886 1.0378 3.1874 3.3519-.0021-2.7105 1.9718 1.0377 3.1874-2.713-1.9685zm6.903 6.9565 1.0337-3.1885-2.7127-1.9687 3.3519-.0022 1.0338-3.1886 1.0378 3.1874 3.3519-.0021-2.7105 1.9718 1.0377 3.1874-2.713-1.9687zm9.6136 4.9846-2.7106 1.9719 1.0338-3.1885-2.7128-1.9687 3.3519-.0022 1.034-3.1886 1.0377 3.1874 3.3519-.0021-2.7105 1.9718 1.0377 3.1874zm4.1925 8.9284 1.0338-3.1885-2.7128-1.9687 3.3519-.0022 1.0339-3.1886 1.0377 3.1874 3.3519-.0021-2.7105 1.9718 1.0377 3.1874-2.7129-1.9687z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ba',
  64
);

export const BbIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M45.913 3.1753C41.706 1.141 36.9863 0 32 0s-9.706 1.141-13.913 3.1753L15.3044 32l2.7826 28.8247C22.294 62.859 27.0138 64 32 64s9.706-1.141 13.913-3.1753L48.6956 32z"
      />
      <path
        fill="#0052b4"
        d="M18.087 3.1764C7.3833 8.352 0 19.3133 0 32c0 12.6868 7.3833 23.6479 18.087 28.8236zm27.826 0v57.6472C56.6168 55.6479 64 44.6866 64 32S56.6168 8.3521 45.913 3.1764"
      />
      <path
        fill="#000"
        d="m41.7391 19.4783 1.8666.9333zl-1.8667-.9332c-.1125.2251-2.5499 5.1842-2.9481 12.7593H34.087V19.4783L32 16.6957l-2.087 2.7826v11.8261h-2.8374c-.3983-7.5751-2.8355-12.5342-2.9481-12.7593l-3.7333 1.8666c.0258.0512 2.5624 5.2144 2.5624 12.9797v2.087h6.9565v11.8262h4.1739V35.4784h6.9565v-2.0871c0-4.0147.6946-7.3252 1.2775-9.3955.6353-2.2575 1.2807-3.5759 1.2871-3.589z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bb',
  64
);

export const BdIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#496e2d"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M25.0435 45.913c7.6839 0 13.913-6.229 13.913-13.913s-6.2291-13.913-13.913-13.913S11.1305 24.3161 11.1305 32s6.2291 13.913 13.913 13.913"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bd',
  64
);

export const BeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M43.1304 1.9904C39.6638.704 35.9143 0 32 0s-7.6637.7041-11.1304 1.9904L18.087 32l2.7826 30.0096C24.3363 63.296 28.0858 64 32 64s7.6638-.704 11.1304-1.9904L45.913 32z"
      />
      <path
        fill="#d80027"
        d="M64 32c0-13.7587-8.684-25.4882-20.8696-30.0095V62.01C55.316 57.4883 64 45.759 64 32"
      />
      <path
        fill="#000"
        d="M0 32c0 13.759 8.684 25.4883 20.8696 30.0098V1.9905C8.684 6.5118 0 18.2413 0 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Be',
  64
);

export const BfIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32c-1.3913 0-32 4.1739-32 4.1739z"
      />
      <path fill="#6da544" d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32" />
      <path
        fill="#ffda44"
        d="m31.9999 20.8696 2.4171 7.4398h7.8234l-6.329 4.5982 2.4172 7.4403-6.3287-4.5981-6.3289 4.5981 2.4176-7.4403-6.3291-4.5982h7.823z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bf',
  64
);

export const BgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#496e2d"
        d="M64 32c0-3.9142-.704-7.6639-1.9904-11.1304L32 19.4783 1.9904 20.8695C.704 24.3361 0 28.0858 0 32c0 3.9143.7041 7.6639 1.9904 11.1304L32 44.5218l30.0096-1.3913C63.296 39.6639 64 35.9143 64 32"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#fff"
        d="M1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0S6.5117 8.684 1.9904 20.8696"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bg',
  64
);

export const BhIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0c-6.422 0-12.401 1.8931-17.4125 5.1498l8.2299 5.5161-10.2957 5.3332 10.2957 5.3333-10.2957 5.3332 10.2957 5.3326-10.2957 5.3332 10.2957 5.3331-10.2957 5.3337 10.2957 5.3333-8.2309 5.5179C19.5982 62.1066 25.5776 64 32 64c17.673 0 32-14.327 32-32S49.673 0 32 0"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bh',
  64
);

export const BiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M51.4845 6.6128C40.028-2.2029 23.972-2.2029 12.5155 6.6127L32 26.0972zM31.9998 37.9031 12.5155 57.3873c11.4565 8.8158 27.5125 8.8158 38.969 0L32 37.9028z"
      />
      <path
        fill="#6da544"
        d="M26.0971 32 6.6127 12.5155c-8.8157 11.4565-8.8157 27.5125 0 38.969zm11.8059 0 19.4842 19.4845c8.8158-11.4565 8.8158-27.5125 0-38.969z"
      />
      <path
        fill="#fff"
        d="M32 45.913c7.6839 0 13.913-6.229 13.913-13.913S39.6839 18.087 32 18.087 18.087 24.3161 18.087 32 24.316 45.913 32 45.913"
      />
      <path
        fill="#d80027"
        d="m32 22.2609 1.2049 2.087h2.4099l-1.205 2.0868 1.205 2.087h-2.4099L32 30.6087l-1.2049-2.087h-2.4097l1.2049-2.087-1.2049-2.0868h2.4097zM25.8756 32l1.2049 2.087h2.4097l-1.2048 2.0869 1.2048 2.087h-2.4097l-1.2049 2.087-1.205-2.087h-2.4097l1.2048-2.087-1.2048-2.0869h2.4097zm12.2489 0 1.2049 2.087h2.4097l-1.2048 2.0869 1.2048 2.087h-2.4097l-1.2049 2.087-1.205-2.087h-2.4097l1.2048-2.087-1.2048-2.0869h2.4097z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bi',
  64
);

export const BmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 15.3043v10.7929L20.8696 15.3043zM16.6956 31.9999h9.4014l-9.4014-12.5218-1.3912 9.7392z"
      />
      <path fill="#fff" d="M31.9144 32.0001H32v-.0857q-.0427.043-.0856.0857" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1658 7.0107-12.0155 12.0155v17.2019h8.3478V12.5217h20.8696V4.1738z"
      />
      <path
        fill="#d80027"
        d="M33.2721 29.3367 20.6306 16.6956h-3.935v.0002l16.5761 16.5761h.0003c.0001.0002.0001-2.7132.0001-3.9352"
      />
      <path
        fill="#f3f3f3"
        d="M36.1739 16.6957v15.3042c0 7.455 19.4782 7.455 19.4782 0V16.6957z"
      />
      <path
        fill="#6da544"
        d="M36.1739 32c0 7.455 9.7391 9.7392 9.7391 9.7392S55.6521 39.455 55.6521 32z"
      />
      <path
        fill="#a2001d"
        d="m45.913 25.8783-4.5217 1.9479V32l4.5217 2.7827L50.4347 32v-4.1738z"
      />
      <path fill="#338af3" d="M41.3913 23.6521h9.0434v4.1739h-9.0434z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bm',
  64
);

export const BnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32.0003 63.9955c17.6705 0 31.9953-14.3248 31.9953-31.9953S49.6708.0049 32.0003.0049.005 14.3297.005 32.0002s14.3248 31.9953 31.9953 31.9953"
      />
      <path
        fill="#000"
        d="M4.2913 16.0023c-1.4441 2.5011-2.5094 5.1159-3.2188 7.7793L54.581 54.6749c1.9519-1.9462 3.684-4.1763 5.1277-6.6773z"
      />
      <path
        fill="#ffda44"
        d="M47.9978 4.2912C35.1955-3.1 19.4102-.6366 9.4191 9.3251l53.5084 30.893c3.6317-13.633-2.1277-28.5355-14.9297-35.9269M16.0025 59.7088C28.8045 67.1 44.5902 64.6366 54.581 54.675L1.0725 23.7816c-3.6314 13.6334 2.1277 28.5359 14.93 35.9272"
      />
      <path
        fill="#d80027"
        d="M41.0422 28.5222c0 4.9937-4.0483 9.0422-9.0422 9.0422s-9.0421-4.0484-9.0421-9.0422c0-1.5571.3936-3.0222 1.0869-4.3014-1.9622 2.0067-3.1736 4.7508-3.1736 7.7791 0 6.1462 4.9825 11.1288 11.1288 11.1288s11.1289-4.9825 11.1289-11.1288c0-3.0283-1.2113-5.7724-3.1736-7.7791.6933 1.2794 1.0869 2.7443 1.0869 4.3014"
      />
      <path fill="#d80027" d="M29.9136 18.0891h4.1734v20.8666h-4.1734z" />
      <path
        fill="#d80027"
        d="M38.9556 22.2623h-13.911c0 .9604.8367 1.7389 1.797 1.7389h-.058c0 .9604.7786 1.739 1.7389 1.739 0 .9604.7786 1.7389 1.7389 1.7389h3.4777c.9604 0 1.7389-.7785 1.7389-1.7389.9604 0 1.7389-.7786 1.7389-1.739h-.0579c.9601-.0001 1.7966-.7784 1.7966-1.7389m-16.693 18.0844H41.738V44.52H22.2626z"
      />
      <path
        fill="#d80027"
        d="M36.1735 41.7379h8.3466v4.1734h-8.3466zm-16.6931 0h8.3466v4.1734h-8.3466z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bn',
  64
);

export const BoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M64 32c0-3.9142-.704-7.6639-1.9904-11.1304L32 19.4783 1.9904 20.8695C.704 24.3361 0 28.0858 0 32c0 3.9143.704 7.6639 1.9904 11.1304L32 44.5218l30.0096-1.3913C63.296 39.6639 64 35.9143 64 32"
      />
      <path
        fill="#6da544"
        d="M32 64c13.7589 0 25.4883-8.684 30.0096-20.8696H1.9904C6.5118 55.316 18.241 64 32 64"
      />
      <path
        fill="#d80027"
        d="M1.9904 20.8696h60.0194C57.4883 8.684 45.7589 0 32 0S6.5118 8.684 1.9904 20.8696"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bo',
  64
);

export const BqIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M9.3725 9.3725C2.5144 16.2306-.579 25.4274.09 34.3956L34.3955.0903c-8.9683-.6693-18.1649 2.424-25.023 9.2822"
      />
      <path
        fill="#0052b4"
        d="M11.4263 56.5089c12.5726 10.5777 31.3675 9.9521 43.2012-1.8815s12.4594-30.6286 1.8815-43.2011z"
      />
      <path
        fill="#000"
        d="m31.8859 30.7111 2.7576-1.4938-2.7576-1.4937c-.6439-4.1826-3.9487-7.4875-8.1313-8.1313l-1.4939-2.7577-1.4937 2.7576c-4.1825.6438-7.4873 3.9486-8.1313 8.1313L9.878 29.2173l2.7576 1.4938c.6439 4.1826 3.9486 7.4875 8.1313 8.1312l1.4938 2.7578 1.4938-2.7576c4.1827-.6439 7.4875-3.9488 8.1314-8.1314m-9.625 4.0715c-3.0737 0-5.5653-2.4915-5.5653-5.5653s2.4915-5.5652 5.5653-5.5652 5.5652 2.4915 5.5652 5.5652-2.4916 5.5653-5.5652 5.5653"
      />
      <path
        fill="#d80027"
        d="m22.2609 25.0435 1.2048 2.0868h2.4099l-1.205 2.087 1.205 2.087h-2.4099l-1.2048 2.0869-1.2049-2.0869h-2.4098l1.2049-2.087-1.2049-2.087h2.4098z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bq',
  64
);

export const BrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#6da544"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#ffda44" d="M32 12.5217 58.4347 32 32 51.4782 5.5653 32z" />
      <path
        fill="#fff"
        d="M32 43.1304c6.1471 0 11.1304-4.9833 11.1304-11.1304S38.1471 20.8696 32 20.8696 20.8696 25.8529 20.8696 32 25.8529 43.1304 32 43.1304"
      />
      <path
        fill="#0052b4"
        d="M26.4347 31.3043c-1.9355 0-3.8033.2944-5.5616.8406.0779 6.08 5.0284 10.9855 11.1269 10.9855 3.771 0 7.1015-1.8771 9.1149-4.746-3.4447-4.3121-8.7448-7.0801-14.6802-7.0801m16.4894 2.8282c.134-.6905.2064-1.4029.2064-2.1325 0-6.1472-4.9833-11.1304-11.1304-11.1304-4.5867 0-8.5242 2.7752-10.2282 6.7374a22.96 22.96 0 0 1 4.6631-.4765c6.4646-.0001 12.3129 2.6871 16.4891 7.002"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Br',
  64
);

export const BsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#338af3"
        d="M19.4783 20.8696h42.5312C57.4883 8.684 45.7588 0 32 0 23.1633 0 15.1641 3.5824 9.3736 9.3736zm0 22.2608h42.5312C57.4883 55.316 45.7588 64 32 64c-8.8367 0-16.8359-3.5824-22.6264-9.3736z"
      />
      <path
        fill="#000"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bs',
  64
);

export const BtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M54.6274 54.6275c-12.4968 12.4967-32.758 12.4967-45.2549 0-12.4967-12.4968-12.4967-32.7581 0-45.255.0045 0 28.7572-8.4959 41.2541 4.0009s4.0094 41.2453 4.0008 41.2541"
      />
      <path
        fill="#d80027"
        d="M54.6274 54.6275c12.4967-12.4968 12.4967-32.7581 0-45.255s-32.758-12.4968-45.2549 0z"
      />
      <path
        fill="#ff9811"
        d="M40.3645 40.3676c-1.3145.5163-2.8419.4615-4.167-.2821-2.3412-1.314-3.177-4.2882-1.8626-6.6299l-.399-.2237c4.0089-.9666 6.9747-4.6054 6.9227-8.8994-.0322-2.6696-1.2251-5.058-3.091-6.6922l-2.9216 2.9932c1.1045.8803 1.8206 2.2305 1.839 3.7496.0325 2.685-2.1252 4.8959-4.8101 4.9283l.0056.4571c-2.8416-2.9882-7.4756-3.7374-11.1682-1.5454-2.2958 1.363-3.7675 3.59-4.2502 6.0232l4.053 1.0337c.2102-1.3967 1.0213-2.692 2.3277-3.4676 2.3088-1.3706 5.3023-.6071 6.673 1.7016l.3935-.2334c-1.1673 3.9548.5008 8.3427 4.2457 10.4447 2.3282 1.3067 4.9928 1.4678 7.3413.6692zm-8.456-8.2742-.0002.0001z"
      />
      <path
        fill="#ffeacf"
        d="m43.8483 21.6726-2.2618 8.0713-6.7862-1.2531-4.3683-9.0043-11.8009 4.1876-.9306-2.6225-3.0875-.3804 2.3264 6.5561 8.1211-2.077 2.3079 6.5036-5.614 8.2852 9.5271 8.1257-1.8059 2.1171 1.2144 2.8644 4.5148-5.293-5.8593-5.9946 4.4784-5.2504 9.9822.7193 2.2737-12.3138 2.7363.5054 1.8737-2.4838zM31.9976 32.2177v.0002z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bt',
  64
);

export const BwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M1.5111 22.2608C.531 25.3319 0 28.6035.0001 31.9999 0 35.396.531 38.6678 1.5113 41.739L32 43.1305l30.4888-1.3915C63.469 38.6678 64 35.3959 64 32c0-3.3962-.5309-6.6681-1.5111-9.7392L32 20.8695z"
      />
      <path
        fill="#000"
        d="M64 31.9999c0-1.8983-.1663-3.7578-.4834-5.5653H.4835A32.17 32.17 0 0 0 0 31.9998c0 1.8985.1664 3.7578.4835 5.5653h63.0331A32.2 32.2 0 0 0 64 31.9999"
      />
      <path
        fill="#338af3"
        d="M32.0001 63.9999c14.277 0 26.3683-9.3504 30.4888-22.261H1.5112c4.1207 12.9105 16.212 22.2607 30.4889 22.261m0-63.9998c-14.2769 0-26.3681 9.3504-30.489 22.2606l60.9775.0002C58.3682 9.3505 46.2769-.0001 32.0001.0001"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bw',
  64
);

export const ByIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fcfcfc"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="m13.2174 29.6811-3.4783-6.3104 3.4783-6.2113 3.4782 6.2113zm-6.9565 0-3.4783-6.3104 3.4783-6.2113 3.4782 6.2113zm6.9565 17.1595-3.4783-6.3104 3.4783-6.2114 3.4782 6.2114zm-6.9565 0-3.4783-6.3104 3.4783-6.2114 3.4782 6.2114zM16.6956 6.2115l-.9847-1.7585a32.1 32.1 0 0 0-4.9493 3.6136l2.4558 4.4552zm-3.4782 45.2668-2.4818 4.432a32.1 32.1 0 0 0 4.946 3.6193l1.0142-1.8398z"
      />
      <path
        fill="#6da544"
        d="M19.4783 40.3479v21.1079C23.3244 63.0929 27.556 64 32 64c13.7589 0 25.4883-8.684 30.0096-20.8696z"
      />
      <path
        fill="#a2001d"
        d="M62.0096 43.1304C63.296 39.6637 64 35.9142 64 32 64 14.327 49.673 0 32 0c-4.4436 0-8.6756.9066-12.5217 2.5435v40.587z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'By',
  64
);

export const BzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0-10.9827-5.5336-20.6718-13.9641-26.4348L32 4.1738 13.9641 5.5651C5.5338 11.3282 0 21.0175 0 32c0 10.9828 5.5338 20.6717 13.9641 26.4347L32 59.8261l18.0359-1.3913C58.4664 52.6717 64 42.9828 64 32"
      />
      <path
        fill="#a2001d"
        d="M50.0359 5.5653C44.9002 2.0544 38.6905 0 32 0c-6.6904 0-12.9003 2.0545-18.0359 5.5653zM13.9641 58.4347C19.0996 61.9454 25.3096 63.9999 32 63.9999s12.9002-2.0545 18.0359-5.5652z"
      />
      <path
        fill="#fff"
        d="M32 47.3044c8.4524 0 15.3044-6.852 15.3044-15.3043 0-8.4524-6.852-15.3044-15.3044-15.3044s-15.3044 6.852-15.3044 15.3044S23.5476 47.3044 32 47.3044"
      />
      <path
        fill="#6da544"
        d="M32 44.5218c6.9156 0 12.5218-5.6062 12.5218-12.5218S38.9156 19.4783 32 19.4783 19.4783 25.0844 19.4783 32 25.0844 44.5218 32 44.5218"
      />
      <path
        fill="#fff"
        d="M32 40.3478c4.6104 0 8.3478-3.7374 8.3478-8.3478S36.6104 23.6521 32 23.6521 23.6521 27.3896 23.6521 32 27.3896 40.3478 32 40.3478"
      />
      <path
        fill="#0052b4"
        d="M32 29.913 27.4783 32v3.4782L32 38.2608l4.5218-2.7826V32z"
      />
      <path fill="#ffda44" d="M27.4783 27.8262h9.0435V32h-9.0435z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Bz',
  64
);

export const CaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M64 32c0-12.6868-7.3831-23.6488-18.087-28.8248v57.6494C56.6169 55.6487 64 44.6867 64 32M0 32c0 12.6867 7.3831 23.6487 18.087 28.8247V3.1752C7.3831 8.3512 0 19.3132 0 32m37.5653 4.1739 5.5651-2.7827L40.3479 32v-2.7826L34.7826 32l2.7827-5.5653h-2.7827L32 22.2609l-2.7826 4.1738h-2.7826L29.2174 32l-5.5653-2.7826V32l-2.7825 1.3912 5.5652 2.7827-1.3913 2.7826h5.5653v4.1739h2.7825v-4.1739h5.5652z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ca',
  64
);

export const CcIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#6da544"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="m49.123 45.913.8781 1.8361 1.983-.4583-.888 1.8314 1.5946 1.2645-1.9855.4475.0057 2.0354-1.5879-1.2734-1.5878 1.2734.0055-2.0354-1.9853-.4475 1.5946-1.2645-.888-1.8314 1.9829.4583zm-8.169-19.4782.8782 1.8361 1.983-.4583-.8881 1.8315 1.5946 1.2645-1.9853.4475.0055 2.0352-1.5879-1.2732-1.5878 1.2732.0054-2.0352-1.9852-.4475 1.5946-1.2645-.8881-1.8315 1.9831.4583zm8.169-11.1304.8781 1.8362 1.983-.4585-.8879 1.8315 1.5945 1.2646-1.9855.4474.0054 2.0353-1.5876-1.2733-1.5878 1.2733.0055-2.0353-1.9852-.4474 1.5945-1.2646-.888-1.8315 1.9829.4585zm7.1354 8.3477.8781 1.8361 1.9831-.4583-.8881 1.8315 1.5946 1.2645-1.9854.4475.0055 2.0353-1.5878-1.2733-1.5878 1.2733.0054-2.0353-1.9853-.4475 1.5947-1.2645-.8882-1.8315 1.983.4583zm-5.1022 9.7391.6908 2.1259h2.2352l-1.8084 1.3138.6909 2.1256-1.8085-1.3136-1.8082 1.3136.6907-2.1256-1.8083-1.3138h2.2351z"
      />
      <path
        fill="#ffda44"
        d="M35.4783 41.0435c-4.9947 0-9.0437-4.049-9.0437-9.0435s4.0489-9.0435 9.0437-9.0435c1.5572 0 3.0226.3939 4.3018 1.087-2.0068-1.9627-4.7512-3.174-7.7803-3.174-6.147 0-11.1303 4.9833-11.1303 11.1304s4.9833 11.1304 11.1303 11.1304c3.029 0 5.7735-1.2113 7.7802-3.174-1.2791.6933-2.7445 1.0872-4.3017 1.0872m-15.355-28.5217c-.9625-1.663-2.7594-2.7827-4.8189-2.7827s-3.8564 1.1197-4.8189 2.7827zm.0185.032-4.8374 4.8374-4.8374-4.8374a5.54 5.54 0 0 0-.7277 2.7505c0 3.0737 2.4916 5.5653 5.5652 5.5653s5.5653-2.4915 5.5653-5.5653a5.54 5.54 0 0 0-.728-2.7505"
      />
      <path
        fill="#a2001d"
        d="M13.913 16v4.6943a5.58 5.58 0 0 0 1.3913.1752c.4803 0 .9466-.061 1.3912-.1752V16z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cc',
  64
);

export const CdIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M60.4467 17.327c-1.4786-2.8649-3.4167-5.5539-5.8182-7.9554-2.4016-2.4016-5.0908-4.3398-7.9555-5.8183L24.1294 24.1291 3.5535 46.6727c1.4786 2.8649 3.4168 5.554 5.8183 7.9555s5.0906 4.3396 7.9553 5.8183l22.5436-20.5759z"
      />
      <path
        fill="#d80027"
        d="M9.3717 54.6283a32.2 32.2 0 0 0 4.2772 3.5938l44.573-44.5733a32.2 32.2 0 0 0-3.5935-4.2771 32.2 32.2 0 0 0-4.2772-3.5935l-44.573 44.573a32.2 32.2 0 0 0 3.5935 4.2771"
      />
      <path
        fill="#338af3"
        d="M9.3716 9.3716C-.7242 19.4675-2.6624 34.6297 3.5534 46.673L46.6729 3.5535C34.6296-2.6621 19.4674-.7238 9.3716 9.3716m45.2568 45.2569c10.0957-10.0957 12.0337-25.258 5.8183-37.3011L17.3272 60.4468c12.0432 6.2156 27.2055 4.2776 37.3012-5.8183"
      />
      <path
        fill="#ffda44"
        d="m17.0533 9.738 1.7267 5.3147h5.588l-4.5207 3.2845 1.7267 5.3145-4.5207-3.2847-4.521 3.2847 1.727-5.3145-4.521-3.2845h5.588z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cd',
  64
);

export const CfIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M60.1091 16.6956C55.9741 9.117 48.8637 3.3958 40.3479 1.1006l-1.3913 15.595zm-56.2182 0h21.1525l-1.3913-15.595C15.1362 3.3958 8.026 9.117 3.8909 16.6956"
      />
      <path
        fill="#6da544"
        d="M38.9565 32v15.3044H60.109C62.5896 42.758 64 37.5437 64 32zm-13.913 0H0c0 5.5437 1.4104 10.758 3.8909 15.3044h21.1525V32z"
      />
      <path
        fill="#ffda44"
        d="M3.8909 47.3043c4.135 7.5786 11.2453 13.2998 19.7612 15.595l1.3913-13.6386zm36.457 15.595c8.5158-2.2952 15.6262-8.0164 19.7612-15.595l-21.1525 1.9561zm-1.3914-13.6389 21.1526-1.9561H38.9565zm-13.913-1.9561H3.8909l21.1526 1.9561z"
      />
      <path
        fill="#d80027"
        d="M32 0c-2.8884 0-5.6861.385-8.3479 1.1024v61.7954C26.3139 63.615 29.1116 64 32 64s5.6861-.385 8.3479-1.1024V1.1024C37.6861.385 34.8884 0 32 0"
      />
      <path
        fill="#ffda44"
        d="m17.2122 6.9565.8633 2.6572h2.7941l-2.2602 1.6422.8633 2.6571-2.2605-1.6421-2.2603 1.6421.8636-2.6571-2.2603-1.6422h2.7939z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cf',
  64
);

export const ChIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="M48.6956 26.4349H37.5653V15.3044H26.4348v11.1305H15.3044v11.1304h11.1304v11.1303h11.1305V37.5653h11.1303z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ch',
  64
);

export const CiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c3.9142 0 7.6639-.704 11.1304-1.9904L44.5217 32 43.1305 1.9904C39.6639.704 35.9142 0 32 0c-3.9143 0-7.6639.7041-11.1304 1.9904L19.4782 32l1.3913 30.0096C24.3361 63.296 28.0857 64 32 64"
      />
      <path
        fill="#ff9811"
        d="M0 32.0001C0 45.759 8.684 57.4884 20.8696 62.0097V1.9905C8.684 6.5119 0 18.2412 0 32"
      />
      <path
        fill="#6da544"
        d="M43.1304 1.9905v60.0194C55.316 57.4884 64 45.759 64 32.0001S55.316 6.5118 43.1304 1.9905"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ci',
  64
);

export const CkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 32.0001H32v-.0857q-.0427.043-.0856.0857" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1658 7.0107-12.0155 12.0155V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32 28.0648 20.6306 16.6957h-3.935v.0002l15.3042 15.304H32z"
      />
      <path
        fill="#fff"
        d="m43.1304 32 .5922 1.822h1.9156l-1.5497 1.126.592 1.8221-1.5501-1.1261-1.5499 1.1261.592-1.8221-1.5498-1.126h1.9157zm-7.8703 3.2601 1.7069.8697 1.3547-1.3547-.2997 1.8923 1.707.8697-1.8923.2995-.2996 1.8925-.8699-1.7071-1.8921.2998 1.3549-1.3547zM32 43.1304l1.822-.592.0003-1.9155 1.1257 1.5497 1.8221-.5922-1.1261 1.55 1.1261 1.5501-1.8221-.5919-1.1257 1.5497v-1.9156zm3.2601 7.8703.8696-1.707-1.3546-1.3545 1.8923.2997.8697-1.707.2996 1.8922 1.8923.2995-1.707.8699.2997 1.8924-1.3547-1.355zm7.8703 3.2601-.592-1.8221h-1.9158l1.5499-1.126-.592-1.822 1.5499 1.126 1.5501-1.126-.592 1.822 1.5497 1.126h-1.9156zm7.8703-3.2601-1.707-.8695-1.3545 1.3547.2997-1.8924-1.707-.8696 1.8922-.2998.2998-1.8922.8696 1.707 1.8922-.2997-1.3548 1.3547zm3.2602-7.8703-1.8221.5923v1.9156l-1.126-1.5499-1.822.5921 1.1261-1.5501-1.1261-1.55 1.822.5922 1.126-1.5497v1.9155zm-3.2602-7.8701-.8695 1.7068 1.3545 1.3547-1.8922-.2998-.8696 1.7071-.2998-1.8925-1.8922-.2996 1.707-.8696-.2997-1.8921 1.3547 1.3545z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ck',
  64
);

export const ClIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M64 32.0001c0 17.673-14.327 32-32 32s-32-14.327-32-32 32 0 32 0z"
      />
      <path fill="#0052b4" d="M0 32C0 14.327 14.327 0 32 0v32z" />
      <path
        fill="#fff"
        d="m19.0486 11.1304 2.0721 6.3772h6.7054l-5.4247 3.9413 2.072 6.3772-5.4248-3.9414-5.4247 3.9414 2.072-6.3772-5.4248-3.9413h6.7054z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cl',
  64
);

export const CmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M45.913 3.1753C41.706 1.141 36.9863 0 32 0s-9.706 1.141-13.913 3.1753L15.3044 32l2.7826 28.8247C22.294 62.859 27.0138 64 32 64s9.706-1.141 13.913-3.1753L48.6956 32z"
      />
      <path
        fill="#ffda44"
        d="m31.9998 20.8696 2.7625 8.5024h8.941l-7.233 5.2555 2.7626 8.5029-7.2331-5.2551-7.2332 5.2551 2.7632-8.5029-7.233-5.2555h8.9403z"
      />
      <path
        fill="#496e2d"
        d="M18.087 3.1764C7.3833 8.352 0 19.3133 0 32c0 12.6868 7.3833 23.6479 18.087 28.8236z"
      />
      <path
        fill="#ffda44"
        d="M45.913 3.1764v57.6472C56.6168 55.6479 64 44.6866 64 32S56.6168 8.3521 45.913 3.1764"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cm',
  64
);

export const CnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="m17.5125 19.4751 2.7625 8.5h8.9375l-7.225 5.2625 2.7625 8.5-7.2375-5.25-7.2375 5.25 2.775-8.5-7.2375-5.2625H14.75zm20.425 30.0874-2.1125-2.5999-3.125 1.2125 1.8125-2.8126L32.4 42.75l3.2375.8625 1.825-2.8125.175 3.3501 3.25.8625-3.1375 1.2zm4.2-7.625 1-3.2L40.4 36.8l3.35-.05.9875-3.2 1.0875 3.175 3.35-.0375-2.6875 2 1.075 3.175-2.7375-1.9375zm5.6625-18.45L46.325 26.5l2.4 2.3375-3.3125-.475-1.475 3-.575-3.3-3.325-.475 2.975-1.5625-.575-3.3125 2.4 2.3375zm-9.775-9.125-.25 3.3376 3.1125 1.2625-3.2625.8-.2375 3.3499-1.7625-2.8499-3.2625.7999L34.525 18.5l-1.775-2.8375 3.1125 1.2625z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cn',
  64
);

export const CoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32l-32 2.7826z"
      />
      <path
        fill="#d80027"
        d="M4.282 48C9.8151 57.5645 20.1556 64 32 64s22.1849-6.4355 27.718-16L32 45.913z"
      />
      <path
        fill="#0052b4"
        d="M59.718 48C62.4408 43.2933 64 37.8289 64 32H0c0 5.8289 1.5593 11.2933 4.282 16z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Co',
  64
);

export const CrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M62.0096 20.8696H1.9904C.704 24.3363 0 28.0858 0 32s.7041 7.6638 1.9904 11.1304h60.0194C63.296 39.6638 64 35.9143 64 32s-.704-7.6637-1.9904-11.1304"
      />
      <path
        fill="#0052b4"
        d="M32 0C22.3011 0 13.6107 4.3155 7.7424 11.1304h48.5151C50.3892 4.3155 41.6989 0 32 0m24.2576 52.8696H7.7424C13.6107 59.6845 22.301 64 32 64s18.3892-4.3155 24.2576-11.1304"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cr',
  64
);

export const CuIcon = createSvgIcon(
  [
    <g key="0">
      <path fill="#ff9811" d="M.0001 5.5653H0v52.8695h.0001z" />
      <path
        fill="#fff"
        d="M31.9999 63.9999c17.673 0 31.9998-14.3269 31.9998-31.9999S49.6729.0001 31.9999.0001 0 14.327 0 32s14.3268 31.9999 31.9999 31.9999"
      />
      <path
        fill="#0052b4"
        d="M32.0001.0002c-10.469 0-19.7632 5.028-25.6014 12.8h51.2027C51.7634 5.028 42.469.0002 32.0001.0002m0 63.9996c10.469 0 19.7633-5.0278 25.6014-12.8H6.3987c5.838 7.7723 15.1324 12.8 25.6014 12.8m-32-31.9997c0 2.1919.221 4.3321.6409 6.4h62.7184a32.14 32.14 0 0 0 .6407-6.4c0-2.1919-.221-4.3321-.6407-6.4H.641a32.14 32.14 0 0 0-.6409 6.4"
      />
      <path
        fill="#d80027"
        d="M9.3727 9.3728c-12.4967 12.4966-12.4967 32.758 0 45.2549C14.5368 49.4636 19.5033 44.4969 32 32.0003z"
      />
      <path
        fill="#fff"
        d="m12.9514 23.6523 2.0717 6.3769h6.7058l-5.4246 3.9415 2.0717 6.377-5.4246-3.9412-5.4249 3.9412 2.0723-6.377-5.4248-3.9415h6.7053z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cu',
  64
);

export const CvIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 64c9.6989 0 18.3892-4.3155 24.2576-11.1304H7.7424C13.6107 59.6845 22.301 64 32 64m32-32C64 14.327 49.673 0 32 0S0 14.327 0 32c0 2.8884.385 5.6861 1.1024 8.3479h61.7954C63.615 37.6861 64 34.8884 64 32"
      />
      <path
        fill="#d80027"
        d="M2.5435 44.5217a31.9 31.9 0 0 0 2.1534 4.1739h54.6065a31.96 31.96 0 0 0 2.1534-4.1739z"
      />
      <path
        fill="#ffda44"
        d="m22.8738 34.087.518 1.5943h1.6763l-1.3561.9854.518 1.5942-1.3562-.9854-1.3563.9854.5181-1.5942-1.3561-.9854h1.6764zm0 20.8695.518 1.5944h1.6763l-1.3561.9853.518 1.5942-1.3562-.9852-1.3563.9852.5181-1.5942-1.3561-.9853h1.6764zm-9.7146-7.0578.518 1.5941h1.6764l-1.3561.9853.518 1.5945-1.3563-.9854-1.3562.9854.5182-1.5945-1.3562-.9853h1.6762zm3.7107-11.7247.518 1.5943h1.6762l-1.356.9853.518 1.5943-1.3562-.9853-1.3563.9853.5183-1.5943-1.3564-.9853h1.6764zm-5.9049 6.5654 1.676.0001.5181-1.5946.5181 1.5945 1.6764-.0001-1.3562.9853.5181 1.5944-1.3564-.9854-1.3561.985.518-1.5941zm4.5487 13.9995.518-1.594-1.3563-.9852h1.6763l.5182-1.5944.5181 1.5943h1.6762l-1.3562.9852.518 1.5945-1.3563-.9855zm17.0709-8.8402-.5179 1.5941h-1.6763l1.356.9853-.518 1.5945 1.3562-.9854 1.3563.9854-.5182-1.5945 1.3563-.9853h-1.6764zM28.874 36.174l-.5179 1.5943h-1.6764l1.356.9853-.518 1.5943 1.3563-.9853 1.3562.9853-.5181-1.5943 1.3563-.9853H29.392zm5.905 6.5654-1.6761.0001-.5182-1.5946-.518 1.5945-1.6763-.0001 1.3561.9853-.5181 1.5944 1.3563-.9854 1.3562.985-.518-1.5941zm-4.5489 13.9995-.5178-1.594 1.3562-.9852h-1.6764l-.5181-1.5944-.518 1.5943h-1.6764l1.3563.9852-.518 1.5945 1.3562-.9855z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cv',
  64
);

export const CwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 64c10.5 0 19.8186-5.0573 25.6536-12.8687H6.3464C12.1814 58.9427 21.5 64 32 64m32-32C64 14.327 49.673 0 32 0S0 14.327 0 32c0 3.7841.6586 7.414 1.8645 10.7836h60.2709C63.3414 39.414 64 35.7841 64 32"
      />
      <path
        fill="#fff"
        d="m21.9028 20.5228 1.7266 5.314h5.588l-4.5206 3.2848 1.7266 5.3142-4.5206-3.2845-4.5207 3.2845 1.7269-5.3142-4.5206-3.2848h5.5877zm-9.596-5.5653 1.036 3.1885h3.3528l-2.7123 1.9708 1.036 3.1886-2.7125-1.9708-2.7124 1.9708 1.0361-3.1886-2.7122-1.9708h3.3527z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cw',
  64
);

export const CyIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fcfcfc"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#6da544"
        d="M50.087 27.8262h-4.1739c0 7.684-6.2292 13.913-13.913 13.913-7.6841 0-13.913-6.229-13.913-13.913h-4.1738c0 8.2768 5.5595 15.2552 13.1482 17.4043-.832 1.5805-.7052 3.5704.4833 5.0535 1.561-1.2511 3.1771-2.5462 4.5481-3.6447 1.371 1.0986 2.9872 2.3937 4.5481 3.6447 1.2003-1.4978 1.3184-3.513.4588-5.1011 7.5056-2.2019 12.9872-9.1387 12.9872-17.3567"
      />
      <path
        fill="#ffda44"
        d="M20.8696 26.4348s0 6.9565 6.9565 6.9565l1.3913 1.3913H32s1.3913-4.1739 4.1739-4.1739c0 0 0-2.7826 2.7826-2.7826h4.1739s-1.3913-5.5653 5.5652-9.7392l-2.7826-1.3912s-9.7391 6.9565-16.6956 5.5652v2.7827h-2.7826l-1.3913-1.3913z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cy',
  64
);

export const CzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M29.2174 32S9.3912 54.6319 9.3725 54.6274C15.1632 60.4183 23.1634 64 32 64c17.673 0 32-14.327 32-32z"
      />
      <path
        fill="#0052b4"
        d="M9.3725 9.3725c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Cz',
  64
);

export const DeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M1.9904 43.1313C6.5117 55.3168 18.241 64.001 32 64.001s25.4882-8.6842 30.0096-20.8697L32 40.3488z"
      />
      <path
        fill="#000"
        d="M32 .001C18.2411.001 6.5117 8.685 1.9904 20.8706L32 23.6531l30.0096-2.7826C57.4882 8.685 45.7589.001 32 .001"
      />
      <path
        fill="#d80027"
        d="M1.9904 20.8706C.704 24.3372 0 28.0867 0 32.001s.7041 7.6637 1.9904 11.1304h60.0194C63.296 39.6647 64 35.9152 64 32.001s-.704-7.6638-1.9904-11.1304z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'De',
  64
);

export const DjIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M29.2174 34.7826S9.3912 9.3681 9.3725 9.3726C15.1632 3.5817 23.1634 0 32 0c17.673 0 32 14.327 32 32z"
      />
      <path
        fill="#6da544"
        d="M29.2174 32S9.3912 54.6319 9.3725 54.6274C15.1632 60.4183 23.1634 64 32 64c17.673 0 32-14.327 32-32z"
      />
      <path
        fill="#fff"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#d80027"
        d="m12.9513 23.6521 2.0718 6.377h6.7058l-5.4248 3.9415 2.0718 6.3772-5.4246-3.9413-5.425 3.9413 2.0723-6.3772-5.4247-3.9415h6.7052z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Dj',
  64
);

export const DkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M25.0436 27.8261h38.6855C61.6838 12.1252 48.2584 0 32 0c-2.3894 0-4.7165.2641-6.9565.7606zm-8.348-.0001V3.8909C7.909 8.685 1.6188 17.479.2709 27.826zm-.0001 8.3479H.2709C1.6188 46.521 7.909 55.3149 16.6956 60.109zm8.348.0001v27.0654C27.2835 63.7359 29.6106 64 32 64c16.2584 0 29.6838-12.1252 31.7291-27.8261z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Dk',
  64
);

export const DmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#496e2d"
        d="M38.2609 63.386c12.6504-2.5095 22.6155-12.4748 25.125-25.125h-25.125zM.6141 38.261c2.5094 12.6502 12.4747 22.6155 25.125 25.125V38.261zm62.7718-12.5219C60.8764 13.0889 50.9113 3.1236 38.2609.6141v25.125zM25.7391.6141C13.0888 3.1236 3.1235 13.089.6141 25.7391h25.125z"
      />
      <path
        fill="#ffda44"
        d="M29.913 38.2607h-4.1739v25.125a32 32 0 0 0 4.1739.5445zm0-12.5216V.0696a32 32 0 0 0-4.1739.5445v25.125z"
      />
      <path
        fill="#000"
        d="M34.087.0696A32.3 32.3 0 0 0 32 0c-.7014 0-1.3968.025-2.087.0696v25.6697h4.1739V.0696zm-4.174 63.8609a32.3 32.3 0 0 0 2.087.0696c.7014 0 1.3967-.025 2.087-.0696V38.261h-4.1739z"
      />
      <path
        fill="#ffda44"
        d="M25.7391 29.9129V25.739H.6141a32 32 0 0 0-.5445 4.1739zm12.5218 0h25.6696a32 32 0 0 0-.5445-4.1739H38.261v4.1739z"
      />
      <path
        fill="#000"
        d="M38.2609 34.0871h25.6696A32.4 32.4 0 0 0 64 32.0001c0-.7014-.025-1.3969-.0696-2.087H38.2609zM.0696 29.9131A32.4 32.4 0 0 0 0 32.0001c0 .7014.0251 1.3969.0696 2.087h25.6697v-4.1739z"
      />
      <path
        fill="#d80027"
        d="M32 47.3043c8.4524 0 15.3044-6.852 15.3044-15.3044S40.4524 16.6956 32 16.6956s-15.3044 6.852-15.3044 15.3043c0 8.4524 6.852 15.3044 15.3044 15.3044"
      />
      <path
        fill="#496e2d"
        d="M35.4867 33.7075c-1.1383-2.2766-2.618-4.5841-2.618-4.5841s.0368-1.0506.0368-1.6766c0-.943-.7645-1.7075-1.7075-1.7075-.8934 0-1.6254.6863-1.7 1.5602-.7025.0459-1.2584.6286-1.2584 1.3426 0 .5192.2941.969.7246 1.1939a1.94 1.94 0 0 1 1.1513-1.0694c.0845.0692.1752.1309.2721.1833l.2188.1047s-.8112 2.2864-.8112 3.5147c0 3.453 2.2768 4.5178 2.2768 4.5178v.0357l-1.1384 1.1382h2.2766v-2.2767l1.1384 1.1383c.01-.0213 2.1563-1.3787 1.1381-3.4151M32 19.4783l.518 1.5942h1.6763l-1.3562.9854.5182 1.5942L32 22.6669l-1.3562.9852.5181-1.5942-1.3561-.9854h1.6762zm-7.36 2.3915 1.356.9853 1.3563-.9855-.518 1.5945 1.3562.9852-1.6764.0001-.518 1.5942-.5181-1.5942-1.6762-.0001 1.3561-.9854zm-4.5489 6.2608h1.6762l.5181-1.5942.518 1.5942 1.6763-.0001-1.3561.9855.5182 1.5943-1.3564-.9854-1.3561.9852.5178-1.5942zm0 7.7387 1.356-.9851-.518-1.5944 1.3563.9854 1.3562-.9854-.518 1.5942 1.3563.9854-1.6765.0001-.518 1.5942-.5181-1.5944zm4.5489 6.261.5179-1.594-1.3563-.9854h1.6764l.5181-1.5944.518 1.5943h1.6764l-1.3562.9855.518 1.5941-1.3563-.9854zM32 44.5218l-.518-1.594h-1.6762l1.3561-.9855-.5181-1.5943L32 41.3332l1.3561-.9853-.518 1.5944 1.3562.9854-1.6763.0001zm7.36-2.3915-1.356-.9853-1.3561.9855.5179-1.5942-1.3563-.9854 1.6764-.0001.5179-1.5943.5182 1.5944h1.6763l-1.3562.9854zm4.5489-6.2609h-1.6761l-.5182 1.5944-.518-1.5941h-1.6765l1.3563-.9855-.5181-1.5942 1.3563.9853 1.356-.9853-.5177 1.5943zm0-7.7387-1.356.9853.5179 1.5942-1.3562-.9852-1.3562.9855.518-1.5944-1.3563-.9852 1.6765-.0003.5179-1.594.5183 1.5941zM39.36 21.8699l-.5179 1.5941 1.3562.9854H38.522l-.518 1.5943-.5181-1.5942-1.6764.0001 1.3563-.9856-.518-1.594 1.3562.9851z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Dm',
  64
);

export const DoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M1.1024 40.3479C4.057 51.3108 12.6892 59.943 23.6522 62.8978V40.3479z"
      />
      <path
        fill="#0052b4"
        d="M23.6521 1.1024C12.6892 4.057 4.057 12.6893 1.1024 23.6522h22.5498z"
      />
      <path
        fill="#d80027"
        d="M62.8977 23.6522C59.943 12.6893 51.3108 4.057 40.3479 1.1024v22.5499z"
      />
      <path
        fill="#0052b4"
        d="M40.3479 62.8975c10.9629-2.9547 19.5951-11.5868 22.5499-22.5498H40.3479z"
      />
      <path
        fill="#496e2d"
        d="M40.3478 32c0 4.6105-3.7373 8.3478-8.3478 8.3478S23.6521 36.6105 23.6521 32 32 23.6521 32 23.6521 40.3478 27.3895 40.3478 32"
      />
      <path
        fill="#0052b4"
        d="M23.6521 32c0-4.6105 3.7375-8.3479 8.3479-8.3479 4.6105 0 8.3478 3.7374 8.3478 8.3479"
      />
      <path
        fill="#d80027"
        d="M27.3044 27.8262v5.2173c0 2.5934 2.1022 4.6957 4.6956 4.6957s4.6956-2.1023 4.6956-4.6957v-5.2173z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Do',
  64
);

export const DzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 0c17.673 0 32 14.327 32 32S49.673 64 32 64c0-1.3913-4.1739-32-4.1739-32z"
      />
      <path fill="#496e2d" d="M32 64C14.327 64 0 49.673 0 32S14.327 0 32 0" />
      <path
        fill="#d80027"
        d="m38.8754 25.8621-2.6255 3.6181-4.2522-1.379 2.6298 3.615-2.6253 3.6181 4.2505-1.3839 2.6298 3.6149-.0028-4.4701 4.2507-1.384-4.252-1.3788z"
      />
      <path
        fill="#d80027"
        d="M34.6546 41.0435c-4.9945 0-9.0435-4.049-9.0435-9.0435s4.049-9.0435 9.0435-9.0435c1.5573 0 3.0227.3938 4.3019 1.087-2.007-1.9626-4.7515-3.174-7.7801-3.174-6.1473 0-11.1304 4.9833-11.1304 11.1304s4.9833 11.1304 11.1304 11.1304c3.0287 0 5.7732-1.2114 7.7801-3.174-1.2792.6935-2.7446 1.0872-4.3019 1.0872"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Dz',
  64
);

export const EcIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32l-32 2.7826z"
      />
      <path
        fill="#d80027"
        d="M4.282 48.0001c5.5331 9.5645 15.8736 16 27.718 16s22.1849-6.4355 27.718-16L32 45.9131z"
      />
      <path
        fill="#0052b4"
        d="M59.718 48C62.4408 43.2933 64 37.8289 64 32H0c0 5.8289 1.5593 11.2933 4.282 16z"
      />
      <path
        fill="#ffda44"
        d="M32 43.1304c6.1471 0 11.1304-4.9833 11.1304-11.1304S38.1471 20.8696 32 20.8696 20.8696 25.8529 20.8696 32 25.8529 43.1304 32 43.1304"
      />
      <path
        fill="#338af3"
        d="M32 38.9565c-3.8359 0-6.9565-3.1207-6.9565-6.9565v-4.1739c0-3.8358 3.1208-6.9565 6.9565-6.9565s6.9565 3.1208 6.9565 6.9565V32c0 3.8359-3.1206 6.9565-6.9565 6.9565"
      />
      <path
        fill="#000"
        d="M43.1304 15.3044h-8.3479c0-1.5368-1.2459-2.7827-2.7826-2.7827s-2.7826 1.2459-2.7826 2.7827h-8.3479c0 1.5368 1.3386 2.7826 2.8752 2.7826h-.0926c0 1.5369 1.2458 2.7826 2.7826 2.7826 0 1.5369 1.2458 2.7826 2.7827 2.7826h5.5652c1.5369 0 2.7826-1.2457 2.7826-2.7826 1.5369 0 2.7827-1.2457 2.7827-2.7826h-.0927c1.5368 0 2.8753-1.2459 2.8753-2.7826"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ec',
  64
);

export const EeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#000"
        d="M0 32c0 3.9143.7041 7.6638 1.9904 11.1304L32 44.5218l30.0096-1.3913C63.296 39.6638 64 35.9143 64 32s-.704-7.6637-1.9904-11.1304L32 19.4783 1.9904 20.8695C.704 24.3363 0 28.0858 0 32"
      />
      <path
        fill="#0052b4"
        d="M32 0C18.2411 0 6.5118 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#fff"
        d="M62.0096 43.1304H1.9904C6.5118 55.3159 18.241 64 32 64s25.4882-8.6841 30.0096-20.8696"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ee',
  64
);

export const EgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0C18.2411 0 6.5117 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#000"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#ff9811"
        d="M43.1304 28.5216h-8.3479c0-1.5367-1.2459-2.7826-2.7826-2.7826s-2.7826 1.2459-2.7826 2.7826h-8.3479c0 1.5369 1.3386 2.7827 2.8754 2.7827h-.0928c0 1.5368 1.2458 2.7826 2.7826 2.7826 0 1.5369 1.2458 2.7826 2.7827 2.7826h5.5652c1.5369 0 2.7826-1.2457 2.7826-2.7826 1.5369 0 2.7827-1.2458 2.7827-2.7826h-.0927c1.5368 0 2.8753-1.2458 2.8753-2.7827"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Eg',
  64
);

export const ErIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M29.2174 29.2173S9.3912 54.6319 9.3725 54.6273C15.1632 60.4182 23.1634 63.9999 32 63.9999c17.673 0 32-14.327 32-32z"
      />
      <path
        fill="#6da544"
        d="M29.2174 32S9.3912 9.3681 9.3725 9.3726C15.1632 3.5817 23.1634 0 32 0c17.673 0 32 14.327 32 32z"
      />
      <path
        fill="#d80027"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255C9.3716 54.6327 64 32.0001 64 32.0001z"
      />
      <path
        fill="#ffda44"
        d="M16.6956 18.7827c-6.1374 0-11.1303 4.9931-11.1303 11.1304v4.1739c0 6.1373 4.9931 11.1303 11.1303 11.1303S27.826 40.2242 27.826 34.087v-4.1739c.0001-6.1373-4.993-11.1304-11.1304-11.1304m6.9565 15.3044c0 3.109-2.0502 5.7476-4.8696 6.6362v-4.5492l2.953-2.953-2.9514-2.9514-.0016-1.0504v-1.393h-4.1738v4.1738l-2.951 2.9509 2.951 2.9508v2.8217c-2.8193-.8887-4.8696-3.5273-4.8696-6.6363v-4.1739c0-3.8358 3.1208-6.9565 6.9565-6.9565s6.9565 3.1208 6.9565 6.9565z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Er',
  64
);

export const EsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M0 32c0 3.9143.7041 7.6638 1.9904 11.1304L32 45.913l30.0096-2.7826C63.2959 39.6638 64 35.9143 64 32s-.7041-7.6637-1.9904-11.1304L32 18.087 1.9904 20.8696C.704 24.3363 0 28.0858 0 32"
      />
      <path
        fill="#d80027"
        d="M62.0096 20.8696C57.4882 8.6841 45.7589 0 32 0S6.5117 8.6841 1.9904 20.8696zM1.9904 43.1304C6.5117 55.3159 18.241 64 32 64s25.4882-8.6841 30.0096-20.8696z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Es',
  64
);

export const EtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M0 31.9999c0 3.9145.7041 7.664 1.9905 11.1308L32 45.9129l30.0095-2.7824C63.296 39.6639 64 35.9143 64 31.9999c0-3.8606-.6839-7.5615-1.9367-10.9881L32 18.0869l-30.0632 2.925C.6838 24.4384 0 28.1393 0 31.9999"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#6da544"
        d="M32 0C18.2411 0 6.5117 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#0052b4"
        d="M32 47.3043c8.4524 0 15.3044-6.852 15.3044-15.3044S40.4524 16.6956 32 16.6956s-15.3044 6.852-15.3044 15.3043c0 8.4524 6.852 15.3044 15.3044 15.3044"
      />
      <path
        fill="#ffda44"
        d="m31.9968 20.1489 2.7627 8.5028h8.9546l-7.2472 5.2551 2.7845 8.528-7.2546-5.2801-7.2435 5.2704 2.7732-8.5183-7.2406-5.2551h8.9481z"
      />
      <path
        fill="#ffda44"
        d="m43.0155 34.1162-8.7645-2.848 5.4166-7.455-2.251-1.6357-5.4169 7.4555-5.4163-7.4554-2.2513 1.6355 5.4165 7.4556-8.7641 2.8474.8597 2.6466 8.7645-2.8476v9.2153h2.7825V33.915l8.7642 2.8477z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Et',
  64
);

export const EuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="m32.0001 12.5217 1.0362 3.1887h3.3525l-2.7124 1.9706 1.0361 3.1886-2.7124-1.9707-2.7125 1.9707 1.0362-3.1886-2.7124-1.9706h3.3526zm-13.7733 5.705 2.9875 1.522 2.3706-2.3705-.5246 3.3113 2.9873 1.5221-3.3113.5245-.5245 3.3115-1.5222-2.9874-3.3112.5247 2.3706-2.3707zM12.5219 32l3.1886-1.0362v-3.3526l1.9705 2.7125 3.1888-1.0361L18.8989 32l1.9709 2.7123-3.1888-1.036-1.9705 2.7124v-3.3526zm5.7049 13.7732 1.5221-2.9875-2.3705-2.3706 3.3114.5247 1.5218-2.9873.5247 3.3113 3.3112.5245-2.987 1.5222.5244 3.3112-2.3706-2.3706zm13.7733 5.705-1.0362-3.1886h-3.3525l2.7125-1.9706-1.0363-3.1884 2.7125 1.9705 2.7124-1.9705-1.0361 3.1884 2.7124 1.9706h-3.3527zm13.7733-5.705-2.9874-1.522-2.3707 2.3706.5246-3.3115-2.9871-1.522 3.3112-.5245.5245-3.3113 1.522 2.9873 3.3113-.5247-2.3707 2.3709zM51.4783 32l-3.1887 1.0361v3.3526l-1.9706-2.7125-3.1884 1.0361L45.1013 32l-1.9707-2.7124 3.1885 1.0361 1.9705-2.7125v3.3528zm-5.7049-13.7733-1.5221 2.9875 2.3706 2.3707-3.3115-.5248-1.5219 2.9874-.5245-3.3114-3.3112-.5246 2.9871-1.522-.5246-3.3111 2.3708 2.3705z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Eu',
  64
);

export const FiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="M25.0433 27.8261h38.6855C61.6834 12.1252 48.258 0 31.9997 0c-2.3894 0-4.7165.2641-6.9565.7606zm-8.348-.0001V3.8909C7.9086 8.685 1.6183 17.479.2705 27.826zm-.0002 8.3479H.2705C1.6184 46.521 7.9086 55.3149 16.6953 60.109zm8.3481.0001v27.0654c2.24.4965 4.5671.7606 6.9565.7606 16.2583 0 29.6837-12.1252 31.7291-27.8261z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Fi',
  64
);

export const FijiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 15.3044v10.7929L20.8696 15.3044zM16.6956 32h9.4015l-9.4015-12.5217-1.3912 9.7391z"
      />
      <path fill="#fff" d="M31.9144 31.9999H32v-.0856z" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.324.003 0 14.3286 0 32h16.6956v-9.4014L26.0971 32h5.8175l.0857-.0856v-5.8172l-9.4018-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1656 7.0107-12.0155 12.0155V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32 28.0649 20.6309 16.6958h-3.9352v.0003l15.304 15.304H32z"
      />
      <path
        fill="#f3f3f3"
        d="M36.1739 20.8695v11.1303c0 7.455 9.7391 9.7392 9.7391 9.7392s9.7391-2.2842 9.7391-9.7392V20.8695l-9.7391-2.7826z"
      />
      <path
        fill="#d80027"
        d="M55.6521 20.8697v-4.1739H36.1739v4.1739h8.3476v8.348h-8.3476v2.7826l8.3476.0001v9.3122c.8398.297 1.3915.4267 1.3915.4267s.5515-.1295 1.3911-.4267v-9.3123h8.348v-2.7827h-8.348v-8.348z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Fiji',
  64
);

export const FkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 31.9999H32v-.0856z" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.324.003 0 14.3286 0 32h16.6956v-9.4014L26.0971 32h5.8174l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1656 7.0107-12.0155 12.0155V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32 28.0649 20.6309 16.6958h-3.9352v.0003l15.304 15.304H32z"
      />
      <path
        fill="#ffda44"
        d="M51.4783 37.5652v1.3912H40.3479v-1.3912h-4.174v5.5651h2.7826v1.3914h13.9131v-1.3914h2.7825v-5.5651z"
      />
      <path
        fill="#338af3"
        d="M36.1739 16.6956v15.3043c0 7.4549 9.7391 9.7392 9.7391 9.7392s9.7391-2.2843 9.7391-9.7392V16.6956z"
      />
      <path
        fill="#f3f3f3"
        d="M45.9125 28.1111c-2.4346 0-2.4346 2.2261-4.8692 2.2261s-2.4347-2.2261-4.8693-2.2261v3.8956c2.4346 0 2.4346 2.2261 4.8693 2.2261s2.4346-2.2261 4.8692-2.2261c2.4349 0 2.4349 2.2261 4.8699 2.2261s2.4349-2.2261 4.8699-2.2261v-3.8956c-2.4349 0-2.4349 2.2261-4.8699 2.2261s-2.435-2.2261-4.8699-2.2261m0-7.7981c-2.4346 0-2.4346 2.2261-4.8692 2.2261s-2.4347-2.2261-4.8693-2.2261v3.8956c2.4346 0 2.4346 2.2261 4.8693 2.2261s2.4346-2.2261 4.8692-2.2261c2.4349 0 2.4349 2.2261 4.8699 2.2261s2.4349-2.2261 4.8699-2.2261V20.313c-2.4349 0-2.4349 2.2261-4.8699 2.2261s-2.435-2.2261-4.8699-2.2261"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Fk',
  64
);

export const FmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="m31.9999 13.913 1.3812 4.2515h4.4705l-3.6165 2.6276 1.3813 4.2514-3.6165-2.6275-3.6166 2.6275 1.3816-4.2514-3.6166-2.6276h4.4703zM13.913 32.0002l4.2515-1.3815v-4.4705l2.6276 3.6167 4.2514-1.3813-2.6275 3.6166 2.6275 3.6162-4.2514-1.3815-2.6276 3.6167v-4.4703zm18.0871 18.0867-1.3813-4.2515h-4.4705l3.6167-2.6276-1.3814-4.2514 3.6165 2.6275 3.6164-2.6275-1.3815 4.2514 3.6166 2.6276h-4.4702zM50.087 31.9998l-4.2515 1.3814v4.4704l-2.6276-3.6167-4.2514 1.3814 2.6275-3.6165-2.6275-3.6164 4.2514 1.3815 2.6276-3.6167v4.4704z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Fm',
  64
);

export const FoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="m62.6087 32 1.1199-4.1739a32 32 0 0 0-.8309-4.1738H29.2174V.1218a31.9 31.9 0 0 0-4.1739.64l-5.5653 3.412-2.7826-.2808a32.04 32.04 0 0 0-4.1739 2.7189V23.652H1.1024a32 32 0 0 0-.831 4.1739L1.3913 32 .2714 36.1739c.186 1.4226.465 2.8161.8308 4.1739h11.4194V57.388a32 32 0 0 0 4.1739 2.7189l4.1739-.2809 4.1738 3.412a32 32 0 0 0 4.1739.6401V40.3479h33.6803a32 32 0 0 0 .8308-4.1739z"
      />
      <path
        fill="#d80027"
        d="M63.7291 27.8261H25.0435V.7606a31.78 31.78 0 0 0-8.3479 3.1303V27.826H.2709A32.3 32.3 0 0 0 0 32c0 1.4146.093 2.8076.2709 4.1739h16.4247V60.109a31.78 31.78 0 0 0 8.3479 3.1302V36.174h38.6856A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1739"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Fo',
  64
);

export const FrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M64 32c0-13.7589-8.684-25.4882-20.8696-30.0096v60.0194C55.316 57.4883 64 45.7589 64 32"
      />
      <path
        fill="#0052b4"
        d="M0 32c0 13.7589 8.6841 25.4883 20.8696 30.0096V1.9904C8.6841 6.5118 0 18.241 0 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Fr',
  64
);

export const GaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M62.0096 43.1303C63.296 39.6638 64 35.9142 64 31.9999s-.704-7.6636-1.9904-11.1304L32 18.0869 1.9904 20.8695C.704 24.3363 0 28.0857 0 31.9999s.7041 7.6639 1.9904 11.1304L32 45.9129z"
      />
      <path
        fill="#0052b4"
        d="M32 64c13.7588 0 25.4883-8.684 30.0095-20.8696H1.9903C6.5118 55.316 18.241 64 32 64"
      />
      <path
        fill="#6da544"
        d="M32 0C18.241 0 6.5118 8.684 1.9903 20.8696h60.0193C57.4883 8.684 45.7588 0 32 0"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ga',
  64
);

export const GbIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M6.615 12.5178c-2.5136 3.2703-4.409 7.0397-5.5126 11.1346h16.6472zm56.2826 11.1346c-1.1036-4.0948-2.9991-7.8641-5.5126-11.1345L46.2506 23.6524zM1.1024 40.348c1.1037 4.0947 2.9991 7.8641 5.5126 11.1344L17.7492 40.348zM51.4822 6.6151c-3.2703-2.5136-7.0396-4.409-11.1345-5.5127v16.6471zM12.5177 57.3849c3.2704 2.5136 7.0398 4.409 11.1345 5.5127v-16.647zM23.6521 1.1024C19.5574 2.206 15.788 4.1015 12.5177 6.615l11.1344 11.1344zm16.6958 61.7952c4.0947-1.1037 7.8641-2.9991 11.1343-5.5126L40.3479 46.2506zm5.9027-22.5496L57.385 51.4825c2.5135-3.2703 4.409-7.0398 5.5126-11.1345z"
      />
      <path
        fill="#d80027"
        d="M63.7291 27.8261H36.174V.2709A32.3 32.3 0 0 0 32 0c-1.4149 0-2.8076.093-4.1739.2709V27.826H.2709A32.3 32.3 0 0 0 0 32c0 1.4149.093 2.8076.2709 4.1739H27.826v27.5552a32.3 32.3 0 0 0 8.3479 0V36.174h27.5552A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1739"
      />
      <path
        fill="#d80027"
        d="m40.3479 40.348 14.2795 14.2795a32 32 0 0 0 1.881-2.0544L44.2831 40.3479zm-16.6958 0h-.0002L9.3725 54.6274a32 32 0 0 0 2.0544 1.881l12.2252-12.2255zm0-16.6956v-.0003L9.3726 9.3725a32 32 0 0 0-1.881 2.0544L19.717 23.6522h3.9351zm16.6958 0L54.6275 9.3726a32 32 0 0 0-2.0544-1.8808L40.3479 19.717z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gb',
  64
);

export const GdIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="M13.9641 5.5653C19.0997 2.0544 25.3095 0 32 0s12.9002 2.0545 18.0359 5.5653L32 6.9565z"
      />
      <path fill="#0052b4" d="m32 32-2.0422-2.0422-.5423.9713z" />
      <path
        fill="#496e2d"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001zm45.255 0c12.4967 12.4967 12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#a2001d"
        d="M32 43.1304c6.1471 0 11.1304-4.9833 11.1304-11.1304S38.1471 20.8696 32 20.8696 20.8696 25.8529 20.8696 32 25.8529 43.1304 32 43.1304"
      />
      <path
        fill="#ffda44"
        d="m31.9999 20.8696 2.4948 7.6787h8.0748l-6.5323 4.7466 2.4949 7.679-6.5322-4.7458-6.5325 4.7458 2.4953-7.679-6.5322-4.7466h8.0742zM32 0l-.0107.0003h.0213z"
      />
      <path
        fill="#a2001d"
        d="M32.0108 0h-.0214C23.1578.0029 15.1626 3.5833 9.3743 9.371h45.2516C48.8374 3.5832 40.8423.0029 32.0108 0M9.3744 54.6292C15.165 60.419 23.1644 64 32 64s16.8349-3.581 22.6256-9.3708z"
      />
      <path
        fill="#ffda44"
        d="m32 3.4783.5181 1.5942h1.6763l-1.3562.9854.5182 1.5942L32 6.667l-1.3561.9852.5181-1.5942-1.3564-.9854h1.6763zm-7.7596 0 .5181 1.5942h1.6763l-1.3562.9854.5182 1.5942-1.3564-.9852-1.356.9852.518-1.5942-1.3564-.9854h1.6763zm15.5192 0 .5181 1.5942h1.6763l-1.3561.9854.5181 1.5942-1.3564-.9852-1.3561.9852.5181-1.5942-1.3564-.9854h1.6763zM32 56.3479l.5181 1.5943h1.6763l-1.3562.9853.5182 1.5943L32 59.5364l-1.3561.9854.5181-1.5943-1.3564-.9853h1.6763zm-7.7596 0 .5181 1.5943h1.6763l-1.3562.9853.5182 1.5943-1.3564-.9854-1.356.9854.518-1.5943-1.3564-.9853h1.6763zm15.5192 0 .5181 1.5943h1.6763l-1.3561.9853.5181 1.5943-1.3564-.9854-1.3561.9854.5181-1.5943-1.3564-.9853h1.6763zM9.7504 31.4716c.8219 1.2986.4356 3.0175-.863 3.8395s-3.0175.4357-3.8395-.8629c-1.4881-2.351-.6253-6.1906-.6253-6.1906s3.8395.8628 5.3278 3.214"
      />
      <path
        fill="#a2001d"
        d="M8.1433 35.5269c.7683 0 1.3912-.6229 1.3912-1.3913s-.6229-1.3912-1.3912-1.3912-1.3913.6229-1.3913 1.3912.6229 1.3913 1.3913 1.3913"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gd',
  64
);

export const GeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M63.7291 27.8261H36.174V.2709A32.3 32.3 0 0 0 32 0c-1.4146 0-2.8076.093-4.1739.2709V27.826H.2709A32.3 32.3 0 0 0 0 32c0 1.4149.093 2.8076.2709 4.1739H27.826v27.5552a32.3 32.3 0 0 0 8.3479 0V36.174h27.5552A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1739"
      />
      <path
        fill="#d80027"
        d="M19.4782 15.3044v-4.174h-4.1738v4.174h-4.174v4.1738h4.174v4.1739h4.1738v-4.1739h4.1739v-4.1738zm29.2174 0v-4.174h-4.1739v4.174h-4.1738v4.1738h4.1738v4.1739h4.1739v-4.1739h4.174v-4.1738zM19.4782 44.5218v-4.1739h-4.1738v4.1739h-4.174v4.1739h4.174v4.174h4.1738v-4.174h4.1739v-4.1739zm29.2174 0v-4.1739h-4.1739v4.1739h-4.1738v4.1739h4.1738v4.174h4.1739v-4.174h4.174v-4.1739z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ge',
  64
);

export const GgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M63.7291 27.8261H36.174V.2709A32.3 32.3 0 0 0 32 0c-1.4146 0-2.8076.093-4.1739.2709V27.826H.2709A32.3 32.3 0 0 0 0 32c0 1.4146.093 2.8076.2709 4.1739H27.826v27.5552a32.3 32.3 0 0 0 8.3479 0V36.174h27.5552A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1739"
      />
      <path
        fill="#ffda44"
        d="m41.0435 33.3913 2.0869 1.3913v-5.5652l-2.0869 1.3914h-7.6522v-7.6523l1.3913-2.0869h-5.5652l1.3914 2.0869v7.6523h-7.6523l-2.0869-1.3914v5.5652l2.0869-1.3913h7.6523v7.6522l-1.3914 2.0869h5.5652l-1.3913-2.0869v-7.6522z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gg',
  64
);

export const GhIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M0 32c0 3.9143.7041 7.6638 1.9904 11.1304L32 44.5218l30.0096-1.3913C63.296 39.6638 64 35.9143 64 32s-.704-7.6637-1.9904-11.1304L32 19.4783 1.9904 20.8695C.704 24.3363 0 28.0858 0 32"
      />
      <path
        fill="#d80027"
        d="M32 0C18.2411 0 6.5117 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#496e2d"
        d="M62.0096 43.1304H1.9904C6.5117 55.3159 18.241 64 32 64s25.4882-8.6841 30.0096-20.8696"
      />
      <path
        fill="#000"
        d="m31.9998 20.8696 2.7625 8.5025h8.941l-7.2329 5.2554 2.7625 8.5029-7.2331-5.255-7.2332 5.255 2.763-8.5029-7.2328-5.2554h8.9405z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gh',
  64
);

export const GiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#f9f9f9"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7587 0 25.4882-8.684 30.0095-20.8696H1.9902C6.5117 55.316 18.241 64 32 64m12.5217-37.5653v-4.1739h1.3913v-2.7826h-2.7826v1.3914h-2.7825v-1.3914h-2.7827v2.7826h1.3913v4.1739h-2.7826v-9.7389h1.3913v-2.7825h-2.7826v1.391h-1.3914v-1.391h-2.7825v1.391h-1.3913v-1.391h-2.7827v2.7825h1.3914v9.7389h-2.7826v-4.1739h1.3912v-2.7826h-2.7826v1.3914h-2.7825v-1.3914H18.087v2.7826h1.3912v4.1739h-2.7826v11.1305h30.6088V26.4347z"
      />
      <path
        fill="#ffda44"
        d="M32 36.1738c-2.3051 0-4.1739 1.8688-4.1739 4.1739 0 1.817 1.1618 3.3625 2.7826 3.9355v5.8038h-4.1738v5.5652h6.9565V44.2833c1.6209-.573 2.7826-2.1183 2.7826-3.9355-.0001-2.3051-1.8689-4.174-4.174-4.174m0 5.5653c-.7684 0-1.3913-.623-1.3913-1.3913s.6229-1.3912 1.3913-1.3912 1.3913.6229 1.3913 1.3912-.6229 1.3913-1.3913 1.3913"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gi',
  64
);

export const GlIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32c-1.3913 0-32 4.1739-32 4.1739z"
      />
      <path fill="#d80027" d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32" />
      <path
        fill="#fff"
        d="M22.2609 47.3044c8.4523 0 15.3043-6.852 15.3043-15.3044s-6.852-15.3044-15.3043-15.3044c-8.4524 0-15.3044 6.852-15.3044 15.3044s6.852 15.3044 15.3044 15.3044"
      />
      <path
        fill="#d80027"
        d="M6.9565 32c0-8.4521 6.852-15.3044 15.3044-15.3044 8.4525 0 15.3043 6.8521 15.3043 15.3044"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gl',
  64
);

export const GmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="M32 0C18.7706 0 7.4171 8.0283 2.5435 19.4783h58.9131C56.583 8.0283 45.2294 0 32 0"
      />
      <path
        fill="#496e2d"
        d="M32 64c13.2294 0 24.583-8.0283 29.4565-19.4783H2.5435C7.417 55.9717 18.7706 64 32 64"
      />
      <path
        fill="#0052b4"
        d="M62.8976 23.6521H1.1024C.385 26.3137 0 29.1116 0 32s.385 5.6862 1.1024 8.3478h61.7954C63.615 37.6862 64 34.8884 64 32s-.385-5.6863-1.1024-8.3479"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gm',
  64
);

export const GnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M43.1308 1.9905C39.664.7041 35.9144 0 32 0c-3.9141 0-7.6636.7041-11.1301 1.9903L19.4785 32l1.3913 30.0098C24.3364 63.296 28.0859 64 32 64c3.9145 0 7.664-.704 11.1308-1.9905L44.522 32z"
      />
      <path
        fill="#d80027"
        d="M0 32c0 13.7587 8.684 25.4882 20.8696 30.0095V1.9902C8.684 6.5117 0 18.241 0 32"
      />
      <path
        fill="#6da544"
        d="M64 32c0-13.759-8.684-25.4883-20.8696-30.0098v60.0194C55.316 57.4882 64 45.7587 64 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gn',
  64
);

export const GqIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#6da544"
        d="M19.4783 20.8696h42.5312C57.4883 8.684 45.7588 0 32 0 23.1633 0 15.1641 3.5824 9.3736 9.3736z"
      />
      <path
        fill="#d80027"
        d="M19.4783 43.1304h42.5312C57.4883 55.316 45.7588 64 32 64c-8.8367 0-16.8359-3.5824-22.6264-9.3736z"
      />
      <path
        fill="#0052b4"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#dedde0"
        d="M37.5652 26.4348v6.9565c0 4.26 5.5653 5.5654 5.5653 5.5654s5.5652-1.3054 5.5652-5.5654v-6.9565z"
      />
      <path fill="#786145" d="M41.7391 32.1392h2.7826v4.0347h-2.7826z" />
      <path
        fill="#6da544"
        d="M45.913 30.6088c0-1.5369-1.2458-2.7826-2.7826-2.7826s-2.7827 1.2457-2.7827 2.7826c-.7683 0-1.3912.6229-1.3912 1.3912s.6229 1.3913 1.3912 1.3913h5.5653c.7684 0 1.3912-.6229 1.3912-1.3913s-.6227-1.3912-1.3912-1.3912"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gq',
  64
);

export const GrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#338af3"
        d="M32 23.6521h30.8976a31.82 31.82 0 0 0-3.5944-8.3478H32zM12.0804 57.0435h39.8391c2.9204-2.326 5.4249-5.1513 7.3836-8.3479H4.6968c1.9588 3.1965 4.4633 6.0219 7.3836 8.3479m-.95-49.3011a32.16 32.16 0 0 0-6.4336 7.562h6.4336zM32 32v-8.3479H19.4783V32h-8.3479v-8.3479H1.1024C.385 26.3138 0 29.1116 0 32s.385 5.6861 1.1024 8.3478h61.7954C63.615 37.6861 64 34.8884 64 32z"
      />
      <path
        fill="#338af3"
        d="M32 0c-4.4436 0-8.6755.9066-12.5218 2.5435v12.7609H32V6.9565h19.9196C46.4532 2.603 39.5311 0 32 0"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gr',
  64
);

export const GtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#338af3"
        d="M64 32c0-12.6867-7.3831-23.6487-18.087-28.8247v57.6494C56.6169 55.6488 64 44.6867 64 32M0 32c0 12.6867 7.3831 23.6488 18.087 28.8248V3.1753C7.3831 8.3513 0 19.3133 0 32"
      />
      <path
        fill="#acabb1"
        d="m40.3622 37.4109-5.4107-5.4107 5.1504-5.1507-.2334-2.7202-1.4745-1.4748L32 29.0485l-6.394-6.394-1.4745 1.4748-.2334 2.7202 5.1504 5.1507-5.4109 5.4107 2.9515 2.9513L32 34.9515l5.4109 5.4107z"
      />
      <path
        fill="#6da544"
        d="M39.8704 24.1296 36.919 27.081c1.2589 1.2589 2.0376 2.998 2.0376 4.919 0 3.842-3.1146 6.9565-6.9565 6.9565-3.8418 0-6.9566-3.1145-6.9566-6.9565 0-1.921.7788-3.6601 2.0376-4.919l-2.9513-2.9514c-2.0144 2.014-3.2602 4.7967-3.2602 7.8704 0 6.1473 4.9833 11.1304 11.1304 11.1304S43.1304 38.1471 43.1304 32c0-3.0736-1.2458-5.8562-3.26-7.8704"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gt',
  64
);

export const GuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M13.9641 58.4347C19.0996 61.9453 25.3096 64 32 64s12.9002-2.0547 18.0359-5.5653L32 55.6521zM50.0359 5.5653C44.9002 2.0546 38.6904 0 32 0S19.0996 2.0546 13.9641 5.5653L32 8.3479z"
      />
      <path
        fill="#0052b4"
        d="M64 31.9999c0-10.5887-6.3395-21.2225-13.9641-26.4347H13.9641C5.5338 11.3282 0 21.0174 0 31.9999c0 10.9829 5.5338 20.6718 13.9641 26.4348h36.0718C58.4664 52.6717 64 42.9828 64 31.9999"
      />
      <path
        fill="#d80027"
        d="M30.1891 52.1995c-.4372-.375-10.7109-9.306-10.7109-20.1996s10.2735-19.8247 10.7109-20.1996L32 10.248l1.8109 1.5522c.4372.375 10.7108 9.306 10.7108 20.1997S34.2482 51.8248 33.8109 52.1995L32 53.7518z"
      />
      <path
        fill="#338af3"
        d="M41.7391 32.0001c0-9.7391-9.7391-18.087-9.7391-18.087s-9.7391 8.3481-9.7391 18.087c0 2.9794.9121 5.828 2.1774 8.3479h15.1235c1.2652-2.5199 2.1773-5.3685 2.1773-8.3479"
      />
      <path
        fill="#0052b4"
        d="M41.7391 32c0 2.9794-.9121 5.828-2.1773 8.3479L32 41.7391l-7.5617-1.3912C23.173 37.8281 22.2609 34.9794 22.2609 32z"
      />
      <path
        fill="#ffda44"
        d="M32 50.087s4.691-4.0221 7.5617-9.7391H24.4382C27.309 46.0649 32 50.087 32 50.087"
      />
      <path fill="#6da544" d="M25.7391 26.4348h12.5218L32 32.6957z" />
      <path fill="#a2001d" d="M29.913 30.6086h4.1739v12.5218H29.913z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gu',
  64
);

export const GyIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#6da544"
        d="M32 0c-5.6576 0-10.9711 1.4703-15.5826 4.0465v55.907C21.029 62.5297 26.3424 64 32 64c17.673 0 32-14.327 32-32S49.673 0 32 0"
      />
      <path
        fill="#fff"
        d="M16.5115 3.9939a32.07 32.07 0 0 0-5.6103 3.9491q.2606-.2284.5258-.4512L35.9351 32 11.4269 56.5083a32 32 0 0 1-.5258-.4513 32.08 32.08 0 0 0 5.6103 3.9491L64 32z"
      />
      <path
        fill="#ffda44"
        d="M13.8088 5.6729a32.2 32.2 0 0 0-2.8063 2.18L32 32 11.0024 56.1474a32.2 32.2 0 0 0 2.8062 2.18l44.7137-26.3273z"
      />
      <path
        fill="#000"
        d="M11.4269 7.4917a32.2 32.2 0 0 0-2.0544 1.8808L29.2174 32 9.3725 54.6274a32 32 0 0 0 2.0544 1.8808L35.9351 32z"
      />
      <path
        fill="#d80027"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Gy',
  64
);

export const HkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="M35.3037 24.2086c-.7272 3.0249-2.0193 2.448-2.6535 5.086-3.7353-.8981-6.0358-4.6544-5.1377-8.39.8977-3.7354 4.6544-6.0359 8.3899-5.1378-1.2684 5.2759.052 5.7364-.5987 8.4418M25.6109 26.45c2.6521 1.6262 1.7041 2.6771 4.0169 4.0955-2.0085 3.2751-6.2917 4.302-9.5669 2.2936-3.2751-2.0084-4.3023-6.2918-2.2938-9.5669 4.6258 2.8365 5.4714 1.7231 7.8438 3.1778m-.8636 9.9116c2.3663-2.0197 3.0725-.7935 5.1361-2.5547 2.4944 2.9221 2.1474 7.3131-.7746 9.8075-2.9223 2.4944-7.3133 2.147-9.8073-.7749 4.1268-3.5229 3.3291-4.6715 5.4458-6.4779m9.1595 3.8842c-1.19-2.8746.1945-3.1676-.8429-5.6743 3.5499-1.4691 7.6189.2177 9.0881 3.7675s-.2178 7.6188-3.7677 9.088c-2.0746-5.0136-3.4133-4.61-4.4775-7.1812m6.5245-7.5112c-3.1017.2433-2.9528-1.1642-5.6572-.9519-.3003-3.8299 2.5614-7.1788 6.3915-7.4794 3.83-.2999 7.1788 2.5616 7.479 6.3919-5.4096.4241-5.4395 1.822-8.2133 2.0394"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Hk',
  64
);

export const HnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#338af3"
        d="M32 64.0001c12.6866 0 23.6487-7.3831 28.8247-18.087H3.1752C8.3512 56.617 19.3132 64.0001 32 64.0001M32 0C19.3132 0 8.3512 7.3831 3.1752 18.087h57.6494C55.6487 7.3831 44.6866 0 32 0M19.6931 20.8696l1.036 3.1887h3.3527l-2.7123 1.9705 1.0361 3.1886-2.7125-1.9706-2.7125 1.9706 1.0362-3.1886-2.7124-1.9705h3.3526zm0 13.9131 1.036 3.1888h3.3527l-2.7123 1.9705 1.0361 3.1885-2.7125-1.9707-2.7125 1.9707 1.0362-3.1885-2.7124-1.9705h3.3526zm24.6137-13.9131 1.0362 3.1887h3.3526l-2.7124 1.9705 1.0361 3.1886-2.7125-1.9706-2.7125 1.9706 1.0362-3.1886-2.7124-1.9705h3.3527zm0 13.9131 1.0362 3.1888h3.3526l-2.7124 1.9705 1.0361 3.1885-2.7125-1.9707-2.7125 1.9707 1.0362-3.1885-2.7124-1.9705h3.3527zM32 27.8262l1.0361 3.1887h3.3526l-2.7124 1.9705 1.0362 3.1885L32 34.2033l-2.7125 1.9706 1.0361-3.1885-2.7124-1.9705h3.3526z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Hn',
  64
);

export const HrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M64 32c0-3.9142-.7041-7.6639-1.9904-11.1304L32 19.4783 1.9904 20.8695C.704 24.3361 0 28.0858 0 32c0 3.9143.7041 7.6639 1.9904 11.1304L32 44.5218l30.0096-1.3913C63.2959 39.6639 64 35.9143 64 32"
      />
      <path
        fill="#0052b4"
        d="M32 64c13.7589 0 25.4883-8.684 30.0096-20.8696H1.9904C6.5118 55.316 18.241 64 32 64"
      />
      <path
        fill="#d80027"
        d="M1.9904 20.8696h60.0194C57.4883 8.684 45.7589 0 32 0S6.5118 8.684 1.9904 20.8696"
      />
      <path
        fill="#338af3"
        d="M40.3479 22.261h-5.5653l.9277-6.9566 3.7099-2.7827 3.7102 2.7827v5.5652zm-16.6958 0h5.5653l-.9276-6.9566-3.7102-2.7827-3.71 2.7827v5.5652z"
      />
      <path
        fill="#0052b4"
        d="M35.7102 22.261h-7.4205v-6.9566L32 12.5217l3.7102 2.7827z"
      />
      <path
        fill="#fff"
        d="M20.8696 20.8698V36.174c0 3.6441 1.7603 6.8849 4.4753 8.9165l1.9479-.4874 2.458 2.4728c.7268.1497 1.479.2286 2.2493.2286a11.14 11.14 0 0 0 2.2377-.2261l2.8058-2.3363 1.6115.3439c2.7139-2.0315 4.4754-5.2689 4.4754-8.912V20.8698z"
      />
      <path
        fill="#d80027"
        d="M20.8696 20.8696h4.4522v4.4522h-4.4522zm8.9043 0h4.4521v4.4522h-4.4521zm8.9044 0h4.4521v4.4522h-4.4521zm-13.3566 4.4522h4.4522v4.4521h-4.4522zm8.9044 0h4.4522v4.4521h-4.4522z"
      />
      <path
        fill="#d80027"
        d="M20.8696 29.7725h4.4522v4.4521h-4.4522zm4.4521 4.4522h4.4522v4.4522h-4.4522zm4.4522-4.4522h4.4521v4.4521h-4.4521zm8.9044 0h4.4521v4.4521h-4.4521zm-4.4522 4.4522h4.4522v4.4522h-4.4522zm-4.4522 4.4522h4.4521v4.4521h-4.4521zm-4.4521.0003h-4.1649c.382 1.655 1.133 3.1694 2.1627 4.4522h2.0022zm13.3565 4.4523h2.002c1.03-1.2828 1.7807-2.7973 2.1627-4.4521h-4.1647zm-13.3566 0v1.9426c1.2949.9744 2.8082 1.673 4.4522 2.0083v-3.9509zm8.9044 0v3.9509c1.6442-.335 3.1573-1.0339 4.4522-2.0083v-1.9426z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Hr',
  64
);

export const HtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#a2001d"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32 32 0 32 0s32 14.327 32 32"
      />
      <path fill="#0052b4" d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32" />
      <path
        fill="#fff"
        d="M43.1304 40.3478 32 38.9565l-11.1304 1.3913V23.6521h22.2608z"
      />
      <path
        fill="#0052b4"
        d="M32 38.9564c3.0736 0 5.5653-2.4916 5.5653-5.5652S35.0736 27.8259 32 27.8259s-5.5652 2.4917-5.5652 5.5653S28.9264 38.9564 32 38.9564"
      />
      <path
        fill="#a2001d"
        d="M32 36.1739c1.5368 0 2.7826-1.2458 2.7826-2.7826S33.5368 30.6086 32 30.6086s-2.7827 1.2459-2.7827 2.7827S30.4632 36.1739 32 36.1739"
      />
      <path fill="#6da544" d="M27.8261 26.4348h8.3478L32 30.6088z" />
      <path fill="#ffda44" d="M30.6088 29.2173h2.7826v8.3479h-2.7826z" />
      <path
        fill="#6da544"
        d="M36.4521 36.7305h-8.9045l-6.678 3.6175h22.2608z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ht',
  64
);

export const HuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M1.9904 20.8696C.704 24.3364 0 28.0857 0 32s.7041 7.6639 1.9904 11.1304L32 45.913l30.0096-2.7826C63.2959 39.6639 64 35.9142 64 32s-.7041-7.6636-1.9904-11.1304L32 18.087z"
      />
      <path
        fill="#d80027"
        d="M32 0C18.2413 0 6.5118 8.684 1.9905 20.8696H62.01C57.4883 8.684 45.759 0 32 0"
      />
      <path
        fill="#6da544"
        d="M32 64c13.759 0 25.4883-8.684 30.0098-20.8696H1.9905C6.5118 55.316 18.2413 64 32 64"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Hu',
  64
);

export const IcIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M32 0c-3.9143 0-7.6639.7041-11.1304 1.9904L19.4782 32l1.3913 30.0096C24.3361 63.296 28.0857 64 32 64s7.6639-.704 11.1304-1.9904L44.5217 32 43.1305 1.9904C39.6639.704 35.9142 0 32 0"
      />
      <path
        fill="#ffda44"
        d="M64 32c0-13.7589-8.684-25.4883-20.8696-30.0096v60.0193C55.316 57.4882 64 45.7589 64 32"
      />
      <path
        fill="#fff"
        d="M20.8696 62.0096V1.9904C8.684 6.5117 0 18.241 0 32s8.684 25.4882 20.8696 30.0096"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ic',
  64
);

export const IdIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#a2001d" d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Id',
  64
);

export const IeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ff9811"
        d="M64 32c0-13.7588-8.684-25.4883-20.8696-30.0095v60.0194C55.316 57.4882 64 45.759 64 32"
      />
      <path
        fill="#6da544"
        d="M0 32c0 13.759 8.684 25.4882 20.8696 30.0097V1.9905C8.684 6.5117 0 18.2412 0 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ie',
  64
);

export const IlIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M44.0492 25.0437h-8.0329l-4.0162-6.9565-4.0162 6.9565h-8.033l4.0168 6.9565-4.0168 6.9565h8.033l4.0162 6.9565 4.0162-6.9565h8.0329l-4.0168-6.9565zm-7.1148 6.9565-2.467 4.2735h-4.9343l-2.4674-4.2735 2.4672-4.2735h4.9344zm-4.9343-8.5472.9182 1.5905h-1.8362zm-7.4018 4.2737h1.8365l-.9182 1.5905zm0 8.547.9184-1.5905.9182 1.5905zm7.4018 4.2735-.9182-1.5905h1.8364zm7.4017-4.2735h-1.8365l.9184-1.5905zm-1.8365-8.547h1.8365l-.9182 1.5905zM51.9197 6.9565H12.0804c-2.9204 2.326-5.4249 5.1513-7.3836 8.3479h54.6065c-1.9589-3.1965-4.4634-6.0219-7.3836-8.3479M12.0804 57.0434h39.8391c2.9204-2.326 5.4249-5.1512 7.3837-8.3478H4.6968c1.9589 3.1965 4.4634 6.0218 7.3836 8.3478"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Il',
  64
);

export const ImIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="m43.8483 21.4515-2.2617 8.0714-6.7862-1.2531-4.3683-9.0044-11.8009 4.1876-.9306-2.6225-3.0875-.3804 2.3264 6.5562 8.1211-2.0769 2.3079 6.5036-5.614 8.2853 9.5271 8.1257-1.8058 2.1171 1.2143 2.8643 4.5147-5.293-5.8592-5.9946 4.4784-5.2504 9.9822.7192 2.2736-12.3137 2.7364.5054 1.8736-2.4838z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Im',
  64
);

export const InIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ff9811"
        d="M32 0C19.3132 0 8.3513 7.3831 3.1753 18.087h57.6493C55.6487 7.3831 44.6866 0 32 0"
      />
      <path
        fill="#6da544"
        d="M32 64.0001c12.6866 0 23.6487-7.3831 28.8247-18.087H3.1753C8.3512 56.617 19.3131 64.0001 32 64.0001"
      />
      <path
        fill="#0052b4"
        d="M32 43.1304c6.1471 0 11.1304-4.9833 11.1304-11.1304S38.1471 20.8696 32 20.8696 20.8696 25.8529 20.8696 32 25.8529 43.1304 32 43.1304"
      />
      <path
        fill="#fff"
        d="M32 38.9565c3.842 0 6.9565-3.1146 6.9565-6.9565S35.842 25.0435 32 25.0435 25.0435 28.158 25.0435 32c0 3.8419 3.1145 6.9565 6.9565 6.9565"
      />
      <path
        fill="#0052b4"
        d="m32 23.4158 2.1461 4.8672 5.288-.5751L36.2921 32l3.142 4.2921-5.288-.5751L32 40.5843l-2.1461-4.8673-5.288.575L27.7079 32l-3.142-4.2921 5.288.5751z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'In',
  64
);

export const IqIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="M32 0C18.2411 0 6.5117 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#000"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#496e2d"
        d="M24.3479 29.913c-.0175 0-.0347.0011-.0522.0014v-.0014h-6.1171c.3101-1.1983 1.3974-2.087 2.691-2.087v-4.1739c-3.8359 0-6.9565 3.1208-6.9565 6.9565v3.4784h10.4348a.6964.6964 0 0 1 .6956.6956v1.3912H11.1304v4.1739h18.087v-5.5652c0-2.685-2.1845-4.8695-4.8695-4.8695m10.4347 6.2608V23.6521h-4.1738v16.6957h6.9565v-4.174zm13.913.0002V23.6521h-4.1739V36.174h-1.3913v-4.1739h-4.1739v8.3479h12.5217v-4.174z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Iq',
  64
);

export const IrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M42.3934 23.6522h-4.1868c.0347.4601.0543.9244.0543 1.3913 0 3.0955-.7738 6.0959-2.1226 8.2316-.4162.6588-1.1154 1.589-2.0514 2.2165V23.6521H29.913v11.8395c-.9359-.6275-1.6352-1.5576-2.0514-2.2165-1.349-2.1357-2.1226-5.1361-2.1226-8.2316 0-.4669.0198-.9313.0543-1.3913h-4.1868a23.7 23.7 0 0 0-.0415 1.3913c0 8.582 4.5835 15.3044 10.4348 15.3044s10.4347-6.7224 10.4347-15.3044a23.6 23.6 0 0 0-.0411-1.3913"
      />
      <path
        fill="#6da544"
        d="M13.2174 15.3044h4.1739v2.7826h4.1738v-2.7826h4.1739v2.7826h4.1739v-2.7826h4.1739v2.7826h4.1738v-2.7826h4.1739v2.7826h4.1739v-2.7826h4.1739v2.7826h10.0421C55.6488 7.3831 44.6866 0 32 0S8.3513 7.3831 3.1753 18.087h10.0421z"
      />
      <path
        fill="#d80027"
        d="M50.7826 45.9131v2.7826h-4.1738v-2.7826h-4.1739v2.7826H38.261v-2.7826h-4.1739v2.7826h-4.1738v-2.7826h-4.1739v2.7826h-4.1739v-2.7826h-4.1742v2.7826h-4.1739v-2.7826H3.1753C8.3513 56.617 19.3133 64.0001 32 64.0001c12.6868 0 23.6488-7.3831 28.8248-18.087z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ir',
  64
);

export const IsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M1.1024 40.3479c1.8515 6.8698 5.9321 12.8241 11.4193 17.0402V40.3479zm28.115 23.5303C30.1346 63.9572 31.0622 64 32 64c14.7849 0 27.2256-10.0276 30.8976-23.6521H29.2174zm33.6802-40.2261C59.2256 10.0276 46.7849 0 32 0c-.9378 0-1.8654.0428-2.7826.1218V23.652zM12.5217 6.6119C7.0345 10.828 2.9539 16.7823 1.1024 23.652h11.4193z"
      />
      <path
        fill="#d80027"
        d="M63.7291 27.8261H25.0435V.7606a31.78 31.78 0 0 0-8.3479 3.1303V27.826H.2709A32.3 32.3 0 0 0 0 32c0 1.4146.0928 2.8076.2709 4.1739h16.4247V60.109a31.78 31.78 0 0 0 8.3479 3.1302V36.174h38.6856A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1739"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Is',
  64
);

export const ItIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M64 32c0-13.7589-8.684-25.4882-20.8696-30.0096v60.0194C55.316 57.4883 64 45.7589 64 32"
      />
      <path
        fill="#6da544"
        d="M0 32c0 13.7589 8.684 25.4883 20.8696 30.0096V1.9904C8.684 6.5118 0 18.241 0 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'It',
  64
);

export const JeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M57.3873 51.4844 37.9029 32.0002h-.0001l19.4845-19.4847a32.28 32.28 0 0 0-5.9028-5.9027L32.0001 26.0972 32 26.0973 12.5156 6.6128a32.27 32.27 0 0 0-5.9027 5.9027l19.4844 19.4843.0001.0001L6.6128 51.4845a32.27 32.27 0 0 0 5.9027 5.9028L32 37.9029l.0001-.0001 19.4844 19.4844a32.3 32.3 0 0 0 3.143-2.7598 32.3 32.3 0 0 0 2.7598-3.143"
      />
      <path
        fill="#ffda44"
        d="M26.4348 9.7392 32 11.1305l5.5653-1.3913V5.0088l-2.2262 1.113L32 2.7828l-3.3391 3.339-2.2261-1.113z"
      />
      <path
        fill="#d80027"
        d="M26.4348 9.739v3.4785c0 4.26 5.5652 5.5653 5.5652 5.5653s5.5653-1.3054 5.5653-5.5653V9.739z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Je',
  64
);

export const JmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#6da544"
        d="M51.482 6.615C46.0861 2.4674 39.3317 0 32 0c-7.3318 0-14.0863 2.4675-19.4821 6.615L32 26.097z"
      />
      <path
        fill="#000"
        d="M6.6149 12.5181C2.4675 17.9139 0 24.6683 0 32.0001s2.4675 14.0862 6.615 19.4822l19.4821-19.4822z"
      />
      <path
        fill="#6da544"
        d="M12.5179 57.3851c5.396 4.1476 12.1503 6.615 19.4821 6.615s14.0861-2.4675 19.4821-6.615L32 37.9031z"
      />
      <path
        fill="#000"
        d="M57.385 51.4821C61.5326 46.0862 64 39.3318 64 32.0001c0-7.3318-2.4674-14.0862-6.615-19.482l-19.482 19.482z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Jm',
  64
);

export const JoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="M19.4782 20.8696h42.5313C57.4882 8.684 45.7587 0 32 0 23.1632 0 15.1641 3.5824 9.3736 9.3736z"
      />
      <path
        fill="#6da544"
        d="M19.4782 43.1304h42.5313C57.4882 55.316 45.7587 64 32 64c-8.8368 0-16.8359-3.5824-22.6264-9.3736z"
      />
      <path
        fill="#d80027"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#fff"
        d="m12.7006 25.0435 1.7561 3.6723 3.9662-.9166-1.7763 3.6626 3.1894 2.5293-3.9709.8949.011 4.0705-3.1755-2.5467-3.1756 2.5467.0111-4.0705-3.9708-.8949 3.1892-2.5293-1.776-3.6626 3.9659.9166z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Jo',
  64
);

export const JpIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 45.9129c7.6839 0 13.913-6.229 13.913-13.913S39.6839 18.0869 32 18.0869s-13.913 6.2291-13.913 13.913S24.3161 45.9129 32 45.9129"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Jp',
  64
);

export const KeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="M32 0C19.3132 0 8.3512 7.3831 3.1752 18.087h57.6494C55.6487 7.3831 44.6866 0 32 0"
      />
      <path
        fill="#496e2d"
        d="M32 64.0001c-12.6868 0-23.6488-7.3831-28.8248-18.087h57.6494C55.6487 56.617 44.6866 64.0001 32 64.0001"
      />
      <path
        fill="#a2001d"
        d="M62.4889 22.261H1.5111C.531 25.3321 0 28.604 0 32.0001s.5309 6.668 1.5111 9.7391h60.9777C63.4691 38.6681 64 35.3962 64 32.0001s-.5309-6.668-1.5111-9.7391"
      />
      <path
        fill="#fff"
        d="m41.9644 14.7877-3.7896-1.7491L32 27.0199l-6.1747-13.9813-3.7897 1.7491 7.666 17.2124-7.666 17.2123 3.7897 1.7492L32 36.9802l6.1748 13.9814 3.7896-1.7492-7.666-17.2123z"
      />
      <path
        fill="#fff"
        d="M34.5739 16.4362C33.1069 14.8341 32 13.9131 32 13.9131s-1.1069.9209-2.5739 2.5231v31.1275C30.8931 49.1661 32 50.0871 32 50.0871s1.1069-.9209 2.5739-2.5233z"
      />
      <path
        fill="#a2001d"
        d="M25.0435 22.4053v19.189c1.5503 2.7469 3.4476 4.9984 4.8696 6.4911V15.9143c-1.422 1.4926-3.3195 3.7443-4.8696 6.491m13.913 0c-1.5503-2.7469-3.4476-4.9984-4.8696-6.491v32.1711c1.4219-1.4927 3.3193-3.7442 4.8696-6.4911z"
      />
      <path
        fill="#000"
        d="M38.9565 22.4053v19.189c1.5694-2.7812 2.7826-6.0698 2.7826-9.5944s-1.2132-6.8134-2.7826-9.5946m-13.913 0v19.189c-1.5694-2.7812-2.7826-6.0698-2.7826-9.5944s1.2132-6.8134 2.7826-9.5946"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ke',
  64
);

export const KgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="m47.6496 32-6.3944 3.0078 3.4052 6.1934-6.9442-1.3287-.8795 7.0145-4.8368-5.1587-4.8365 5.1587-.8799-7.0145-6.9435 1.3284 3.405-6.1934L16.3504 32l6.3946-3.0076-3.405-6.1935 6.9432 1.3288.8804-7.0147 4.8363 5.1589 4.8371-5.1589.8792 7.0147 6.9444-1.3288-3.4052 6.1939z"
      />
      <path
        fill="#d80027"
        d="M32 41.7392c5.3788 0 9.7391-4.3603 9.7391-9.7391S37.3788 22.261 32 22.261s-9.7391 4.3603-9.7391 9.7391S26.6212 41.7392 32 41.7392"
      />
      <path
        fill="#ffda44"
        d="M27.1304 32c-.2346 0-.4663.012-.6949.0348.0084 1.3488.4964 2.5834 1.3024 3.5426a9.76 9.76 0 0 1 1.8816-3.1153A6.92 6.92 0 0 0 27.1304 32m2.9977 5.2416A5.55 5.55 0 0 0 32 37.5652c.657 0 1.2869-.1146 1.8719-.3236-.3189-1.2515-.9773-2.3687-1.8719-3.2467-.8946.8778-1.553 1.9952-1.8719 3.2467m6.6913-8.0233C35.8571 27.5551 34.06 26.4348 32 26.4348s-3.8571 1.1201-4.8194 2.7835c1.7543.0089 3.3993.4859 4.8194 1.3095 1.4201-.8236 3.0649-1.3006 4.8194-1.3095m-2.4392 3.2441a9.76 9.76 0 0 1 1.8817 3.1152c.806-.9591 1.294-2.1937 1.3024-3.5426a7 7 0 0 0-.6949-.0348 6.92 6.92 0 0 0-2.4892.4622"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Kg',
  64
);

export const KhIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M0 32c0 5.5437 1.4104 10.758 3.8909 15.3043L32 50.087l28.1091-2.7827C62.5896 42.758 64 37.5437 64 32c0-5.5438-1.4104-10.758-3.8909-15.3044L32 13.913 3.8909 16.6956C1.4104 21.242 0 26.4562 0 32"
      />
      <path
        fill="#0052b4"
        d="M3.8909 16.6956H60.109C54.6817 6.7486 44.1294 0 32 0S9.3182 6.7486 3.8909 16.6956M32 63.9999c12.1294 0 22.6817-6.7486 28.1091-16.6956H3.8909C9.3182 57.2513 19.8706 63.9999 32 63.9999"
      />
      <path
        fill="#fff"
        d="M43.1304 38.2608V34.087h-2.7826v-5.5653l-2.7826-2.7826-2.7826 2.7826v-5.5652L32 20.1738l-2.7826 2.7827v5.5652l-2.7827-2.7826-2.7826 2.7826v5.5653h-2.7825v4.1738H18.087v4.1739h27.826v-4.1739z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Kh',
  64
);

export const KiIcon = createSvgIcon(
  [
    <g key="0">
      <path fill="#d80027" d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32" />
      <path
        fill="#ffda44"
        d="m43.1304 29.7598-4.5481 2.1391 2.422 4.4049-4.9387-.9449-.6257 4.989L32 36.6785l-3.44 3.6694-.6256-4.989-4.9386.9446 2.4218-4.4046-4.548-2.1391 4.548-2.1395-2.4218-4.4044 4.9385.9445.6258-4.9888L32 22.8408l3.44-3.6692.6256 4.9888 4.9388-.9445-2.4218 4.4047zm-2.7826-19.3251H34.087c0-1.1524-.9345-2.087-2.087-2.087s-2.087.9345-2.087 2.087h-6.2609c0 1.1525 1.004 2.087 2.1565 2.087h-.0696c0 1.1525.9342 2.087 2.087 2.087 0 1.1525.9342 2.087 2.087 2.087h4.1739c1.1523 0 2.0869-.9344 2.0869-2.087 1.1524 0 2.0871-.9344 2.0871-2.087h-.0697c1.1527 0 2.1566-.9344 2.1566-2.087"
      />
      <path fill="#fff" d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32z" />
      <path
        fill="#0052b4"
        d="M32 64c10.0028 0 18.932-4.5905 24.8003-11.7785-1.0555-.7196-1.6254-1.8829-3.4674-1.8829-2.6666 0-2.6666 2.4383-5.3331 2.4383s-2.6666-2.4383-5.3331-2.4383c-2.6667 0-2.6667 2.4383-5.3334 2.4383s-2.6669-2.4383-5.3338-2.4383c-2.6666 0-2.6666 2.4383-5.3331 2.4383-2.6662 0-2.6662-2.4383-5.3329-2.4383s-2.6668 2.4383-5.3337 2.4383-2.6669-2.4383-5.3338-2.4383c-1.8417 0-2.4116 1.163-3.4666 1.8826C13.0674 59.4095 21.9972 64 32 64m26.6662-27.9187c-2.6666 0-2.6666-2.4382-5.3333-2.4382s-2.6667 2.4382-5.3332 2.4382-2.6666-2.4382-5.3331-2.4382S40 36.0813 37.3332 36.0813c-2.6667 0-2.6668-2.4382-5.3337-2.4382-2.6666 0-2.6666 2.4382-5.3331 2.4382-2.6663 0-2.6663-2.4382-5.3329-2.4382-2.6669 0-2.6669 2.4382-5.3337 2.4382s-2.6669-2.4382-5.3338-2.4382c-2.6663 0-2.6663 2.4382-5.3329 2.4382-2.6522 0-2.6676-2.4114-5.2915-2.4371a32 32 0 0 0 .5129 4.306c2.1255.3124 2.3116 2.3977 4.7787 2.3977 2.6667 0 2.6667-2.438 5.3329-2.438 2.6669 0 2.6669 2.438 5.3338 2.438s2.6669-2.438 5.3337-2.438c2.6667 0 2.6667 2.438 5.3329 2.438 2.6666 0 2.6666-2.438 5.3331-2.438 2.6669 0 2.6669 2.438 5.3338 2.438 2.6668 0 2.6669-2.438 5.3334-2.438s2.6666 2.438 5.3331 2.438 2.6666-2.438 5.3331-2.438c2.6669 0 2.6669 2.438 5.3334 2.438 2.4674 0 2.6535-2.0852 4.7791-2.3976a32.05 32.05 0 0 0 .5131-4.306c-2.6243.0259-2.64 2.437-5.2924 2.437m-5.3333 5.9097c-2.6667 0-2.6667 2.4382-5.3332 2.4382s-2.6666-2.4382-5.3331-2.4382S40 44.4292 37.3332 44.4292s-2.6668-2.4382-5.3337-2.4382c-2.6666 0-2.6666 2.4382-5.3331 2.4382-2.6663 0-2.6663-2.4382-5.3329-2.4382-2.6669 0-2.6669 2.4382-5.3338 2.4382-2.6668 0-2.6668-2.4382-5.3337-2.4382-2.6663 0-2.6663 2.4382-5.3329 2.4382-1.9053 0-2.4496-1.2445-3.5777-1.9555A31.84 31.84 0 0 0 4.66 48.6372c.2046.0378.4274.0586.6731.0586 2.6666 0 2.6666-2.438 5.3329-2.438 2.6669 0 2.6669 2.438 5.3337 2.438s2.6669-2.438 5.3338-2.438c2.6666 0 2.6666 2.438 5.3329 2.438 2.6666 0 2.6666-2.438 5.3331-2.438 2.6669 0 2.6669 2.438 5.3337 2.438s2.6669-2.438 5.3334-2.438 2.6666 2.438 5.3331 2.438 2.6667-2.438 5.3332-2.438c2.6668 0 2.6668 2.438 5.3333 2.438.246 0 .4688-.0208.6734-.0587a31.86 31.86 0 0 0 2.9049-6.1633c-1.1283.7107-1.6726 1.9554-3.5783 1.9554-2.6665 0-2.6665-2.4382-5.3333-2.4382"
      />
      <path
        fill="#fff"
        d="M63.9007 29.472c-2.5662.0606-2.6016 2.4355-5.2345 2.4355-2.6666 0-2.6666-2.4383-5.3333-2.4383s-2.6667 2.4383-5.3332 2.4383-2.6666-2.4383-5.3331-2.4383S40 31.9075 37.3332 31.9075c-2.6667 0-2.6668-2.4383-5.3337-2.4383-2.6666 0-2.6666 2.4383-5.3331 2.4383-2.6663 0-2.6663-2.4383-5.3329-2.4383-2.6669 0-2.6669 2.4383-5.3337 2.4383s-2.6669-2.4383-5.3338-2.4383c-2.6663 0-2.6663 2.4383-5.3329 2.4383-2.6323 0-2.668-2.3746-5.234-2.4355A32.5 32.5 0 0 0 0 32.0001c0 .5829.0165 1.162.0476 1.7371 2.6179.0294 2.6353 2.4368 5.2856 2.4368C8 36.174 8 33.736 10.6662 33.736c2.6669 0 2.6669 2.438 5.3338 2.438 2.6668 0 2.6669-2.438 5.3337-2.438 2.6667 0 2.6666 2.438 5.3329 2.438 2.6666 0 2.6666-2.438 5.3331-2.438 2.6669 0 2.6669 2.438 5.3338 2.438 2.6668 0 2.6669-2.438 5.3334-2.438S45.3335 36.174 48 36.174s2.6666-2.438 5.3331-2.438c2.6669 0 2.6669 2.438 5.3334 2.438 2.6506 0 2.668-2.4074 5.2864-2.4368A32.6 32.6 0 0 0 64 32.0001c0-.8509-.034-1.6939-.0993-2.5281"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ki',
  64
);

export const KmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M63.9989 31.9073H29.3101c-6.8871 6.8873-11.0518 12.2044-15.3043 16.4569l18.087 1.63 28.0667-2.7826C62.6089 42.6872 64 37.5061 64 32c0-.031-.0011-.0617-.0011-.0927"
      />
      <path
        fill="#ffda44"
        d="M14.0059 16.603h46.0515C54.6151 6.707 44.0914 0 32 0 23.1869 0 15.2074 3.5639 9.4205 9.328z"
      />
      <path
        fill="#0052b4"
        d="M15.3971 47.2117c-2.8767 2.8767-3.9885 5.287-6.0698 7.3682C15.1216 60.3983 23.1398 64 32 64c12.167 0 22.7475-6.7906 28.1596-16.7883z"
      />
      <path
        fill="#6da544"
        d="M9.3725 9.28c-12.4967 12.4967-12.4967 32.758 0 45.2549L32 31.9074z"
      />
      <path
        fill="#fff"
        d="M8.4406 31.9073c0-4.6622 3.2767-8.5571 7.6522-9.5126a9.77 9.77 0 0 0-2.087-.2265c-5.379 0-9.7392 4.3603-9.7392 9.7391s4.3603 9.7392 9.7392 9.7392a9.78 9.78 0 0 0 2.087-.2265c-4.3755-.9557-7.6522-4.8504-7.6522-9.5127"
      />
      <path
        fill="#fff"
        d="m15.9854 23.5594.5181 1.5943h1.6763l-1.3563.9854.5181 1.5942-1.3562-.9852-1.3563.9852.5182-1.5942-1.3563-.9854h1.6763zm0 4.174.5181 1.5944h1.6763l-1.3563.9852.5181 1.5944-1.3562-.9854-1.3563.9854.5182-1.5944-1.3563-.9852h1.6763z"
      />
      <path
        fill="#fff"
        d="m15.9854 31.9073.5181 1.5943h1.6763l-1.3563.9854.5181 1.5942-1.3562-.9854-1.3563.9854.5182-1.5942-1.3563-.9854h1.6763zm0 4.1739.5181 1.5942h1.6763l-1.3563.9854.5181 1.5943-1.3562-.9853-1.3563.9853.5182-1.5943-1.3563-.9854h1.6763z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Km',
  64
);

export const KrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M43.1304 32c0 2.7826-4.9833 9.7391-11.1304 9.7391S20.8696 34.7826 20.8696 32c0-6.1472 4.9833-11.1304 11.1304-11.1304S43.1304 25.8528 43.1304 32"
      />
      <path
        fill="#0052b4"
        d="M43.1304 32c0 6.1473-4.9833 11.1304-11.1304 11.1304S20.8696 38.1473 20.8696 32"
      />
      <path
        fill="#000"
        d="m43.7968 41.8384 2.9509-2.9509 1.9674 1.9673-2.951 2.9509zm-4.9197 4.9184 2.951-2.9509 1.9673 1.9673-2.9509 2.951zm10.8221.9832 2.9509-2.9509 1.9673 1.9673-2.9509 2.9509zm-4.9196 4.9192 2.9509-2.9509 1.9673 1.9673-2.9509 2.9509zm1.9683-7.8696 2.9509-2.951 1.9673 1.9673-2.9509 2.951zm-4.9184 4.9182 2.951-2.951 1.9673 1.9674-2.951 2.9509zm7.8827-27.5408-7.8692-7.8692 1.9673-1.9673 7.8692 7.8692zm-7.8706-1.9666-2.951-2.9509 1.9673-1.9672 2.9509 2.9509zm4.9182 4.9195-2.9509-2.951 1.9672-1.9672 2.951 2.9509zm.983-10.8225-2.9509-2.951 1.9673-1.9673 2.9509 2.9509zm4.921 4.9201-2.951-2.9509 1.9673-1.9673 2.951 2.9509zM11.3443 44.7839l7.8692 7.8692-1.9673 1.9673-7.8692-7.8691zm7.8688 1.9659 2.9509 2.9509-1.9672 1.9672-2.951-2.9509zm-4.9187-4.9173 2.9509 2.9509-1.9673 1.9674-2.9509-2.951zm2.9513-2.9519 7.8691 7.8692-1.9673 1.9673-7.8691-7.8692zm1.9669-27.5403-7.8691 7.8692-1.9673-1.9673 7.8691-7.8692zm2.951 2.9507-7.8691 7.8692-1.9674-1.9673 7.8692-7.8692zm2.9537 2.9529-7.8692 7.8692-1.9672-1.9673 7.8692-7.8691z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Kr',
  64
);

export const KwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M62.0096 43.1303C63.2959 39.6637 64 35.9142 64 31.9999s-.7041-7.6637-1.9904-11.1304L32 18.0869 1.9904 20.8695C.704 24.3362 0 28.0857 0 31.9999s.7041 7.6638 1.9904 11.1304L32 45.9129z"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7588 0 25.4883-8.684 30.0095-20.8696H1.9903C6.5118 55.316 18.241 64 32 64"
      />
      <path
        fill="#6da544"
        d="M32 0C18.241 0 6.5118 8.684 1.9903 20.8696h60.0193C57.4883 8.684 45.7588 0 32 0"
      />
      <path
        fill="#000"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255l11.497-11.497V20.8697z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Kw',
  64
);

export const KyIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 32.0001H32v-.0857q-.0427.043-.0856.0857" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#6da544"
        d="M45.913 23.6522c3.0736 0 5.5652-2.4916 5.5652-5.5652s-2.4916-5.5653-5.5652-5.5653-5.5653 2.4917-5.5653 5.5653 2.4917 5.5652 5.5653 5.5652"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1658 7.0107-12.0155 12.0155V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32 28.0648 20.6306 16.6957h-3.935v.0002l15.3042 15.304H32zm4.1739-11.3692h19.4782v8.3478H36.1739z"
      />
      <path
        fill="#ffda44"
        d="M36.1739 37.5653v5.5653h2.928c1.7556 1.7205 4.1587 2.7826 6.8111 2.7826s5.0555-1.0621 6.8111-2.7826h2.928v-5.5653z"
      />
      <path
        fill="#338af3"
        d="M36.1739 23.6521V32c0 7.4549 9.7391 9.7391 9.7391 9.7391S55.6521 39.4549 55.6521 32v-8.3479z"
      />
      <path
        fill="#f3f3f3"
        d="M45.9125 28.1111c-2.4346 0-2.4346 2.2261-4.8692 2.2261s-2.4347-2.2261-4.8693-2.2261v3.8956c2.4346 0 2.4346 2.2261 4.8693 2.2261s2.4346-2.2261 4.8692-2.2261c2.4349 0 2.4349 2.2261 4.8699 2.2261s2.4349-2.2261 4.8699-2.2261v-3.8956c-2.4349 0-2.4349 2.2261-4.8699 2.2261s-2.435-2.2261-4.8699-2.2261m0-7.7981c-2.4346 0-2.4346 2.2261-4.8692 2.2261s-2.4347-2.2261-4.8693-2.2261v3.8956c2.4346 0 2.4346 2.2261 4.8693 2.2261s2.4346-2.2261 4.8692-2.2261c2.4349 0 2.4349 2.2261 4.8699 2.2261s2.4349-2.2261 4.8699-2.2261V20.313c-2.4349 0-2.4349 2.2261-4.8699 2.2261s-2.435-2.2261-4.8699-2.2261"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ky',
  64
);

export const KzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M50.087 32.3479H13.913c0 2.4974 2.1752 4.5218 4.6723 4.5218h-.1505c0 2.4973 2.0243 4.5217 4.5217 4.5217 0 2.4974 2.0244 4.5218 4.5218 4.5218h9.0435c2.4974 0 4.5217-2.0244 4.5217-4.5218 2.4974 0 4.5218-2.0244 4.5218-4.5217h-.1505c2.4968 0 4.6722-2.0244 4.6722-4.5218"
      />
      <path
        fill="#338af3"
        d="M44.5218 26.4348c0 6.9155-5.6063 12.5218-12.5218 12.5218s-12.5217-5.6063-12.5217-12.5218"
      />
      <path
        fill="#ffda44"
        d="m41.5644 26.4348-3.9082 1.8384 2.0812 3.785-4.2438-.8119-.5377 4.287L32 32.3802l-2.956 3.1531-.5376-4.287-4.2438.8116 2.081-3.7848-3.908-1.8383 3.9081-1.8382-2.0811-3.7849 4.2436.8117.5379-4.287L32 20.4896l2.956-3.1532.5376 4.287 4.2439-.8117-2.0811 3.785z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Kz',
  64
);

export const LbIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0C19.3133 0 8.3513 7.3831 3.1753 18.087h57.6493C55.6488 7.3831 44.6866 0 32 0m0 64.0001c12.6866 0 23.6488-7.3831 28.8248-18.087H3.1753C8.3513 56.617 19.3133 64.0001 32 64.0001"
      />
      <path
        fill="#6da544"
        d="M40.3479 37.5654 32 22.261l-8.3479 15.3044h6.2609v4.1738h4.174v-4.1738z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lb',
  64
);

export const LcIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#f3f3f3" d="M20.1739 43.1304h23.6522L32 15.3044z" />
      <path fill="#333" d="M24.2839 40.3478 32 22.7966l7.7161 17.5512z" />
      <path fill="#ffda44" d="M20.1739 43.1304h23.6522L32 32z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lc',
  64
);

export const LiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32c1.3913 0 32-4.1739 32-4.1739z"
      />
      <path fill="#0052b4" d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32" />
      <path
        fill="#ffda44"
        d="M23.6521 22.2609c0-2.3051-1.8687-4.1739-4.1739-4.1739-1.0693 0-2.044.4025-2.7826 1.0636v-2.455h1.3913V13.913h-1.3913v-1.3912H13.913v1.3912h-1.3913v2.7826h1.3913v2.455c-.7386-.6611-1.7133-1.0636-2.7826-1.0636-2.3051 0-4.1739 1.8688-4.1739 4.1739 0 1.2359.5376 2.3459 1.3912 3.1102v2.455h13.913v-2.455c.8539-.7643 1.3914-1.8743 1.3914-3.1102"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Li',
  64
);

export const LkIcon = createSvgIcon(
  [
    <g key="0">
      <path fill="#ff9811" d="M.0001 5.5652H0v52.8695h.0001z" />
      <path
        fill="#ffda44"
        d="M31.9999 63.9999c17.6731 0 32-14.3269 32-32S49.673 0 31.9999 0 0 14.3269 0 31.9999s14.3269 32 31.9999 32"
      />
      <path
        fill="#ff9811"
        d="M25.0437 5.5652H13.9643a32 32 0 0 0-1.4424 1.0466L9.7393 32l2.7826 25.388c.4709.3618.9514.7111 1.4424 1.0466h11.0794z"
      />
      <path
        fill="#6da544"
        d="M.0001 32.0002c0 10.3432 4.9085 19.5384 12.5218 25.3881V6.6121C4.9086 12.4618.0001 21.657.0001 32.0002"
      />
      <path fill="#ffda44" d="M51.4783 19.5081v.8006l.0298.0045z" />
      <path
        fill="#a2001d"
        d="M61.4495 40.3478h-6.0291l-2.5507 2.7826v5.5652h-5.5652V45.913h2.7826v-5.5652H37.5653v3.4782h-2.7826v-6.6289c-.8538-.7642-1.3913-1.8744-1.3913-3.1102V16c0-2.3052 1.8688-4.1739 4.1739-4.1739v25.7391h5.5653l1.9095-1.5913a6.66 6.66 0 0 1-.5183-2.5825v-4.1739H40.348v-8.3478h8.3477c0-1.3912 2.087-2.7826 2.087-2.7826s2.087 1.3912 2.087 2.7826v8.3479c1.5479.0184 4.0072-.0217 6.664 0-.698-1.22-1.0988-2.6676-1.0988-4.1739 0-2.4551 1.06-4.6624 2.7472-6.1899-2.432-5.3894-6.3127-9.9846-11.1461-13.2886H29.2176v52.8696h20.8185c5.8774-4.0176 10.346-9.944 12.514-16.8863z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lk',
  64
);

export const LrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="M7.3145 11.6365h49.371a32.18 32.18 0 0 0-6.2846-5.8181H13.5991a32.17 32.17 0 0 0-6.2846 5.8181M0 31.9999c0 .9809.0466 1.9507.133 2.9092h63.734c.0864-.9585.133-1.9283.133-2.9092s-.0466-1.9506-.133-2.909H.133A32.4 32.4 0 0 0 0 31.9999m3.4895 14.5455h57.021a31.8 31.8 0 0 0 2.2845-5.818H1.205a31.8 31.8 0 0 0 2.2845 5.818m10.1096 11.6365h36.8016a32.18 32.18 0 0 0 6.2847-5.8181H7.3145a32.2 32.2 0 0 0 6.2846 5.8181M1.2049 23.2727H62.795a31.77 31.77 0 0 0-2.2846-5.8181H3.4895a31.8 31.8 0 0 0-2.2846 5.8181"
      />
      <path
        fill="#d80027"
        d="M15.3044 5.8181h35.0965C45.1959 2.1534 38.8496 0 32 0c-4.1739 0-11.4906 2.1534-16.6956 5.8181m15.3043 11.6365h29.9018a32.04 32.04 0 0 0-3.825-5.8181H30.6087zm0 11.6364H63.867c-.18-1.9978-.5418-3.9433-1.0719-5.8182H30.6087zM1.205 40.7274h61.59c.5302-1.8747.892-3.8203 1.072-5.8181H.133c.18 1.9978.5417 3.9433 1.072 5.8181m6.1095 11.6361h49.371a32.05 32.05 0 0 0 3.825-5.8181H3.4895a32.04 32.04 0 0 0 3.825 5.8181M32 64c6.8496 0 13.1959-2.1534 18.4009-5.8181H13.5991C18.8041 61.8466 25.1504 64 32 64"
      />
      <path
        fill="#0052b4"
        d="M1.2049 23.2728C.6746 25.1478.313 27.0931.133 29.0909H32V0C17.3525 0 5.0039 9.8415 1.2049 23.2728"
      />
      <path
        fill="#fff"
        d="m19.0485 8.3479 2.0719 6.3769h6.7057l-5.4247 3.9415 2.0717 6.3772-5.4246-3.9412-5.4249 3.9412 2.0723-6.3772-5.4248-3.9415h6.7054z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lr',
  64
);

export const LsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M0 31.9999c0 4.9863 1.1409 9.706 3.1753 13.913L32 47.3043l28.8247-1.3912C62.8591 41.7059 64 36.9862 64 31.9999s-1.1409-9.706-3.1753-13.913L32 16.6956 3.1753 18.0868C1.1408 22.2939 0 27.0137 0 31.9999"
      />
      <path
        fill="#6da544"
        d="M32 64.0001c12.6866 0 23.6487-7.3831 28.8247-18.087H3.1752C8.3512 56.617 19.3132 64.0001 32 64.0001"
      />
      <path
        fill="#0052b4"
        d="M32 0C19.3132 0 8.3512 7.3831 3.1752 18.087h57.6494C55.6487 7.3831 44.6866 0 32 0"
      />
      <path
        fill="#000"
        d="M34.087 31.3045v-7.6522h-4.1739v7.6522l-5.0412 5.0413c1.4661 2.4 4.11 4.0022 7.1282 4.0022 3.0183 0 5.662-1.6022 7.1283-4.0022z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ls',
  64
);

export const LtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#6da544"
        d="M62.0096 43.1304C63.296 39.6639 64 35.9143 64 32s-.704-7.6639-1.9904-11.1304L32 18.087 1.9904 20.8696C.704 24.3361 0 28.0858 0 32s.704 7.6639 1.9904 11.1304L32 45.913z"
      />
      <path
        fill="#ffda44"
        d="M62.0096 20.8696C57.4883 8.684 45.7589 0 32 0S6.5118 8.684 1.9904 20.8696z"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7589 0 25.4883-8.684 30.0096-20.8696H1.9904C6.5118 55.316 18.241 64 32 64"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lt',
  64
);

export const LuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0C18.2411 0 6.5118 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#338af3"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5118 55.316 18.241 64 32 64"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lu',
  64
);

export const LvIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="M32 0C17.2151 0 4.7744 10.0276 1.1024 23.6521h61.7953C59.2256 10.0276 46.7849 0 32 0m0 64c14.7849 0 27.2256-10.0276 30.8976-23.6521H1.1024C4.7744 53.9723 17.215 64 32 64"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lv',
  64
);

export const LyIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#000"
        d="M3.1753 18.0869C1.141 22.2939 0 27.0136 0 31.9999s1.141 9.706 3.1753 13.913L32 48.6956l28.8247-2.7827C62.859 41.7059 64 36.9863 64 31.9999s-1.141-9.706-3.1753-13.913L32 15.3043z"
      />
      <path
        fill="#496e2d"
        d="M3.1764 45.913C8.352 56.6168 19.3132 64 32 64c12.6866 0 23.6479-7.3832 28.8236-18.087z"
      />
      <path
        fill="#d80027"
        d="M3.1764 18.087h57.6472C55.6479 7.3831 44.6866 0 32 0 19.3132 0 8.3521 7.3831 3.1764 18.087"
      />
      <path
        fill="#fff"
        d="m39.4483 26.1483 2.6255 3.6181 4.2521-1.3787-2.6298 3.615 2.6253 3.618-4.2505-1.384-2.6298 3.615.0028-4.4701-4.2508-1.384 4.2523-1.3788z"
      />
      <path
        fill="#fff"
        d="M32.2826 41.0435c-4.9945 0-9.0435-4.049-9.0435-9.0435s4.049-9.0435 9.0435-9.0435c1.5573 0 3.0227.3938 4.3019 1.087-2.007-1.9626-4.7515-3.174-7.7801-3.174-6.1473 0-11.1304 4.9833-11.1304 11.1304s4.9833 11.1304 11.1304 11.1304c3.0287 0 5.7732-1.2114 7.7801-3.174-1.2794.6935-2.7445 1.0872-4.3019 1.0872"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ly',
  64
);

export const MaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M50.911 26.2612H36.4643L32 12.5217l-4.4642 13.7395H13.089l11.6876 8.4915-4.4643 13.7399L32 40.001l11.6878 8.4917-4.4644-13.7398zm-22.8632 7.4287 1.5096-4.6462h4.8851l1.5098 4.6462v.0001L32 36.5614zm5.4907-7.4287h-3.0769L32 21.5262zm4.7806 5.709-.9508-2.9263h4.9786zm-11.6875-2.9263-.9508 2.9263-4.0279-2.9263zm-1.0265 12.1637 1.5385-4.7349 2.4894 1.8085zm8.7619-2.9262 2.4894-1.8085 1.5385 4.7348z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ma',
  64
);

export const McIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#d80027" d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mc',
  64
);

export const MdIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M45.913 3.1753C41.706 1.141 36.9863 0 32 0s-9.706 1.141-13.913 3.1753L15.3044 32l2.7826 28.8247C22.294 62.859 27.0138 64 32 64s9.706-1.141 13.913-3.1753L48.6956 32z"
      />
      <path
        fill="#0052b4"
        d="M18.087 3.1764C7.3833 8.3523 0 19.3134 0 32s7.3833 23.6478 18.087 28.8236z"
      />
      <path
        fill="#d80027"
        d="M45.913 3.1764v57.6472C56.6167 55.6478 64 44.6866 64 32S56.6167 8.3523 45.913 3.1764"
      />
      <path
        fill="#ff9811"
        d="M43.1304 25.1773h-7.6521c0-1.921-1.5573-3.4782-3.4783-3.4782s-3.4782 1.5572-3.4782 3.4782h-7.6522c0 1.8914 1.6477 3.4245 3.5388 3.4245h-.114c0 1.8915 1.5332 3.4249 3.4247 3.4249 0 1.6746 1.2028 3.0661 2.7913 3.3636l-2.6988 6.0928A11.1 11.1 0 0 0 32 42.3008c1.4819 0 2.8953-.2921 4.1883-.8177l-2.6987-6.0928c1.5885-.2975 2.7913-1.689 2.7913-3.3636 1.8915 0 3.4247-1.5334 3.4247-3.4249h-.1141c1.8914 0 3.5389-1.5332 3.5389-3.4245"
      />
      <path
        fill="#0052b4"
        d="M32 29.913 27.4782 32v4.1739L32 38.9565l4.5217-2.7826V32z"
      />
      <path fill="#d80027" d="M27.4782 27.8261h9.0435V32h-9.0435z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Md',
  64
);

export const MeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="M64 32c0-10.9826-5.5336-20.6719-13.9641-26.4347H13.9641C5.5338 11.328 0 21.0174 0 32c0 10.9829 5.5338 20.6719 13.9641 26.4347h36.0718C58.4664 52.6719 64 42.9829 64 32"
      />
      <path
        fill="#ffda44"
        d="M25.0435 23.6521h13.913V18.087l-2.7826 1.3913L32 15.3044l-4.1739 4.1739-2.7826-1.3913zM44.5218 32h-6.9539c.2728-.4718.4313-1.0176.4313-1.6016 0-1.7734-1.4377-3.2108-3.2108-3.2108-1.2251 0-2.2891.6865-2.8305 1.6953-.5414-1.0089-1.6054-1.6953-2.8305-1.6953-1.7731 0-3.2107 1.4374-3.2107 3.2108 0 .5841.1587 1.13.4312 1.6016H19.478c0 2.1279 1.8534 3.8527 3.9812 3.8527h-.1283c0 1.7454 1.1609 3.2192 2.7525 3.6925l-3.1271 3.1274 2.9514 2.9514 4.1866-4.1866c.164.0601.3336.1081.509.1411l-2.5298 5.7119A10.4 10.4 0 0 0 32 48.057c1.3893 0 2.7142-.2736 3.9265-.7666l-2.5297-5.7119a3.2 3.2 0 0 0 .5087-.1411l4.1867 4.1866 2.9512-2.9514-3.1272-3.1272c1.5915-.4737 2.7525-1.9472 2.7525-3.6925h-.1284c2.128-.0002 3.9815-1.725 3.9815-3.8529"
      />
      <path
        fill="#6da544"
        d="m32 34.087-4.5217 2.0868v4.174L32 43.1303l4.5218-2.7825v-4.174z"
      />
      <path fill="#0052b4" d="M27.4783 32h9.0435v5.5653h-9.0435z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Me',
  64
);

export const MgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#6da544"
        d="M20.8696 32.0001v30.0096c3.4665 1.2864 7.2162 1.9904 11.1304 1.9904 17.673 0 32-14.327 32-32s-43.1304 0-43.1304 0"
      />
      <path
        fill="#d80027"
        d="M32 0c-3.9142 0-7.6639.7041-11.1304 1.9904V32H64C64 14.327 49.673 0 32 0"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mg',
  64
);

export const MkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M36.8665 63.6321c5.2045-.794 9.9952-2.8435 14.057-5.8272L32 32zM27.1334.368c-5.2044.794-9.9952 2.8434-14.0572 5.827L32 32zM13.0762 57.8049c4.0618 2.9836 8.8525 5.0331 14.0569 5.8274L32 32z"
      />
      <path
        fill="#d80027"
        d="M6.195 13.0764C3.2112 17.1384 1.162 21.929.3679 27.1335L32 32.0002z"
      />
      <path
        fill="#d80027"
        d="M.3679 36.8665c.794 5.2045 2.8435 9.9952 5.8272 14.057L32 32zm63.2642-9.7331c-.7941-5.2044-2.8435-9.9951-5.8272-14.057L32 32zM50.9235 6.195C46.8616 3.2112 42.071 1.162 36.8665.368L32 32zm6.8816 44.7286c2.9837-4.0618 5.033-8.8527 5.8273-14.057L32 32z"
      />
      <path
        fill="#d80027"
        d="M32 43.1304c6.1471 0 11.1304-4.9833 11.1304-11.1304S38.1471 20.8696 32 20.8696 20.8696 25.8529 20.8696 32 25.8529 43.1304 32 43.1304"
      />
      <path
        fill="#ffda44"
        d="M32 40.3478c4.6104 0 8.3478-3.7374 8.3478-8.3478S36.6104 23.6521 32 23.6521 23.6521 27.3896 23.6521 32 27.3896 40.3478 32 40.3478"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mk',
  64
);

export const MlIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M43.1304 1.9904C39.6637.704 35.9142 0 32 0s-7.6638.7041-11.1304 1.9904L18.087 32l2.7826 30.0096C24.3362 63.296 28.0857 64 32 64s7.6637-.704 11.1304-1.9904L45.913 32z"
      />
      <path
        fill="#d80027"
        d="M64 32c0-13.7588-8.684-25.4883-20.8696-30.0095v60.0194C55.316 57.4882 64 45.759 64 32"
      />
      <path
        fill="#6da544"
        d="M0 32c0 13.759 8.684 25.4882 20.8696 30.0097V1.9905C8.684 6.5117 0 18.2412 0 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ml',
  64
);

export const MmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#6da544"
        d="M62.0096 43.1304C63.296 39.6639 64 35.9143 64 32s-.704-7.6638-1.9904-11.1303L32 18.087 1.9904 20.8697C.704 24.3362 0 28.0858 0 32s.7041 7.6639 1.9904 11.1304L32 45.913z"
      />
      <path
        fill="#ffda44"
        d="M62.0096 20.8696C57.4883 8.684 45.7589 0 32 0S6.5118 8.684 1.9904 20.8696z"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7589 0 25.4883-8.684 30.0096-20.8696H1.9904C6.5118 55.316 18.241 64 32 64"
      />
      <path
        fill="#fff"
        d="M53.9436 27.0732H37.1802L32 11.1304l-5.1803 15.9428H10.0564l13.5618 9.8533-5.1802 15.9431L32 43.1304l13.562 9.7391-5.1801-15.9431z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mm',
  64
);

export const MnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M32 64c3.9143 0 7.6639-.704 11.1304-1.9904L44.5218 32 43.1305 1.9904C39.6639.704 35.9143 0 32 0s-7.6639.7041-11.1304 1.9904L19.4783 32l1.3912 30.0096C24.3361 63.296 28.0858 64 32 64"
      />
      <path
        fill="#a2001d"
        d="M0 32c0 13.7589 8.684 25.4882 20.8696 30.0096V1.9904C8.684 6.5117 0 18.241 0 32M43.1304 1.9904v60.0193C55.316 57.4882 64 45.7589 64 32S55.316 6.5117 43.1304 1.9904"
      />
      <path
        fill="#ffda44"
        d="M15.3044 32h2.7826v11.1304h-2.7826zM4.1739 32h2.7826v11.1304H4.174zm6.9565 6.9566c1.5368 0 2.7826-1.2458 2.7826-2.7826s-1.2458-2.7826-2.7826-2.7826-2.7826 1.2458-2.7826 2.7826 1.2458 2.7826 2.7826 2.7826m0-11.1305c.7684 0 1.3912-.6229 1.3912-1.3913s-.6228-1.3912-1.3912-1.3912-1.3913.6229-1.3913 1.3912.6229 1.3913 1.3913 1.3913M8.3479 40.3479h5.5653v2.7826H8.3479zm0-11.1305h5.5653V32H8.3479zm2.7825-12.5217.9855 3.0325h3.1885l-2.5794 1.8742.9848 3.0325-2.5794-1.8742-2.5792 1.8742.9847-3.0325-2.5794-1.8742h3.1885z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mn',
  64
);

export const MoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#496e2d"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="M37.5653 30.6656c-.7855 0-1.5313.1566-2.2238.4059.3794-.8455.6338-1.7863.6338-2.7909 0-3.9751-3.9752-6.9565-3.9752-6.9565s-3.9751 2.9814-3.9751 6.9565c0 1.0045.2544 1.9454.6338 2.7909-.6927-.249-1.4384-.4059-2.2238-.4059-3.9751 0-6.9565 3.9751-6.9565 3.9751s2.9814 3.9753 6.9565 3.9753c2.3306 0 4.3184-1.366 5.5653-2.4968 1.2468 1.1306 3.2346 2.4968 5.5652 2.4968 3.9751 0 6.9565-3.9753 6.9565-3.9753s-2.9816-3.9751-6.9567-3.9751"
      />
      <path
        fill="#ffda44"
        d="m32 12.5217.8212 2.527h2.6571l-2.1494 1.562.8205 2.527L32 17.5757l-2.1493 1.562.8205-2.527-2.1494-1.562h2.6571zm-10.1041 4.42 1.5797 1.4222 1.8409-1.0628-.8645 1.9419 1.5796 1.4225-2.114-.2222-.8645 1.9418-.4422-2.0791-2.1139-.2222 1.8408-1.063zm-7.3966 7.3966 2.0792.4419 1.0629-1.8409.2222 2.1139 2.079.4423-1.9417.8646.2222 2.1137-1.4226-1.5793-1.9417.8645 1.0628-1.841zm27.6048-7.3966-1.5796 1.4222-1.8409-1.0628.8644 1.9419-1.5795 1.4225 2.114-.2222.8645 1.9418.4423-2.0791 2.1138-.2222-1.8407-1.063zm7.3968 7.3966-2.0793.4419-1.0627-1.8409-.2224 2.1139-2.079.4423 1.9417.8646-.2222 2.1137 1.4226-1.5793 1.9418.8645-1.0629-1.841z"
      />
      <path
        fill="#fff"
        d="M32 49.7465c3.1576 0 6.0681-1.0535 8.4029-2.8261H23.5972c2.3348 1.7725 5.2452 2.8261 8.4028 2.8261m-12.7542-8.3478c.4417 1.0107 1.0017 1.9574 1.6594 2.8261H43.095c.6577-.8686 1.2177-1.8154 1.6594-2.8261z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mo',
  64
);

export const MqIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M63.7257 27.826c-.8827-6.7482-3.914-13.269-9.0984-18.4533C49.443 4.1883 42.9221 1.1569 36.1738.2742l.0002 27.5518zM27.826.2742c-6.7483.8827-13.2691 3.914-18.4535 9.0984S1.1569 21.0778.274 27.8263l27.552-.0001zM.2741 36.1741c.8828 6.7482 3.9141 13.2692 9.0984 18.4535s11.7051 8.2155 18.4536 9.0986l-.0001-27.5519zM36.174 63.7258c6.7483-.8827 13.269-3.914 18.4534-9.0984s8.2156-11.7051 9.0984-18.4533H36.174z"
      />
      <path
        fill="#fff"
        d="M42.9237 20.3047c0-.4255.3458-.7714.7715-.7714h1.653c2.613 0 4.7388-2.1257 4.7388-4.7386s-2.1257-4.7387-4.7388-4.7387h-1.5698c-.5124-.385-1.1997-.6223-1.958-.6223-1.5816 0-2.8637 1.0256-2.8637 2.2909 0 1.253 1.2576 2.2695 2.8181 2.2892l-.0008.0092h3.5742c.4256 0 .7715.346.7715.7715s-.3459.7713-.7715.7713h-1.653c-2.613 0-4.7387 2.1258-4.7387 4.7387s2.1255 4.7387 4.7387 4.7387h6.3917V21.076h-6.3917a.772.772 0 0 1-.7715-.7713m-25.0434 0c0-.4255.3458-.7714.7715-.7714h1.653c2.613 0 4.7388-2.1257 4.7388-4.7386s-2.1257-4.7387-4.7388-4.7387H18.735c-.5124-.385-1.1997-.6223-1.958-.6223-1.5816 0-2.8637 1.0256-2.8637 2.2909 0 1.253 1.2576 2.2695 2.8181 2.2892l-.0008.0092h3.5743c.4256 0 .7715.346.7715.7715s-.3459.7713-.7715.7713h-1.653c-2.613 0-4.7386 2.1258-4.7386 4.7387s2.1255 4.7387 4.7386 4.7387h6.3916V21.076h-6.3917a.772.772 0 0 1-.7715-.7713m25.0434 29.5227c0-.4255.3458-.7714.7715-.7714h1.653c2.613 0 4.7388-2.1257 4.7388-4.7386s-2.1257-4.7387-4.7388-4.7387h-1.5698c-.5124-.3849-1.1997-.6223-1.958-.6223-1.5817 0-2.8639 1.0258-2.8639 2.2909 0 1.253 1.2577 2.2695 2.8182 2.2892l-.0008.0092h3.5741c.4257 0 .7715.346.7715.7715s-.3458.7713-.7715.7713h-1.653c-2.613 0-4.7386 2.1258-4.7386 4.7387s2.1255 4.7387 4.7386 4.7387h6.3919v-3.9671h-6.3917c-.4257.0001-.7715-.346-.7715-.7714m-25.0434 0c0-.4255.3458-.7714.7715-.7714h1.653c2.613 0 4.7388-2.1257 4.7388-4.7386s-2.1257-4.7387-4.7388-4.7387H18.735c-.5124-.3849-1.1997-.6223-1.958-.6223-1.5817 0-2.8639 1.0258-2.8639 2.2909 0 1.253 1.2577 2.2695 2.8182 2.2892l-.0008.0092h3.5743c.4256 0 .7715.346.7715.7715s-.3459.7713-.7715.7713h-1.653c-2.613 0-4.7387 2.1258-4.7387 4.7387s2.1255 4.7387 4.7387 4.7387h6.3917v-3.9671h-6.3917c-.4257.0001-.7715-.346-.7715-.7714"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mq',
  64
);

export const MrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#496e2d"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M32 36.9689c-5.3282 0-9.7795-3.7448-10.8716-8.7454a11.17 11.17 0 0 0-.2588 2.3851c0 6.1474 4.9832 11.1304 11.1304 11.1304 6.1473 0 11.1304-4.9831 11.1304-11.1304 0-.8192-.091-1.6163-.2588-2.3852-1.0921 5.0009-5.5433 8.7455-10.8716 8.7455"
      />
      <path
        fill="#ffda44"
        d="m31.9999 22.2609 1.036 3.1886h3.3529l-2.7124 1.9706 1.036 3.1886-2.7125-1.9707-2.7124 1.9707 1.0361-3.1886-2.7123-1.9706h3.3526z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mr',
  64
);

export const MsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 32.0001H32v-.0857q-.0427.043-.0856.0857" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1658 7.0107-12.0155 12.0155V32h8.3478V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32 28.0648 20.6306 16.6957h-3.935v.0002l15.3042 15.304H32z"
      />
      <path
        fill="#338af3"
        d="M36.1739 16.6957v15.3042c0 7.455 9.7391 9.7393 9.7391 9.7393s9.7391-2.2843 9.7391-9.7393V16.6957z"
      />
      <path
        fill="#a2001d"
        d="M36.1739 31.9999c0 7.455 9.7391 9.7392 9.7391 9.7392s9.7391-2.2842 9.7391-9.7392z"
      />
      <path
        fill="#000"
        d="M50.087 23.6524h-2.7828v-2.7828h-2.7826v2.7828h-2.7825v2.7825h2.7825v8.3477h2.7826v-8.3477h2.7828z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ms',
  64
);

export const MtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#d80027" d="M32 0c17.673 0 32 14.327 32 32S49.673 64 32 64" />
      <path
        fill="#acabb1"
        d="M22.2609 12.5217V8.3479H18.087v4.1738h-4.174v4.1739h4.174v4.174h4.1739v-4.174h4.1739v-4.1739z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mt',
  64
);

export const MuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M3.8909 16.6956 32 19.4783l28.1091-2.7827C54.6817 6.7486 44.1294 0 32 0S9.3182 6.7486 3.8909 16.6956"
      />
      <path
        fill="#ffda44"
        d="M3.8909 47.3044 32 50.087l28.1091-2.7826C62.5896 42.758 64 37.5438 64 32l-32-2.7826L0 32c0 5.5438 1.4104 10.758 3.8909 15.3044"
      />
      <path
        fill="#0052b4"
        d="M3.8909 16.6957C1.4104 21.2421 0 26.4563 0 32.0001h64c0-5.5438-1.4104-10.758-3.8909-15.3044z"
      />
      <path
        fill="#6da544"
        d="M32 63.9999c12.1294 0 22.6817-6.7486 28.1091-16.6956H3.8909C9.3182 57.2513 19.8706 63.9999 32 63.9999"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mu',
  64
);

export const MwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M0 32c0 3.9143.7041 7.6638 1.9904 11.1304L32 44.5218l30.0096-1.3913C63.296 39.6638 64 35.9143 64 32s-.704-7.6637-1.9904-11.1304L32 19.4783 1.9904 20.8695C.704 24.3363 0 28.0858 0 32"
      />
      <path
        fill="#000"
        d="M32 0C18.2411 0 6.5117 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#496e2d"
        d="M62.0096 43.1304H1.9904C6.5117 55.3159 18.241 64 32 64s25.4882-8.6841 30.0096-20.8696"
      />
      <path
        fill="#d80027"
        d="m41.5644 15.3044-3.908-1.8382 2.0811-3.7849-4.2438.8119-.5377-4.2873L32 9.3591l-2.9559-3.1532-.5379 4.2873-4.2436-.8119 2.0811 3.7849-3.9081 1.8382z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mw',
  64
);

export const MxIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M64 32c0-12.6868-7.3831-23.6488-18.087-28.8248v57.6494C56.6169 55.6487 64 44.6867 64 32"
      />
      <path
        fill="#6da544"
        d="M0 32c0 12.6867 7.3831 23.6487 18.087 28.8247V3.1752C7.3831 8.3512 0 19.3132 0 32m23.6521 0c0 4.6103 3.7375 8.3478 8.3479 8.3478S40.3479 36.6103 40.3479 32v-2.7827H23.6521z"
      />
      <path
        fill="#ff9811"
        d="M43.1304 26.4347h-8.3479c0-1.5367-1.2459-2.7826-2.7826-2.7826s-2.7826 1.2459-2.7826 2.7826h-8.3479c0 1.5369 1.3386 2.7827 2.8752 2.7827h-.0926c0 1.5368 1.2458 2.7826 2.7826 2.7826 0 1.5368 1.2458 2.7826 2.7827 2.7826h5.5652c1.5369 0 2.7826-1.2458 2.7826-2.7826 1.5369 0 2.7827-1.2458 2.7827-2.7826h-.0928c1.5369 0 2.8754-1.2458 2.8754-2.7827"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mx',
  64
);

export const MyIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M30.6087 32.0001H64c0-2.8884-.385-5.6861-1.1024-8.3479H30.6087zm0-16.6957h28.6945a32.17 32.17 0 0 0-7.3836-8.3479H30.6087zM32 64.0001c7.5311 0 14.4533-2.603 19.9196-6.9565H12.0804C17.5468 61.3971 24.4689 64.0001 32 64.0001M4.6967 48.6957h54.6065a31.8 31.8 0 0 0 3.5944-8.3479H1.1024a31.8 31.8 0 0 0 3.5943 8.3479"
      />
      <path fill="#0052b4" d="M32 32V0C14.327 0 0 14.327 0 32z" />
      <path
        fill="#ffda44"
        d="M21.2793 27.3913c-4.3703 0-7.913-3.5429-7.913-7.913s3.5428-7.913 7.913-7.913c1.3626 0 2.6447.3446 3.7641.9511-1.756-1.7171-4.1575-2.7771-6.8076-2.7771-5.3787 0-9.7392 4.3603-9.7392 9.7391 0 5.3787 4.3605 9.7391 9.7392 9.7391 2.6501 0 5.0516-1.06 6.8076-2.7771-1.1194.6062-2.4014.9509-3.7641.9509"
      />
      <path
        fill="#ffda44"
        d="m23.5092 13.913 1.4048 2.9377 3.1727-.733-1.4208 2.9299 2.5515 2.0234-3.1767.7161.0088 3.2564-2.5403-2.0373-2.5405 2.0373.0087-3.2564-3.1767-.7161 2.5515-2.0234-1.4209-2.9299 3.1729.733z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'My',
  64
);

export const MzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M17.2964 44.5217 9.3736 54.6264C15.1641 60.4176 23.1633 64 32 64c13.2288 0 24.5805-8.0286 29.4539-19.4783z"
      />
      <path
        fill="#496e2d"
        d="M61.5036 19.5941C56.6575 8.0828 45.2735 0 32 0 23.1633 0 15.1641 3.5824 9.3736 9.3736l8.0138 10.2205z"
      />
      <path
        fill="#000"
        d="M6.9565 23.5363v16.8115h55.9413C63.6155 37.6864 64 34.8884 64 32c0-2.9302-.3947-5.7677-1.1326-8.4637z"
      />
      <path
        fill="#a2001d"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#ffda44"
        d="m12.9513 23.6521 2.0718 6.377h6.7058l-5.4248 3.9415 2.0718 6.3772-5.4246-3.9413-5.425 3.9413 2.0723-6.3772-5.4247-3.9415h6.7052z"
      />
      <path fill="#fff" d="M6.8884 32h12.128v5.5653H6.8884z" />
      <path
        fill="#000"
        d="m21.3125 25.6199-1.9676-1.9678-6.3935 6.3935-6.3935-6.3935-1.9677 1.9678 6.3992 6.3877-6.3992 6.3993 1.9677 1.9409 6.3935-6.382 6.3935 6.382 1.9676-1.9409-6.3991-6.3993z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Mz',
  64
);

export const NaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="M9.3726 54.6275a32.2 32.2 0 0 0 4.277 3.5935l44.5711-44.5712a32.17 32.17 0 0 0-3.5935-4.277 32.2 32.2 0 0 0-4.277-3.5934L5.7792 50.3507a32.2 32.2 0 0 0 3.5934 4.2768"
      />
      <path
        fill="#0052b4"
        d="M9.3726 9.3725C-.7229 19.468-2.6609 34.6295 3.5546 46.6722L46.6722 3.5546C34.6295-2.6608 19.4679-.7225 9.3726 9.3725"
      />
      <path
        fill="#496e2d"
        d="M54.6274 54.6275c10.0952-10.0952 12.0332-25.2569 5.8181-37.2997L17.3278 60.4455c12.0426 6.2154 27.2042 4.2774 37.2996-5.818"
      />
      <path
        fill="#ffda44"
        d="m26.4347 18.087-3.5857 1.6866 1.9095 3.4728-3.8937-.7448-.4935 3.9332-2.712-2.8929-2.7121 2.8929-.4932-3.9332-3.8938.7447 1.9094-3.4728L8.884 18.087l3.5857-1.6867-1.9095-3.4725 3.8936.7447.4935-3.9334 2.712 2.893 2.7122-2.893.4933 3.9334 3.8937-.7447-1.9093 3.4726z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Na',
  64
);

export const NeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M3.1753 18.0871C1.141 22.2941 0 27.0137 0 32.0001s1.141 9.706 3.1753 13.913L32 48.6957l28.8247-2.7826C62.859 41.7061 64 36.9864 64 32.0001s-1.141-9.706-3.1753-13.913L32 15.3044z"
      />
      <path
        fill="#6da544"
        d="M3.1764 45.9131C8.352 56.617 19.3132 64.0001 32 64.0001s23.6479-7.3831 28.8236-18.087z"
      />
      <path
        fill="#ff9811"
        d="M3.1764 18.087h57.6472C55.6479 7.3831 44.6866 0 32 0S8.3521 7.3831 3.1764 18.087M32 43.1304c6.1471 0 11.1303-4.9833 11.1303-11.1304S38.1471 20.8696 32 20.8696 20.8696 25.8529 20.8696 32 25.8528 43.1304 32 43.1304"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ne',
  64
);

export const NfIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M45.913 3.1753C41.706 1.141 36.9864 0 32 0s-9.706 1.141-13.913 3.1753L15.3044 32l2.7826 28.8247C22.294 62.859 27.0136 64 32 64s9.706-1.141 13.913-3.1753L48.6956 32z"
      />
      <path
        fill="#6da544"
        d="M18.087 3.1763C7.3831 8.352 0 19.313 0 31.9999s7.3831 23.6479 18.087 28.8236zm27.826 0v57.6472C56.6169 55.6478 64 44.6865 64 31.9999S56.6169 8.352 45.913 3.1763m-5.5652 38.5626L32 15.3042l-8.3479 26.4347h6.2609v6.9565h4.174v-6.9565z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Nf',
  64
);

export const NgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#6da544"
        d="M0 32c0 13.759 8.684 25.4882 20.8696 30.0097V1.9905C8.684 6.5117 0 18.2412 0 32m64 0c0-13.7588-8.684-25.4883-20.8696-30.0095v60.0194C55.316 57.4882 64 45.759 64 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ng',
  64
);

export const NiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#338af3"
        d="M32 0C19.3132 0 8.3513 7.3831 3.1753 18.087h57.6493C55.6487 7.3831 44.6866 0 32 0m0 64.0001c12.6866 0 23.6487-7.3831 28.8247-18.087H3.1753C8.3512 56.617 19.3131 64.0001 32 64.0001"
      />
      <path
        fill="#ffda44"
        d="M32 22.261c-5.3787 0-9.7391 4.3604-9.7391 9.7391S26.6213 41.7392 32 41.7392s9.7391-4.3603 9.7391-9.7391c0-5.3787-4.3603-9.7391-9.7391-9.7391m0 15.3044c-3.0735 0-5.5652-2.4915-5.5652-5.5653S28.9264 26.4349 32 26.4349s5.5653 2.4915 5.5653 5.5652S35.0735 37.5654 32 37.5654"
      />
      <path
        fill="#0052b4"
        d="M36.8197 33.3913 32 32l-4.8198 1.3913-1.6065 2.7826h12.8524z"
      />
      <path fill="#338af3" d="m32 25.0435-3.2131 5.5652L32 32l3.2131-1.3913z" />
      <path
        fill="#6da544"
        d="M27.1803 33.3911h9.6395l-1.6067-2.7825h-6.4262z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ni',
  64
);

export const NlIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M31.9883 64c17.6731 0 32-14.3269 32-32s-14.3269-32-32-32-32 14.3269-32 32 14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="M31.9883 0C18.2294 0 6.5 8.684 1.9786 20.8696H61.998C57.4765 8.684 45.7471 0 31.9883 0"
      />
      <path
        fill="#0052b4"
        d="M31.9883 64c13.7588 0 25.4882-8.684 30.0096-20.8696H1.9786C6.5 55.316 18.2294 64 31.9883 64"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Nl',
  64
);

export const NoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M1.1024 40.3479c1.8515 6.8698 5.932 12.8241 11.4193 17.0402V40.3479zm28.1149 23.5303C30.1346 63.9572 31.0622 64 32 64c14.7848 0 27.2256-10.0276 30.8976-23.6521H29.2173zm33.6803-40.2261C59.2256 10.0276 46.7848 0 32 0a32.4 32.4 0 0 0-2.7827.1218V23.652zM12.5217 6.6119C7.0345 10.828 2.9539 16.7823 1.1024 23.652h11.4193z"
      />
      <path
        fill="#0052b4"
        d="M63.7291 27.8261H25.0435V.7606a31.78 31.78 0 0 0-8.3479 3.1303V27.826H.2709A32.3 32.3 0 0 0 0 32c0 1.4146.0928 2.8076.2709 4.1739h16.4247V60.109a31.78 31.78 0 0 0 8.3479 3.1302V36.174h38.6856A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1739"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'No',
  64
);

export const NpIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="m63.8122 35.4781-.0008-.001-.0001.001zm-.001 0 .0002-.001L28.7183.1663a31.9 31.9 0 0 0-4.6387.8217C10.2372 4.5124 0 32 0 32s44.7998 29.9794 49.9106 26.5205a32.1 32.1 0 0 0 2.9367-2.2441L32.0494 35.4781z"
      />
      <path
        fill="#d80027"
        d="M55.6521 32 24.5306.8787C10.461 4.2433 0 16.899 0 32c0 17.673 14.327 32 32 32 6.7036 0 12.9246-2.0627 18.0661-5.5861L23.6521 32z"
      />
      <path
        fill="#fff"
        d="m30.434 47.2491-3.9081-1.8382 2.0811-3.7849-4.2438.8119-.5377-4.2873-2.9559 3.1532-2.9559-3.1532-.5378 4.2873-4.2437-.812 2.0812 3.785-3.9083 1.8382 3.9083 1.8382-2.0812 3.785 4.2439-.8118.5375 4.287 2.956-3.1531 2.9559 3.1531.5377-4.287 4.2437.8119-2.0812-3.7849zm-2.6079-29.5012-2.8425-1.3369 1.5136-2.7529-3.0866.5905-.3911-3.1182-2.1499 2.2933-2.1499-2.2933-.3912 3.1182-3.0867-.5905 1.5138 2.7529-2.8426 1.3369 6.9566 1.3915z"
      />
      <path
        fill="#fff"
        d="M29.2174 17.7478c0 4.6104-3.7375 8.3479-8.3479 8.3479s-8.3479-3.7375-8.3479-8.3479"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Np',
  64
);

export const NrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 0C15.2645 0 1.5323 12.8476.1219 29.2174h63.7564C62.4678 12.8476 48.7355 0 32 0m0 64.0001c16.7355 0 30.4678-12.8476 31.8783-29.2174H.1219C1.5323 51.1525 15.2645 64.0001 32 64.0001"
      />
      <path
        fill="#fff"
        d="m26.4348 43.1305-3.5857 1.6867 1.9094 3.4726-3.8937-.7448-.4933 3.9333-2.7122-2.8928-2.712 2.8928-.4933-3.9333-3.8938.7447 1.9095-3.4726-3.5857-1.6866 3.5858-1.6867-1.9096-3.4725 3.8936.7448.4937-3.9334 2.7118 2.8929 2.7123-2.8929.4932 3.9334 3.8938-.7448-1.9094 3.4727z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Nr',
  64
);

export const NuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 15.3044v10.7929L20.8696 15.3044zM16.6956 32h9.4014l-9.4014-12.5217-1.3912 9.7391z"
      />
      <path fill="#fff" d="M31.9144 31.9999H32v-.0856z" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M32 28.0649 20.6306 16.6958h-3.935v.0003l15.3041 15.304H32z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738a32.1 32.1 0 0 0-3.5395 2.34h1.313l-3.4703 2.5218 1.3253 4.0796-3.4703-2.5212-.3692.2683a32.1 32.1 0 0 0-3.8045 5.327V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#0052b4"
        d="M13.67 5.769q-.5178.3625-1.0205.745l-2.1569 2.5217-2.145 1.5582-.3724.2705A32.2 32.2 0 0 0 5.769 13.67a5.89 5.89 0 0 0 2.5787.5909c3.2658 0 5.913-2.6472 5.913-5.913A5.884 5.884 0 0 0 13.67 5.769"
      />
      <path
        fill="#ffda44"
        d="m7.9753 10.8644.3724-.2705 3.4703 2.5214-1.3254-4.0796 3.47-2.5218h-1.3133a32.2 32.2 0 0 0-4.674 4.3505m14.1425-5.2992.6907 2.1256h2.235l-1.8081 1.3139.6904 2.1256-1.808-1.3137-1.8082 1.3137.6903-2.1256-1.8081-1.3139h2.2351zM8.3479 19.4783l.6907 2.1256h2.235l-1.808 1.314.6904 2.1256-1.8081-1.3139-1.8083 1.3139.6904-2.1256-1.808-1.314h2.235z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Nu',
  64
);

export const NzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 32H32v-.0856z" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.324.003 0 14.3286 0 32h16.6956v-9.4014L26.0971 32h5.8174l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1739c-5.0049 2.8499-9.1656 7.0106-12.0155 12.0155V32h8.3479V12.5218H32v-8.348z"
      />
      <path
        fill="#d80027"
        d="M32 28.0649 20.6309 16.6957s-3.9352.0003-3.9352 0v.0003L31.9999 32H32zm23.4162-4.32.6907 2.1257h2.2351l-1.8083 1.3138.6908 2.1256-1.8083-1.3136-1.8083 1.3136.6907-2.1256-1.8084-1.3138h2.2352zm-7.9898 15.3042 1.0361 3.1888h3.3527l-2.7125 1.9705 1.0362 3.1886-2.7125-1.9706-2.7125 1.9706 1.0363-3.1886-2.7125-1.9705h3.3526zm.3018-25.0434.8635 2.6574h2.7938L49.125 18.305l.8635 2.6572-2.2603-1.6423-2.2603 1.6423.8634-2.6572-2.2603-1.6419h2.7938zm-7.688 9.6465 1.036 3.1887h3.3528l-2.7125 1.9705L42.7527 32l-2.7125-1.9706L37.3277 32l1.0363-3.1886-2.7125-1.9705h3.3526z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Nz',
  64
);

export const OmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M0 32c0 12.1294 6.7488 22.6819 16.6956 28.1091V3.8909C6.7488 9.318 0 19.8706 0 32"
      />
      <path
        fill="#d80027"
        d="M62.0098 43.1304C63.296 39.6638 64 35.9143 64 32s-.704-7.6639-1.9902-11.1304H1.9905C.7041 24.3361 0 28.0858 0 32s.7041 7.6638 1.9905 11.1304L32 45.913z"
      />
      <path
        fill="#6da544"
        d="M32 64c13.759 0 25.4882-8.684 30.0097-20.8696H1.9905C6.5117 55.316 18.2412 64 32 64"
      />
      <path
        fill="#d80027"
        d="M0 31.9999c0 14.7849 10.0276 27.2256 23.6521 30.8976V1.1023C10.0276 4.7743 0 17.215 0 31.9999"
      />
      <path
        fill="#fff"
        d="m19.5771 14.0817-2.9513-2.9513-1.9675 1.9677-1.9675-1.9677-2.9514 2.9513 1.9676 1.9677-1.9679 1.9677 2.9514 2.9514 1.9676-1.9678 1.9677 1.9678 2.9513-2.9514-1.9676-1.9677z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Om',
  64
);

export const PaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#0052b4" d="M0 32c0 17.673 14.327 32 32 32V32z" />
      <path fill="#d80027" d="M32 0c17.673 0 32 14.327 32 32H32z" />
      <path
        fill="#0052b4"
        d="m19.0486 11.1304 2.0721 6.3772h6.7054l-5.4247 3.9413 2.072 6.3772-5.4248-3.9414-5.4247 3.9414 2.072-6.3772-5.4248-3.9413h6.7054z"
      />
      <path
        fill="#d80027"
        d="m44.9514 36.1738 2.0721 6.3773h6.7054l-5.4249 3.9412 2.0721 6.3773-5.4247-3.9414-5.4248 3.9414 2.072-6.3773-5.4247-3.9412h6.7054z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pa',
  64
);

export const PeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M64 32c0-13.7588-8.684-25.4883-20.8696-30.0095v60.0194C55.316 57.4882 64 45.759 64 32M0 32c0 13.759 8.684 25.4882 20.8696 30.0097V1.9905C8.684 6.5117 0 18.2412 0 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pe',
  64
);

export const PfIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M3.8909 16.6956H60.109C54.6818 6.7486 44.1294 0 32 0S9.3183 6.7486 3.8909 16.6956M32 64.0001c12.1294 0 22.6817-6.7487 28.1091-16.6957H3.8909C9.3183 57.2514 19.8706 64.0001 32 64.0001"
      />
      <path
        fill="#ffda44"
        d="M43.1304 32c0 6.1473-4.9833 9.7391-11.1304 9.7391S20.8696 38.1473 20.8696 32c0-6.1472 4.9833-11.1304 11.1304-11.1304S43.1304 25.8528 43.1304 32"
      />
      <path
        fill="#0052b4"
        d="M43.1304 32c0 6.1473-4.9833 11.1304-11.1304 11.1304S20.8696 38.1473 20.8696 32"
      />
      <path
        fill="#d80027"
        d="M25.0435 29.2173h2.7826v5.5652h-2.7826zm11.1304 0h2.7826v5.5652h-2.7826zm-5.5652-4.1738h2.7827v9.7391h-2.7827z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pf',
  64
);

export const PgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#000"
        d="M54.6275 54.6274c-12.4968 12.4967-32.758 12.4967-45.255 0-12.4968-12.4968-12.4968-32.7582.0001-45.255S40.163-1.1568 52.6597 11.34s14.4644 30.7905 1.9678 43.2873"
      />
      <path
        fill="#a2001d"
        d="M9.3726 9.3725c12.4968-12.4968 32.7579-12.4966 45.2549 0 12.4967 12.4968 12.4967 32.7581 0 45.255"
      />
      <path
        fill="#fff"
        d="m24.4552 43.1306.518 1.5944h1.6764l-1.3562.9852.5181 1.5944-1.3563-.9854-1.3562.9854.518-1.5944-1.3561-.9852h1.6762zm-4.2813-15.3044.8636 2.6572h2.7938l-2.2604 1.6421.8634 2.6573-2.2604-1.6424-2.2603 1.6424.8635-2.6573-2.2605-1.6421h2.794zm0 19.4782.8634 2.6573h2.794l-2.2607 1.642.8637 2.6572-2.2604-1.6423-2.2603 1.6423.8633-2.6572-2.2603-1.642h2.7937zm8.1687-12.5217.8636 2.6573H32l-2.2604 1.642.8634 2.6572-2.2604-1.6424-2.2602 1.6424.8635-2.6572-2.2604-1.642h2.7939zm-16.3376 0 .8636 2.6573h2.7936l-2.2602 1.642.8632 2.6572-2.2602-1.6424-2.2604 1.6424.8636-2.6572-2.2605-1.642h2.7939z"
      />
      <path
        fill="#ffda44"
        d="M53.5686 23.695c-1.4301-1.4301-3.2883-2.275-5.2852-2.4201l5.9775-4.6491c-2.3806-2.3807-5.5714-3.4558-8.6849-3.2284a8.31 8.31 0 0 0-2.1367-3.6581l-2.3612 4.7222a3.47 3.47 0 0 0-.5902-.787c-1.3585-1.3584-3.5608-1.3584-4.919 0-1.3583 1.3584-1.3585 3.5606 0 4.919.2391.2391.5049.4353.7871.5903l-4.7222 2.3611a8.306 8.306 0 0 0 3.66 2.1374c-.2282 3.1135.8458 6.3037 3.2266 8.6845l5.2225-6.7148c.3929-.3869.9117-.6005 1.4637-.6005.5575 0 1.0815.217 1.4757.6114a2.073 2.073 0 0 1 .6113 1.4756 2.074 2.074 0 0 1-.6113 1.4758L48.65 30.582c.9196-.9197 1.4263-2.1426 1.4263-3.4434 0-1.0642-.3395-2.076-.9663-2.9125a5.53 5.53 0 0 1 2.4914 1.4368c2.17 2.1699 2.17 5.7006 0 7.8704l1.9677 1.9677c1.5767-1.5767 2.445-3.673 2.445-5.9029-.0003-2.2301-.8688-4.3263-2.4455-5.9031"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pg',
  64
);

export const PhIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0v32L9.3725 54.6275C15.1634 60.4182 23.1634 64 32 64c17.673 0 32-14.327 32-32S32 0 32 0"
      />
      <path
        fill="#0052b4"
        d="M32 0C23.1634 0 15.1634 3.5818 9.3725 9.3725L32 32h32C64 14.327 49.673 0 32 0"
      />
      <path
        fill="#ffda44"
        d="m21.9114 32-3.908-1.8383 2.0811-3.7848-4.2437.8118-.5378-4.2871-2.956 3.153-2.9558-3.153-.538 4.2871-4.2435-.812 2.081 3.785L2.7828 32l3.908 1.8382-2.081 3.7849 4.244-.8117.5373 4.287 2.956-3.153 2.956 3.153.5378-4.287 4.2435.8118-2.081-3.7848zM8.5342 12.5217l1.3005 1.8179 2.1306-.6749-1.3273 1.7985 1.3005 1.8179-2.1207-.7064-1.3271 1.7984.0166-2.235-2.1206-.7065 2.131-.6749zm0 33.1053 1.3005 1.8178 2.1306-.675-1.3273 1.7987 1.3005 1.8178-2.1207-.7063-1.3271 1.7983.0166-2.235-2.1206-.7065 2.131-.6749zm18.5491-16.5525-1.3004 1.8178-2.1307-.6751 1.3272 1.7986-1.3005 1.818 2.1208-.7065 1.3272 1.7984-.0167-2.2349 2.1206-.7065-2.1309-.6748z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ph',
  64
);

export const PitcairnislandsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 31.9999H32v-.0856z" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1658 7.0107-12.0155 12.0155V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32 28.0649 20.6306 16.6958h-3.935v.0003l15.3041 15.304H32z"
      />
      <path
        fill="#acabb1"
        d="m50.087 19.4782-4.174 1.3914-4.1738-1.3914L40.3479 16l1.3913-3.4783h8.3478L48.6957 16z"
      />
      <path
        fill="#338af3"
        d="M36.1739 19.4783v15.3042c0 7.455 9.7391 9.7393 9.7391 9.7393s9.7391-2.2843 9.7391-9.7393V19.4783z"
      />
      <path
        fill="#6da544"
        d="M37.0519 38.4083c2.394 4.5962 8.8612 6.1135 8.8612 6.1135s6.4673-1.5173 8.8613-6.1135l-8.8613-14.756z"
      />
      <path
        fill="#ffda44"
        d="M55.6521 34.6279 45.913 19.4783 36.1739 34.628v.1545c0 1.3798.3342 2.582.8779 3.6258l8.8612-13.7844 8.8613 13.7842c.5436-1.0438.8778-2.246.8778-3.6257z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pitcairnislands',
  64
);

export const PkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="M0 32c0 12.1294 6.7486 22.6817 16.6956 28.1091V3.8909C6.7486 9.3182 0 19.8706 0 32"
      />
      <path
        fill="#496e2d"
        d="M32 0c-5.5438 0-10.758 1.4104-15.3044 3.8909V60.109C21.242 62.5896 26.4562 64 32 64c17.673 0 32-14.327 32-32S49.673 0 32 0"
      />
      <path
        fill="#fff"
        d="M45.6817 37.2922c-4.0484 2.9252-9.7017 2.0147-12.6267-2.0336-2.9252-4.0485-2.0146-9.7016 2.0338-12.6266 1.2622-.912 2.6805-1.4511 4.1233-1.6385-2.7758-.4151-5.7102.2104-8.1648 1.984-4.9825 3.6002-6.1034 10.5579-2.5033 15.5406 3.6002 4.9824 10.5579 6.1034 15.5407 2.5029 2.4548-1.7736 3.97-4.3628 4.4472-7.1289-.6308 1.3108-1.5879 2.488-2.8502 3.4001m-.1734-16.4223 2.2805 2.4576 3.042-1.409-1.6329 2.928 2.2804 2.4579-3.2895-.6482-1.6328 2.9283-.4001-3.3288-3.2895-.6481 3.0421-1.409z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pk',
  64
);

export const PlIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#d80027" d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pl',
  64
);

export const PrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0C21.531 0 12.2366 5.0279 6.3986 12.8h51.2028C51.7634 5.0279 42.469 0 32 0m0 64c10.469 0 19.7634-5.0279 25.6014-12.8H6.3986C12.2366 58.9721 21.531 64 32 64M0 32.0001c0 2.1919.221 4.3321.6409 6.4h62.7185c.4199-2.0679.6406-4.2081.6406-6.4s-.221-4.3321-.6408-6.4H.6409a32.14 32.14 0 0 0-.6409 6.4"
      />
      <path
        fill="#0052b4"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#fff"
        d="m12.9513 23.6521 2.0718 6.377h6.7058l-5.4248 3.9415 2.0718 6.3772-5.4246-3.9413-5.425 3.9413 2.0723-6.3772-5.4247-3.9415h6.7052z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pr',
  64
);

export const PsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="M19.4783 20.8696h42.5312C57.4883 8.684 45.7588 0 32 0 23.1633 0 15.1641 3.5824 9.3736 9.3736z"
      />
      <path
        fill="#6da544"
        d="M19.4783 43.1304h42.5312C57.4883 55.316 45.7588 64 32 64c-8.8367 0-16.8359-3.5824-22.6264-9.3736z"
      />
      <path
        fill="#d80027"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ps',
  64
);

export const PtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#6da544"
        d="M0 32c0 13.7587 8.684 25.4881 20.8694 30.0095l2.7827-30.0096-2.7827-30.0095C8.684 6.5119 0 18.241 0 32"
      />
      <path
        fill="#d80027"
        d="M64 32C64 14.327 49.673 0 32 0c-3.9142 0-7.6639.7041-11.1306 1.9904v60.0192C24.3361 63.296 28.0858 64 32 64c17.673 0 32-14.327 32-32"
      />
      <path
        fill="#ffda44"
        d="M20.8696 43.1304C27.0168 43.1304 32 38.1471 32 32s-4.9832-11.1304-11.1304-11.1304S9.7393 25.8529 9.7393 32s4.9832 11.1304 11.1303 11.1304"
      />
      <path
        fill="#d80027"
        d="M14.6088 26.4348v6.9565c0 3.4577 2.803 6.2608 6.2608 6.2608 3.4579 0 6.2609-2.803 6.2609-6.2608v-6.9565z"
      />
      <path
        fill="#fff"
        d="M20.8697 35.4783c-1.1508 0-2.087-.9363-2.087-2.087v-2.7825h4.1738v2.7826c0 1.1506-.9362 2.0869-2.0868 2.0869"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pt',
  64
);

export const PwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M25.0435 45.9129c7.6839 0 13.913-6.229 13.913-13.913s-6.2291-13.913-13.913-13.913-13.913 6.2291-13.913 13.913 6.2291 13.913 13.913 13.913"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Pw',
  64
);

export const PyIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0C19.3132 0 8.3512 7.3831 3.1752 18.087h57.6494C55.6487 7.3831 44.6866 0 32 0"
      />
      <path
        fill="#0052b4"
        d="M32 64.0001c12.6866 0 23.6487-7.3831 28.8247-18.087H3.1752C8.3512 56.617 19.3132 64.0001 32 64.0001"
      />
      <path
        fill="#6da544"
        d="m39.8704 22.7383-2.9514 2.9514c1.2589 1.2588 2.0376 2.998 2.0376 4.919 0 3.842-3.1146 6.9565-6.9565 6.9565-3.8418 0-6.9565-3.1147-6.9565-6.9565 0-1.921.7788-3.6602 2.0377-4.919l-2.9514-2.9514c-2.0144 2.014-3.2601 4.7966-3.2601 7.8704 0 6.1472 4.9832 11.1303 11.1303 11.1303s11.1304-4.9832 11.1304-11.1303c-.0001-3.0738-1.2459-5.8564-3.2601-7.8704"
      />
      <path
        fill="#ffda44"
        d="m32 26.4348 1.0361 3.1888h3.3527l-2.7124 1.9705 1.0361 3.1886L32 32.8121l-2.7125 1.9706 1.0361-3.1886-2.7123-1.9705h3.3526z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Py',
  64
);

export const QaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#751a46"
        d="M64 32C64 14.327 49.673 0 32 0c-6.26 0-12.0992 1.7994-17.0315 4.9064l7.0141 2.9801-9.4608 4.0197 9.4608 4.0197-9.4608 4.0195 9.4608 4.0194-9.4608 4.0188 9.4608 4.0187-9.4608 4.0195 9.4608 4.0192-9.4608 4.0189 9.4608 4.0192-9.4608 4.0195 9.4608 4.0189-7.011 2.9785C19.9033 62.2015 25.7413 64 32 64c17.673 0 32-14.327 32-32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Qa',
  64
);

export const RoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M43.1304 1.9903C39.6636.704 35.9142 0 32 0c-3.9143-.0001-7.6638.7041-11.1304 1.9903L18.087 31.9999l2.7826 30.0096C24.3361 63.296 28.0856 64 32 64c3.9141 0 7.6637-.704 11.1304-1.9905L45.9129 32z"
      />
      <path
        fill="#d80027"
        d="M64 32c0-13.7588-8.684-25.4884-20.8696-30.0096v60.0195C55.316 57.4881 63.9999 45.759 64 32"
      />
      <path
        fill="#0052b4"
        d="M0 31.9999C0 45.759 8.684 57.4881 20.8694 62.0097l.0001-60.0192C8.684 6.5117 0 18.241 0 31.9999"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ro',
  64
);

export const RsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 0C14.327 0 0 14.327 0 32c0 3.9142.7041 7.6639 1.9904 11.1304h60.0194C63.296 39.6639 64 35.9142 64 32 64 14.327 49.673 0 32 0"
      />
      <path
        fill="#d80027"
        d="M32 0C18.2411 0 6.5117 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#d80027"
        d="M8.2747 18.087v15.9632c0 9.0805 11.8626 11.8629 11.8626 11.8629s11.8625-2.7824 11.8625-11.8629V18.087z"
      />
      <path
        fill="#ffda44"
        d="M13.1807 20.8696h13.9132v-5.5652l-2.7827 1.3912-4.1738-4.1739-4.174 4.1739-2.7827-1.3912zm16.0367 15.4033-9.0435-9.0435-9.0435 9.0435 2.9513 2.9513 6.0922-6.0921 6.0921 6.0921z"
      />
      <path
        fill="#fff"
        d="M29.2174 27.8262h-4.2195a2.766 2.766 0 0 0 .3752-1.391c0-1.537-1.2459-2.7827-2.7826-2.7827-1.0619 0-1.984.5948-2.4531 1.4692-.4692-.8743-1.3913-1.4692-2.4532-1.4692-1.5367 0-2.7826 1.2457-2.7826 2.7827 0 .5072.138.9816.3753 1.391h-4.1465c0 1.5368 1.3386 2.7826 2.8752 2.7826h-.0926c0 1.5369 1.2457 2.7826 2.7826 2.7826 0 1.3608.9773 2.4913 2.2679 2.7333l-2.1925 4.9502a9.02 9.02 0 0 0 3.403.6644 9.02 9.02 0 0 0 3.403-.6644l-2.1925-4.9502c1.2906-.2418 2.2679-1.3724 2.2679-2.7333 1.5368 0 2.7826-1.2457 2.7826-2.7826h-.0926c1.5365 0 2.875-1.2459 2.875-2.7826"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Rs',
  64
);

export const RuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M62.0096 43.1304C63.296 39.6638 64 35.9143 64 32s-.704-7.6637-1.9904-11.1304H1.9904C.704 24.3363 0 28.0858 0 32s.7041 7.6638 1.9904 11.1304L32 45.913z"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5118 55.316 18.241 64 32 64"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ru',
  64
);

export const RwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M0 31.9999c0 5.5438 1.4104 10.758 3.8909 15.3044L32 50.0869l28.1091-2.7826C62.5896 42.7579 64 37.5437 64 31.9999l-32-2.7826z"
      />
      <path
        fill="#338af3"
        d="M60.1091 16.6956C54.6817 6.7486 44.1294 0 32 0S9.3183 6.7486 3.8909 16.6956C1.4104 21.242 0 26.4562 0 32h64c0-5.5438-1.4104-10.758-3.8909-15.3044"
      />
      <path
        fill="#496e2d"
        d="M32 64.0001c12.1294 0 22.6817-6.7487 28.1091-16.6957H3.8909C9.3182 57.2514 19.8706 64.0001 32 64.0001"
      />
      <path
        fill="#ffda44"
        d="m36.1739 18.7276 3.9082 1.8384-2.0811 3.785 4.2438-.8117.5377 4.2868 2.9558-3.153 2.956 3.153.5376-4.2868 4.2437.8115-2.081-3.7849 3.908-1.8383-3.9081-1.8381 2.0811-3.785-4.2436.8118-.5379-4.287-2.9558 3.1531-2.9559-3.153-.5376 4.2869-4.2439-.8118 2.0811 3.7851z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Rw',
  64
);

export const SaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#6da544"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="M18.087 38.261c0 2.3051 1.8688 4.1739 4.1739 4.1739h12.5217c0 1.921 1.5573 3.4782 3.4783 3.4782h4.1739c1.921 0 3.4782-1.5572 3.4782-3.4782V38.261zm28.1739-20.1738v9.7391c0 1.5344-1.2483 2.7826-2.7827 2.7826v4.1739c3.8359 0 6.9565-3.1208 6.9565-6.9565v-9.7391zm-29.913 9.7391c0 1.5344-1.2483 2.7826-2.7827 2.7826v4.1739c3.8359 0 6.9565-3.1208 6.9565-6.9565v-9.7391h-4.1738z"
      />
      <path
        fill="#fff"
        d="M40 18.0872h4.1739v9.7391H40zm-6.2609 5.565a.6964.6964 0 0 1-.6956.6956.6965.6965 0 0 1-.6956-.6956v-5.5653H28.174v5.5653a.6964.6964 0 0 1-.6956.6956c-.3835 0-.6957-.3121-.6957-.6956v-5.5653h-4.174v5.5653c0 2.6851 2.1845 4.8696 4.8697 4.8696 1.0341 0 1.9931-.325 2.7826-.877.7894.5519 1.7485.877 2.7826.877.2083 0 .413-.0146.6144-.0403-.2958 1.2187-1.3933 2.1272-2.7014 2.1272v4.1738c3.8359 0 6.9565-3.1207 6.9565-6.9565v-9.7391h-4.1739z"
      />
      <path fill="#fff" d="M22.6087 30.6089h6.2609v4.1739h-6.2609z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sa',
  64
);

export const SbIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#496e2d"
        d="M54.6283 54.6283c12.0013-12.0014 12.4752-31.162 1.4266-43.7318l-24.055 21.1033-21.1034 24.0551c12.5698 11.0486 31.7303 10.5747 43.7318-1.4266"
      />
      <path
        fill="#0052b4"
        d="M9.3717 9.3717C21.3731-2.6296 40.5337-3.1035 53.1035 7.9451L31.9999 32.0003 7.9452 53.1035C-3.1035 40.5337-2.6295 21.3731 9.3717 9.3717"
      />
      <path
        fill="#ffda44"
        d="M53.1033 7.945 7.945 53.1036a32.3 32.3 0 0 0 1.4266 1.5247c.496.496 1.0056.97 1.5251 1.4268l45.1581-45.1584a32.4 32.4 0 0 0-1.4268-1.5252 32.5 32.5 0 0 0-1.5247-1.4263"
      />
      <path
        fill="#fff"
        d="m13.4826 11.1294.6909 2.1259h2.2351l-1.8083 1.3136.6907 2.1259-1.8084-1.3139-1.8084 1.3139.6909-2.1259-1.8084-1.3136h2.2353zm11.4174 0 .6908 2.1259h2.235l-1.8082 1.3136.6907 2.1259L24.9 15.3809l-1.8084 1.3139.6909-2.1259-1.8084-1.3136h2.2351zM13.4826 22.2603l.6909 2.1258h2.2351l-1.8083 1.3138.6907 2.1258-1.8084-1.3138-1.8084 1.3138.6909-2.1258-1.8084-1.3138h2.2353zm11.4174 0 .6908 2.1258h2.235l-1.8082 1.3138.6907 2.1258L24.9 26.5119l-1.8084 1.3138.6909-2.1258-1.8084-1.3138h2.2351zm-5.7087-5.5655.6909 2.1259h2.235l-1.8082 1.3137.6907 2.1259-1.8084-1.3139-1.8083 1.3139.6907-2.1259-1.8083-1.3137h2.2352z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sb',
  64
);

export const ScIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M53.6011 8.3921C47.9086 3.1806 40.326 0 32 0c-1.363 0-2.7061.0859-4.0244.2512L12.5218 18.087 1.0126 40.0164c.7435 2.8826 1.8803 5.6068 3.347 8.1146L32 32z"
      />
      <path
        fill="#6da544"
        d="m58.6414 49.7297-44.771 8.64C19.024 61.9199 25.2687 64 32 64c11.1151 0 20.905-5.6679 26.6414-14.2703"
      />
      <path
        fill="#d80027"
        d="M53.6056 8.3965 4.3777 48.162a32.12 32.12 0 0 0 4.5852 6.046L64 32.0001c0-9.3449-4.0064-17.7534-10.3944-23.6036"
      />
      <path
        fill="#0052b4"
        d="M0 32c0 2.7683.3518 5.4545 1.0126 8.0163L27.9756.2513C12.2022 2.2304 0 15.69 0 32"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sc',
  64
);

export const ScotIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M51.482 6.615C46.0861 2.4674 39.3318 0 32 0S17.9138 2.4675 12.5179 6.615L32 26.097zM6.6149 12.518C2.4675 17.9139 0 24.6683 0 32c0 7.3318 2.4675 14.0863 6.615 19.4823L26.0971 32zm5.903 44.867C17.9139 61.5326 24.6683 64 32 64c7.3318 0 14.0861-2.4675 19.4821-6.615L32 37.903zm44.8671-5.903C61.5326 46.0861 64 39.3318 64 32s-2.4674-14.0861-6.615-19.482L37.903 32z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Scot',
  64
);

export const SdIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M3.1753 18.0871C1.141 22.2941 0 27.0137 0 32.0001s1.141 9.706 3.1753 13.913L32 48.6957l28.8247-2.7826C62.859 41.7061 64 36.9864 64 32.0001s-1.141-9.706-3.1753-13.913L32 15.3044z"
      />
      <path
        fill="#000"
        d="M3.1764 45.9131C8.352 56.617 19.3132 64.0001 32 64.0001s23.6479-7.3831 28.8236-18.087z"
      />
      <path
        fill="#d80027"
        d="M3.1764 18.087h57.6472C55.6479 7.3831 44.6867 0 32 0 19.3132 0 8.3521 7.3831 3.1764 18.087"
      />
      <path
        fill="#496e2d"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sd',
  64
);

export const SeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M25.0436 27.8261h38.6855C61.6837 12.1252 48.2584 0 32 0c-2.3893 0-4.7166.2641-6.9565.7606zm-8.348-.0001V3.8909C7.9089 8.685 1.6188 17.479.2709 27.826zm-.0001 8.3479H.2709c1.3479 10.3471 7.638 19.141 16.4247 23.9351zm8.348.0001v27.0654A32.1 32.1 0 0 0 32 64c16.2584 0 29.6837-12.1252 31.7291-27.8261z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Se',
  64
);

export const SgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M0 32.0001C0 14.327 14.327 0 32 0s32 14.327 32 32.0001"
      />
      <path
        fill="#fff"
        d="M19.4783 16.6955c0-4.6622 3.2766-8.557 7.6521-9.5126a9.78 9.78 0 0 0-2.087-.2264c-5.3789 0-9.7391 4.3603-9.7391 9.7392 0 5.3788 4.3602 9.7391 9.7391 9.7391a9.77 9.77 0 0 0 2.087-.2265c-4.3755-.9556-7.6521-4.8504-7.6521-9.5128M32 7.6521l.6908 2.1256h2.2351l-1.8084 1.3139.6908 2.1256L32 11.9036l-1.8083 1.3136.6908-2.1256-1.8083-1.3139h2.235z"
      />
      <path
        fill="#fff"
        d="m26.5781 11.8259.6907 2.1258h2.2351l-1.8083 1.3137.6908 2.1257-1.8083-1.3137-1.8085 1.3137.6909-2.1257-1.8084-1.3137h2.2352zm10.8439 0 .6909 2.1258h2.235l-1.8084 1.3137.6909 2.1257-1.8084-1.3137-1.8083 1.3137.6908-2.1257-1.8083-1.3137h2.235zm-2.0869 6.261.6908 2.1258h2.235l-1.8083 1.3137.6908 2.1256-1.8083-1.3136-1.8082 1.3136.6907-2.1256-1.8082-1.3137h2.2349zm-6.6701 0 .6906 2.1258h2.2353l-1.8084 1.3137.6909 2.1256-1.8084-1.3136-1.8084 1.3136.6908-2.1256-1.8083-1.3137h2.2352z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sg',
  64
);

export const SiIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M62.0096 20.8696H27.8261v-8.3479H11.1304v8.3479h-9.14C.704 24.3361 0 28.0857 0 32s.7041 7.6637 1.9904 11.1304L32 45.913l30.0096-2.7826C63.2959 39.6637 64 35.9142 64 32s-.7041-7.6639-1.9904-11.1304"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#fff"
        d="M11.1304 20.8696v2.7825c0 6.3902 8.3478 8.348 8.3478 8.348s8.3479-1.9578 8.3479-8.348v-2.7825l-2.7826 2.7827-5.5653-4.1739-5.5652 4.1739z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Si',
  64
);

export const SkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 64c17.673 0 32-14.327 32-32 0-3.9142-.704-7.6639-1.9904-11.1304H1.9904C.704 24.3361 0 28.0858 0 32c0 17.673 14.327 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#fff"
        d="M8.2748 18.087v15.9632c0 9.0805 11.8626 11.8629 11.8626 11.8629s11.8625-2.7824 11.8625-11.8629V18.087z"
      />
      <path
        fill="#d80027"
        d="M11.0574 18.087v15.9632c0 1.066.2367 2.0728.7057 3.0167h16.7484c.469-.9438.7057-1.9507.7057-3.0167V18.087z"
      />
      <path
        fill="#fff"
        d="M25.7025 29.2174h-4.1737v-2.7826h2.7826v-2.7827h-2.7826v-2.7825h-2.7827v2.7825h-2.7825v2.7827h2.7825v2.7826h-4.174V32h4.174v2.7826h2.7827V32h4.1737z"
      />
      <path
        fill="#0052b4"
        d="M15.5589 40.9512c1.7931 1.1269 3.6353 1.7812 4.5785 2.0722.9431-.2909 2.7853-.9453 4.5785-2.0722 1.8082-1.1365 3.0758-2.4362 3.7956-3.8843a4.846 4.846 0 0 0-2.8089-.8929 4.87 4.87 0 0 0-1.107.128c-.7541-1.7135-2.466-2.9106-4.4581-2.9106s-3.7041 1.1971-4.4581 2.9106a4.87 4.87 0 0 0-1.107-.128 4.846 4.846 0 0 0-2.8089.8929c.7194 1.448 1.987 2.7477 3.7954 3.8843"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sk',
  64
);

export const SlIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M62.0096 43.1303C63.296 39.6637 64 35.9142 64 31.9999s-.704-7.6637-1.9904-11.1304L32 18.0869 1.9904 20.8695C.704 24.3362 0 28.0857 0 31.9999s.704 7.6638 1.9904 11.1304L32 45.9129z"
      />
      <path
        fill="#338af3"
        d="M32 64c13.7587 0 25.4882-8.684 30.0095-20.8696H1.9902C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#6da544"
        d="M32 0C18.241 0 6.5117 8.684 1.9902 20.8696h60.0194C57.4882 8.684 45.7587 0 32 0"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sl',
  64
);

export const SmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32c1.3913 0 32-4.1738 32-4.1738z"
      />
      <path fill="#fff" d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32" />
      <path
        fill="#6da544"
        d="M44.702 22.0806 32 34.7827 19.298 22.0806c-1.6426 2.4383-2.6022 5.3732-2.6022 8.5281v4.1739c0 6.702 4.3306 12.4111 10.3402 14.4775-.8021 1.572-.6669 3.5338.5085 5.0007 1.561-1.2511 3.1771-2.5462 4.5481-3.6447 1.371 1.0986 2.9873 2.3937 4.5482 3.6447 1.1891-1.484 1.3146-3.4752.4808-5.0565 5.9275-2.1112 10.1827-7.7785 10.1827-14.4217v-4.1738c.0001-3.155-.9597-6.0897-2.6023-8.5282"
      />
      <path
        fill="#ffda44"
        d="M32 45.9129c-6.1374 0-11.1304-4.9931-11.1304-11.1304v-4.1739c0-6.1373 4.9932-11.1303 11.1304-11.1303s11.1304 4.9931 11.1304 11.1303v4.1739c0 6.1373-4.993 11.1304-11.1304 11.1304"
      />
      <path
        fill="#338af3"
        d="M38.9565 34.7827v-4.1739c0-3.8358-3.1207-6.9565-6.9565-6.9565-3.8357 0-6.9565 3.1208-6.9565 6.9565v4.1739L32 36.174z"
      />
      <path
        fill="#6da544"
        d="M25.0435 34.7827c0 3.8359 3.1208 6.9565 6.9565 6.9565s6.9565-3.1207 6.9565-6.9565z"
      />
      <path
        fill="#ffda44"
        d="M40.3479 19.4781c0-2.3051-1.8688-4.1738-4.1739-4.1738-1.0694 0-2.044.4025-2.7826 1.0636v-2.455h1.3912v-2.7826h-1.3912V9.739h-2.7826v1.3913h-1.3913v2.7826h1.3913v2.455c-.7387-.6611-1.7134-1.0636-2.7827-1.0636-2.3051 0-4.1738 1.8687-4.1738 4.1738 0 1.2359.5376 2.3459 1.3912 3.1103v2.455h13.913v-2.455c.8538-.7644 1.3914-1.8744 1.3914-3.1103"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sm',
  64
);

export const SnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M45.913 3.1753C41.706 1.141 36.9863 0 32 0s-9.706 1.141-13.913 3.1753L15.3044 32l2.7826 28.8247C22.294 62.859 27.0138 64 32 64s9.706-1.141 13.913-3.1753L48.6956 32z"
      />
      <path
        fill="#496e2d"
        d="m31.9998 20.8696 2.7625 8.5025h8.941l-7.233 5.2554 2.7626 8.5029-7.2331-5.255-7.2332 5.255 2.7632-8.5029-7.233-5.2554h8.9403zM18.087 3.1763C7.3833 8.352 0 19.3133 0 31.9999s7.3833 23.6477 18.087 28.8236z"
      />
      <path
        fill="#d80027"
        d="M45.913 3.1763v57.6472C56.6168 55.6476 64 44.6865 64 31.9999S56.6168 8.3521 45.913 3.1763"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sn',
  64
);

export const SoIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="m32 16.6956 3.4535 10.6286H46.629l-9.0413 6.5687 3.4535 10.6288L32 37.9528l-9.0413 6.5689 3.4535-10.6288-9.0414-6.5687h11.1757z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'So',
  64
);

export const SrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#a2001d"
        d="M62.0095 20.8696H1.9903C.704 24.3364 0 28.0858 0 32s.7041 7.6639 1.9903 11.1304h60.0193C63.296 39.6639 64 35.9143 64 32s-.704-7.6636-1.9905-11.1304"
      />
      <path
        fill="#6da544"
        d="M32.0926 63.9999c10.9603 0 20.6323-5.5115 26.3995-13.913H5.6932c5.7673 8.4015 15.439 13.913 26.3994 13.913m0-63.9997c10.9603 0 20.6323 5.5115 26.3995 13.913H5.6932C11.4605 5.5117 21.1322.0002 32.0926.0002"
      />
      <path
        fill="#ffda44"
        d="m32 20.8696 2.7626 8.5025h8.9407l-7.233 5.2555 2.7628 8.5028L32 37.8755l-7.2331 5.2549 2.763-8.5028-7.2331-5.2555h8.9406z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sr',
  64
);

export const SsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="M61.5036 19.5941C56.6575 8.0828 45.2735 0 32 0 23.1632 0 15.1641 3.5824 9.3736 9.3736l8.0137 10.2205z"
      />
      <path
        fill="#496e2d"
        d="M17.4782 44.29 9.3736 54.6264C15.1641 60.4177 23.1632 64 32 64c13.3182 0 24.7347-8.1367 29.553-19.71z"
      />
      <path
        fill="#a2001d"
        d="M6.9565 23.5361v16.8115h55.9412C63.6155 37.6863 64 34.8883 64 31.9999c0-2.9303-.3948-5.7678-1.1326-8.4638z"
      />
      <path
        fill="#0052b4"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#ffda44"
        d="m10.4233 24.0439 3.9056 5.4502 6.391-2.0307-3.9764 5.3992 3.9056 5.4503-6.3635-2.1133-3.9765 5.399.0438-6.7054-6.3638-2.1136 6.3905-2.0305z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ss',
  64
);

export const StIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#6da544"
        d="M19.4783 20.8696h42.5312C57.4883 8.684 45.7588 0 32 0 23.1633 0 15.1641 3.5824 9.3736 9.3736zm0 22.2608h42.5312C57.4883 55.316 45.7588 64 32 64c-8.8367 0-16.8359-3.5824-22.6264-9.3736z"
      />
      <path
        fill="#d80027"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#000"
        d="m40.6343 26.4348 1.3813 4.2515h4.4703l-3.6165 2.6275 1.3814 4.2515-3.6165-2.6276-3.6166 2.6276 1.3813-4.2515-3.6164-2.6275h4.4703zm13.9131 0 1.3812 4.2515h4.4703l-3.6164 2.6275 1.3812 4.2515-3.6163-2.6276-3.6167 2.6276 1.3814-4.2515-3.6165-2.6275h4.4703z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'St',
  64
);

export const SvIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M32 0C19.3132 0 8.3513 7.3831 3.1753 18.087h57.6493C55.6487 7.3831 44.6866 0 32 0m0 64.0001c12.6866 0 23.6487-7.3831 28.8247-18.087H3.1753C8.3512 56.617 19.3131 64.0001 32 64.0001"
      />
      <path fill="#ffda44" d="M25.5737 33.3914 32 22.261l6.4262 11.1304z" />
      <path
        fill="#6da544"
        d="M40.3479 37.0663 32 41.2403l-8.3479-4.174v-5.5651h16.6958z"
      />
      <path
        fill="#ffda44"
        d="m39.8704 22.7383-2.9514 2.9514c1.2589 1.2588 2.0376 2.998 2.0376 4.919 0 3.842-3.1146 6.9565-6.9565 6.9565-3.8418 0-6.9565-3.1147-6.9565-6.9565 0-1.921.7788-3.6602 2.0377-4.919l-2.9514-2.9514c-2.0144 2.014-3.2601 4.7966-3.2601 7.8704 0 6.1472 4.9832 11.1303 11.1303 11.1303s11.1304-4.9832 11.1304-11.1303c-.0001-3.0738-1.2459-5.8564-3.2601-7.8704"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sv',
  64
);

export const SyIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0C18.2411 0 6.5117 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
      <path
        fill="#000"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5117 55.316 18.241 64 32 64"
      />
      <path
        fill="#6da544"
        d="m19.1202 24.3479 1.7266 5.314h5.5879l-4.5206 3.2847 1.7268 5.3143-4.5207-3.2844-4.5206 3.2844 1.7267-5.3143-4.5206-3.2847h5.5879zm25.7595 0 1.7267 5.314h5.588l-4.5208 3.2847 1.7268 5.3143-4.5207-3.2844-4.5206 3.2844 1.7268-5.3143-4.5207-3.2847h5.5879z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sy',
  64
);

export const SzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M60.8247 45.9129C62.859 41.7061 64 36.9862 64 31.9999s-1.141-9.7061-3.1753-13.913L32 16.6956 3.1753 18.0868C1.141 22.2938 0 27.0137 0 31.9999s1.141 9.7062 3.1753 13.913L32 47.3043z"
      />
      <path
        fill="#000"
        d="M32 0C19.3132 0 8.3512 7.3831 3.1752 18.087h57.6494C55.6487 7.3831 44.6866 0 32 0"
      />
      <path
        fill="#0052b4"
        d="M32 64.0001c-12.6868 0-23.6488-7.3831-28.8248-18.087h57.6494C55.6487 56.617 44.6866 64.0001 32 64.0001"
      />
      <path
        fill="#a2001d"
        d="M62.4889 22.261H1.5111C.531 25.3321 0 28.604 0 32.0001s.5309 6.668 1.5111 9.7391h60.9777C63.4691 38.6681 64 35.3962 64 32.0001s-.5309-6.668-1.5111-9.7391"
      />
      <path
        fill="#ffda44"
        d="M11.1304 30.6086h41.7391v2.7827H11.1304zm5.5652-5.5651h30.6088v2.7826H16.6956z"
      />
      <path
        fill="#fff"
        d="M47.5031 32S40.3477 40.3478 32 40.3478 23.6521 32 23.6521 32s0-8.3479 8.3479-8.3479S47.5031 32 47.5031 32"
      />
      <path
        fill="#000"
        d="M32 40.3478C23.6521 40.3478 16.4969 32 16.4969 32S23.6521 23.6521 32 23.6521"
      />
      <path fill="#fff" d="M26.4348 29.2173h2.7826v5.5652h-2.7826z" />
      <path fill="#000" d="M34.7826 29.2173h2.7826v5.5652h-2.7826z" />
      <path
        fill="#0052b4"
        d="M11.1304 34.7825c1.5368 0 2.7826-1.2458 2.7826-2.7826s-1.2458-2.7826-2.7826-2.7826-2.7826 1.2458-2.7826 2.7826 1.2458 2.7826 2.7826 2.7826m41.7393 0c1.5368 0 2.7826-1.2458 2.7826-2.7826s-1.2458-2.7826-2.7826-2.7826-2.7827 1.2458-2.7827 2.7826 1.2459 2.7826 2.7827 2.7826"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sz',
  64
);

export const TcIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 31.9999H32v-.0856z" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1658 7.0107-12.0155 12.0155V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32 28.0649 20.6306 16.6958h-3.935v.0003l15.3042 15.304H32z"
      />
      <path
        fill="#ffda44"
        d="M36.1739 16.6956v15.3042c0 7.455 9.7391 9.7393 9.7391 9.7393s9.7391-2.2843 9.7391-9.7393V16.6956z"
      />
      <path
        fill="#ff9811"
        d="M44.5218 22.2609c0 1.5369-1.2458 5.5652-2.7827 5.5652-1.5368 0-2.7826-4.0283-2.7826-5.5652s2.7826-2.7826 2.7826-2.7826 2.7827 1.2457 2.7827 2.7826"
      />
      <path
        fill="#a2001d"
        d="M51.9056 25.2915c.449-1.0956.7983-2.6971.7983-3.4944 0-1.2807-1.6696-2.3188-1.6696-2.3188s-1.6697 1.0382-1.6697 2.3188c0 .7973.3493 2.3988.7983 3.4944l-.9639 2.1763a4.86 4.86 0 0 0 1.8351.3582c.6494 0 1.2687-.128 1.8352-.3582z"
      />
      <path
        fill="#6da544"
        d="M43.8261 31.9999s-1.3912 2.7826-1.3912 5.5652h6.9565C49.3913 34.7825 48 31.9999 48 31.9999l-2.087-1.3913z"
      />
      <path
        fill="#d80027"
        d="M48 31.9999v-.6956c0-1.1525-.9344-2.087-2.087-2.087s-2.087.9344-2.087 2.087v.6956z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tc',
  64
);

export const TdIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 0c-3.9142 0-7.6639.7041-11.1304 1.9904L19.4783 32l1.3912 30.0096C24.3361 63.296 28.0858 64 32 64c3.9143 0 7.6639-.704 11.1304-1.9904L44.5218 32 43.1305 1.9904C39.6639.704 35.9143 0 32 0"
      />
      <path
        fill="#d80027"
        d="M64 32c0-13.7589-8.684-25.4883-20.8696-30.0096v60.0193C55.316 57.4882 64 45.7589 64 32"
      />
      <path
        fill="#0052b4"
        d="M20.8696 62.0096V1.9904C8.684 6.5117 0 18.241 0 32s8.684 25.4882 20.8696 30.0096"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Td',
  64
);

export const TgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#496e2d"
        d="M32 0c-.0233.0003-1.3913 12.8-1.3913 12.8h26.9928C51.7634 5.0279 42.469 0 32 0m0 64c10.469 0 19.7634-5.0279 25.6014-12.8H6.3986C12.2366 58.9721 21.531 64 32 64m31.3592-38.3999H30.6087L32 38.4001h31.3592c.42-2.0679.6408-4.2081.6408-6.4s-.221-4.3321-.6408-6.4"
      />
      <path
        fill="#d80027"
        d="M32 38.4V0C14.327 0 0 14.327 0 32c0 2.1919.221 4.3321.6408 6.4z"
      />
      <path
        fill="#fff"
        d="m17.6571 15.3044 2.072 6.3769h6.7057l-5.4247 3.9416 2.0718 6.3772-5.4248-3.9413-5.4247 3.9413 2.0721-6.3772-5.4246-3.9416h6.7054z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tg',
  64
);

export const ThIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M62.0096 20.8696H1.9904C.704 24.3363 0 28.0858 0 32s.704 7.6638 1.9904 11.1304h60.0194C63.296 39.6638 64 35.9143 64 32s-.704-7.6637-1.9904-11.1304"
      />
      <path
        fill="#d80027"
        d="M32 0C22.3011 0 13.6107 4.3155 7.7424 11.1304h48.5151C50.3892 4.3155 41.6989 0 32 0m24.2576 52.8696H7.7424C13.6107 59.6845 22.301 64 32 64s18.3892-4.3155 24.2576-11.1304"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Th',
  64
);

export const TjIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M3.1753 18.0871C1.141 22.2941 0 27.0138 0 32.0001s1.141 9.706 3.1753 13.913L32 48.6957l28.8247-2.7826C62.859 41.7061 64 36.9863 64 32.0001s-1.141-9.706-3.1753-13.913L32 15.3044z"
      />
      <path
        fill="#6da544"
        d="M3.1764 45.9131C8.3522 56.6168 19.3134 64.0001 32 64.0001s23.6479-7.3833 28.8236-18.087z"
      />
      <path
        fill="#d80027"
        d="M3.1764 18.087h57.6472C55.6479 7.3833 44.6866 0 32 0S8.3522 7.3833 3.1764 18.087"
      />
      <path
        fill="#ffda44"
        d="M26.4347 40.3477h11.1305v-4.7305l-2.2261 1.113L32 33.3911l-3.3391 3.3391-2.2262-1.113zm-6.3682-5.5652.5181 1.5942h1.6763l-1.3563.9854.5181 1.5942-1.3562-.9852-1.3563.9852.5182-1.5942-1.3563-.9854h1.6763zm1.6061-5.5652.5181 1.5942h1.6763l-1.3563.9854.518 1.5943-1.3561-.9853-1.3562.9853.5181-1.5943-1.3563-.9854h1.6763zm4.5915-4.1738.5181 1.5942h1.6762l-1.356.9854.5178 1.5942-1.3561-.9852-1.3561.9852.518-1.5942-1.3563-.9854h1.6764zm17.6694 9.739-.5181 1.5942h-1.6763l1.3563.9854-.5182 1.5942 1.3563-.9852 1.3561.9852-.518-1.5942 1.3563-.9854h-1.6763zm-1.6061-5.5652-.5182 1.5942H40.133l1.3562.9854-.5181 1.5943 1.3563-.9853 1.3562.9853-.5181-1.5943 1.3562-.9854h-1.6762zm-4.5915-4.1738-.5181 1.5942h-1.6762l1.356.9854-.518 1.5942 1.3563-.9852 1.3561.9852-.518-1.5942 1.3561-.9854h-1.6762zM32 22.9563l.5181 1.5942h1.6763l-1.3563.9854.5182 1.5943L32 26.1449l-1.3563.9853.5182-1.5943-1.3563-.9854h1.6763z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tj',
  64
);

export const TkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M51.4782 15.3044c-.287 1.3794-.4173 2.8485-.4173 4.313 0 8.4417 5.0324 15.7481 12.2442 19.0372A32.12 32.12 0 0 0 64 32C64 14.327 49.673 0 32 0S0 14.327 0 32s14.327 32 32 32c10.9603 0 20.6323-5.5115 26.3995-13.913H18.087v-4.1739h42.7377a31.9 31.9 0 0 0 1.1851-2.7826H18.087z"
      />
      <path
        fill="#fff"
        d="m23.509 16.6956.6908 2.1257h2.235l-1.8082 1.3139.6908 2.1256-1.8084-1.3136-1.8081 1.3136.6906-2.1256-1.8084-1.3139h2.2352zM14.4297 32l.8635 2.6574h2.7938l-2.2604 1.6419.8635 2.6572-2.2604-1.6422-2.2602 1.6422.8633-2.6572-2.2602-1.6419h2.7937zm0-22.261.8635 2.6574h2.7938l-2.2604 1.6419.8635 2.6572-2.2604-1.6422-2.2602 1.6422.8633-2.6572-2.2602-1.6419h2.7937zM7.4732 22.2607l.8635 2.6574h2.7937L8.8701 26.56l.8635 2.6572-2.2604-1.6422-2.2602 1.6422.8633-2.6572-2.2602-1.6419h2.7936z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tk',
  64
);

export const TmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#496e2d"
        d="M31.9999 0a32.1 32.1 0 0 0-6.9564.7606L23.6523 32l1.3912 31.2394A32.12 32.12 0 0 0 31.9999 64c17.6731 0 32-14.327 32-32.0001C63.9998 14.3269 49.673 0 31.9999 0M8.3479 10.4463C3.1624 16.1333 0 23.697 0 31.9998s3.1625 15.8665 8.348 21.5537l1.3912-21.5537z"
      />
      <path
        fill="#fff"
        d="M46.8026 24.1375c1.5744-4.3883-.1943-9.1609-3.9902-11.5379a9.78 9.78 0 0 1 2.0407.4915c5.0629 1.8165 7.6947 7.393 5.8782 12.4558-1.8165 5.0631-7.393 7.6946-12.4559 5.8781a9.77 9.77 0 0 1-1.8879-.918c4.4413.5784 8.8408-1.9813 10.4151-6.3695m-8.7321-12.7408-1.3681 1.7678-2.1036-.7549 1.2582 1.8473-1.3679 1.7675 2.1457-.6258 1.2585 1.847.0675-2.234 2.1457-.6259-2.1036-.7546z"
      />
      <path
        fill="#fff"
        d="m41.7645 17.1565-1.3681 1.7676-2.1038-.7549 1.2584 1.8473-1.368 1.7675 2.1456-.626 1.2585 1.8474.0678-2.2342 2.1456-.626-2.1037-.7547zm-10.207-3.6621-1.3681 1.7675-2.1036-.7546 1.2583 1.8471-1.368 1.7676 2.1455-.6259 1.2585 1.8472.0678-2.234 2.1456-.6259-2.1036-.7549zm-.15 6.5979-1.368 1.7676-2.1037-.7547 1.2585 1.8472-1.3683 1.7675 2.1459-.6257 1.2584 1.847.0676-2.234 2.1457-.6259-2.1038-.7549zm6.2782 2.2527-1.3681 1.7675-2.1036-.7548 1.2585 1.8473-1.3683 1.7673 2.1459-.6257 1.2584 1.8472.0676-2.2342 2.1458-.6258-2.1039-.7547z"
      />
      <path
        fill="#d80027"
        d="M8.3479 10.4465v43.1071c4.36 4.7818 10.1512 8.2349 16.6956 9.6856V.7607C18.499 2.2115 12.708 5.6647 8.3479 10.4465"
      />
      <path
        fill="#fff"
        d="m14.7191 16.848-2.7951-2.0822v-2.9447l2.7951-2.082h3.9531l2.7952 2.082v2.9447l-2.7952 2.0822z"
      />
      <path
        fill="#ff9811"
        d="M16.6957 9.739h-1.9766l-2.7951 2.0821v1.4397h4.7717zm0 7.109h1.9765l2.7952-2.0822v-1.5021h-4.7717z"
      />
      <path
        fill="#fff"
        d="m14.7191 54.2606-2.7951-2.0822v-2.9445l2.7951-2.0823h3.9531l2.7952 2.0823v2.9445l-2.7952 2.0822z"
      />
      <path
        fill="#ff9811"
        d="M16.6957 47.1516h-1.9766l-2.7951 2.0823v1.4396h4.7717zm0 7.1089h1.9765l2.7952-2.0822v-1.502h-4.7717z"
      />
      <path
        fill="#496e2d"
        d="m14.7191 35.5543-2.7951-2.0822v-2.9445l2.7951-2.0823h3.9531l2.7952 2.0823v2.9445l-2.7952 2.0822zm6.8461 4.5813h-1.2175v-1.2173h-2.1393l-1.5128-1.5128-1.5126 1.5128h-2.1394v1.2173h-1.2174v2.4348h1.2174v1.2174h2.1393l1.5128 1.5128 1.5127-1.5128h2.1393v-1.2174h1.2175zm0-18.7064h-1.2175v-1.2175h-2.1393l-1.5128-1.5127-1.5126 1.5127h-2.1394v1.2175h-1.2174v2.4348h1.2174v1.2174h2.1393l1.5128 1.513 1.5127-1.513h2.1393V23.864h1.2175z"
      />
      <path
        fill="#d80027"
        d="M15.3042 30.6084h2.7827v2.7826h-2.7827zm1.3913-6.571c.7684 0 1.3912-.6229 1.3912-1.3913s-.6228-1.3912-1.3912-1.3912-1.3913.6229-1.3913 1.3912.6229 1.3913 1.3913 1.3913m0 18.7073c.7684 0 1.3912-.6229 1.3912-1.3913s-.6228-1.3912-1.3912-1.3912-1.3913.6228-1.3913 1.3912.6229 1.3913 1.3913 1.3913"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tm',
  64
);

export const TnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="M32 47.3043c8.4524 0 15.3044-6.852 15.3044-15.3044S40.4524 16.6956 32 16.6956s-15.3044 6.852-15.3044 15.3043c0 8.4524 6.852 15.3044 15.3044 15.3044"
      />
      <path
        fill="#d80027"
        d="m33.8854 26.1482 2.6255 3.6181 4.2521-1.3787-2.6296 3.615 2.6252 3.618-4.2507-1.384-2.6297 3.615.0028-4.4702-4.2506-1.384 4.2522-1.3787z"
      />
      <path
        fill="#d80027"
        d="M35.4783 41.0434c-4.9945 0-9.0435-4.049-9.0435-9.0435s4.049-9.0435 9.0435-9.0435c1.5572 0 3.0226.3937 4.3018 1.087-2.0068-1.9626-4.7512-3.174-7.7801-3.174-6.147 0-11.1304 4.9832-11.1304 11.1304S25.853 43.1301 32 43.1301c3.0289 0 5.7734-1.2113 7.7801-3.174-1.2792.6935-2.7446 1.0873-4.3018 1.0873"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tn',
  64
);

export const ToIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M20.8696 16.6956v-4.1739h-4.174v4.1739h-4.1739v4.174h4.1739v4.1739h4.174v-4.1739h4.1739v-4.174z"
      />
      <path
        fill="#d80027"
        d="M32 0v32l-32 .0001C0 49.673 14.327 64 32 64s32-14.327 32-32S49.673 0 32 0"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'To',
  64
);

export const TpIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M32 0c-7.8346 0-15.0104 2.8171-20.5731 7.4918L45.913 32 11.4269 56.5083C16.9896 61.1829 24.1654 64 32 64c17.673 0 32-14.327 32-32S49.673 0 32 0"
      />
      <path
        fill="#000"
        d="M9.3725 9.3726c-12.4967 12.4967-12.4967 32.7581 0 45.255L32 32.0001z"
      />
      <path
        fill="#fff"
        d="m8.8724 24.6694 4.87 4.609 5.8885-3.208-2.8781 6.0563 4.8701 4.6091-6.6492-.866-2.8785 6.0561-1.2309-6.5915-6.6493-.8662 5.8883-3.2076z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tp',
  64
);

export const TrIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#fff"
        d="m30.6898 26.1482 2.6256 3.6181 4.2521-1.3787-2.6297 3.615 2.6252 3.618-4.2506-1.384-2.6296 3.615.0027-4.4702-4.2507-1.384 4.2522-1.3787z"
      />
      <path
        fill="#fff"
        d="M23.5243 41.0434c-4.9945 0-9.0435-4.049-9.0435-9.0435s4.049-9.0435 9.0435-9.0435c1.5572 0 3.0225.3939 4.3017 1.087-2.0069-1.9628-4.7515-3.174-7.78-3.174-6.1472 0-11.1304 4.9832-11.1304 11.1304S13.899 43.1301 20.046 43.1301c3.0288 0 5.7733-1.2113 7.78-3.174-1.2792.6934-2.7445 1.0873-4.3017 1.0873"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tr',
  64
);

export const TtIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M17.327 3.5532C14.4622 5.032 11.7731 6.97 9.3716 9.3715s-4.3398 5.0907-5.8183 7.9555l20.5759 22.5436 22.5436 20.5759c2.8649-1.4787 5.554-3.4168 7.9555-5.8182 2.4017-2.4016 4.3397-5.0907 5.8183-7.9555L39.8707 24.1291z"
      />
      <path
        fill="#000"
        d="M54.6284 54.6285a32.2 32.2 0 0 0 3.5936-4.2772L13.6489 5.7781a32.2 32.2 0 0 0-4.2771 3.5935 32.2 32.2 0 0 0-3.5937 4.2772l44.5732 44.573a32.2 32.2 0 0 0 4.2771-3.5933"
      />
      <path
        fill="#d80027"
        d="M9.3715 54.6283c10.0959 10.0959 25.258 12.0339 37.3012 5.8181L3.5534 17.3269C-2.6623 29.3702-.724 44.5324 9.3714 54.6283M54.6283 9.3717C44.5325-.7241 29.3703-2.6621 17.3271 3.5533L60.4465 46.673c6.2157-12.0432 4.2777-27.2056-5.8182-37.3013"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tt',
  64
);

export const TvIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#338af3"
        d="M64 32c0 17.673-14.327 32-31.9999 32C14.327 64 0 49.673 0 32 0 32.0076 32.0001.0035 32.0001 0 49.673 0 64 14.327 64 32"
      />
      <path
        fill="#0052b4"
        d="M15.3044 32h10.7927l-9.4015-11.1304-1.3912 4.1739zm16.6957-5.9027L20.8696 15.3044H32z"
      />
      <path fill="#fff" d="M31.9144 31.9999H32v-.0856z" />
      <path
        fill="#fff"
        d="M32.0001 16.6956V0h-.0054C14.324.003 0 14.3286 0 32h16.6957v-9.4014L26.0971 32h5.8175l.0857-.0856v-5.8172l-9.4018-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1656 7.0107-12.0155 12.0155V32h8.3479V12.5217H32V4.1738z"
      />
      <path
        fill="#d80027"
        d="M32.0001 28.0649 20.6308 16.6958h-3.935v.0003l15.3041 15.304h.0002z"
      />
      <path
        fill="#ffda44"
        d="m34.9258 52.8696.6907 2.1258h2.2351l-1.8081 1.3137.6907 2.1257-1.8084-1.3137-1.8082 1.3137.6908-2.1257L32 54.9954h2.235zm17.8006-13.9133.6906 2.1257h2.2351l-1.8081 1.3139.6909 2.1256-1.8085-1.3136-1.8081 1.3136.6907-2.1256-1.8085-1.3139h2.2351zm4.4602-20.8694.6908 2.1258h2.2351l-1.8081 1.3137.6906 2.1256-1.8084-1.3136-1.8081 1.3136.6907-2.1256-1.8083-1.3137h2.2351zm1.105 15.3042.6907 2.1259h2.2351l-1.8081 1.3137.6907 2.1257-1.8084-1.3137-1.8081 1.3137.6908-2.1257-1.8085-1.3137h2.2351zM38.1307 47.8697l1.9919 1.0149 1.5804-1.5804-.3495 2.2074 1.9914 1.0147-2.2078.3498-.3496 2.2076-1.0145-1.9916-2.2078.3498 1.5804-1.5803zm0-8.3478 1.9919 1.0148 1.5804-1.5804-.3495 2.2075 1.9914 1.0146-2.2078.3498-.3496 2.2076-1.0145-1.9915-2.2078.3497 1.5804-1.5803zm6.9566 5.351 1.9918 1.0148 1.5804-1.5803-.3495 2.2073 1.9914 1.0148-2.2078.3497-.3496 2.2077-1.0145-1.9918-2.2077.35 1.5803-1.5804zm0-17.8727 1.9918 1.0147 1.5804-1.5803-.3495 2.2075 1.9914 1.0146-2.2078.3497-.3496 2.2077-1.0145-1.9915-2.2077.3497 1.5803-1.5804zm6.7421-.2141 1.9919 1.0147 1.5803-1.5803-.3496 2.2075 1.9915 1.0146-2.2077.3497L54.4861 32l-1.0145-1.9915-2.2077.3497 1.5804-1.5804z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tv',
  64
);

export const TwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32L32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#0052b4" d="M32 32V0C14.327 0 0 14.327 0 32z" />
      <path
        fill="#fff"
        d="m27.8261 18.7276-3.9081 1.8385 2.081 3.7849-4.2436-.812-.5379 4.2871-2.9557-3.153-2.956 3.153-.5377-4.2871-4.2437.8118 2.081-3.7849-3.908-1.8383 3.9081-1.8381-2.0811-3.785 4.2436.8119.5379-4.287 2.9559 3.153 2.9558-3.153.5378 4.287 4.2437-.8119-2.0811 3.7851z"
      />
      <path
        fill="#0052b4"
        d="M18.2622 24.6835c3.2898 0 5.9567-2.6669 5.9567-5.9566 0-3.2898-2.6669-5.9566-5.9567-5.9566s-5.9566 2.6668-5.9566 5.9566c0 3.2897 2.6669 5.9566 5.9566 5.9566"
      />
      <path
        fill="#fff"
        d="M18.2618 21.9017c-1.7502 0-3.1739-1.4239-3.1739-3.174s1.4239-3.174 3.1739-3.174 3.174 1.4239 3.174 3.174c-.0002 1.7501-1.4242 3.174-3.174 3.174"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tw',
  64
);

export const TzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="M9.3725 54.6275a32.2 32.2 0 0 0 4.277 3.5935l44.5712-44.5713a32.16 32.16 0 0 0-3.5933-4.277 32.2 32.2 0 0 0-4.277-3.5934L5.7792 50.3507a32.2 32.2 0 0 0 3.5933 4.2768"
      />
      <path
        fill="#6da544"
        d="M9.3725 9.3726C-.7228 19.468-2.6609 34.6294 3.5545 46.6723L46.6722 3.5547C34.6294-2.6607 19.4679-.7224 9.3725 9.3726"
      />
      <path
        fill="#338af3"
        d="M54.6274 54.6274c10.0952-10.0953 12.0332-25.2569 5.8181-37.2998L17.3277 60.4454c12.0427 6.2154 27.2043 4.2772 37.2997-5.818"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tz',
  64
);

export const UaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#338af3" d="M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ua',
  64
);

export const UgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M55.8491 53.3333C60.917 47.6718 64 40.1965 64 32s-3.0831-15.6718-8.151-21.3333L32 8.3479 8.151 10.6667C3.0831 16.3282 0 23.8035 0 32s3.083 15.6718 8.1509 21.3333L32 55.6522z"
      />
      <path
        fill="#000"
        d="M8.151 10.6666h47.6981C49.9897 4.1207 41.4766 0 32 0S14.0103 4.1208 8.151 10.6666"
      />
      <path
        fill="#d80027"
        d="m0 32 32 2.7826L64 32c0-3.7405-.6439-7.3302-1.8235-10.6667H1.8235C.6439 24.6698 0 28.2595 0 32"
      />
      <path
        fill="#000"
        d="M1.8235 42.6666h60.3533C63.3561 39.3301 64 35.7405 64 32H0c0 3.7405.6439 7.3301 1.8235 10.6666"
      />
      <path
        fill="#d80027"
        d="M55.8491 53.3333H8.1509C14.01 59.8793 22.5233 64 32 64c9.4768 0 17.9899-4.1207 23.8491-10.6667"
      />
      <path
        fill="#fff"
        d="M42.6783 32c0 5.8979-4.7804 10.6783-10.6783 10.6783S21.3218 37.8979 21.3218 32 26.1022 21.3218 32 21.3218 42.6783 26.1022 42.6783 32"
      />
      <path
        fill="#000"
        d="M35.9119 32.5446 32 30.8495s.9152-3.0379.964-3.2458a2.07 2.07 0 0 0 .0546-.473 2.08 2.08 0 0 0-.6114-1.4756l.9838-.9838c-.6294-.6293-1.499-1.0187-2.4595-1.0187s-1.8301.3892-2.4595 1.0187l.9837.9838a2.08 2.08 0 0 0-.6112 1.4756c0 .2108.0319.4139.09.6058l-1.4811 1.481h2.692s-1.113 1.6717-1.7207 3.0446c-.6076 1.3727.0084 3.0486 1.4127 3.6729l.812.3608L32 37.5653v1.3913l-1.3913 1.3912h2.7827v-2.7826l1.2696-1.2696h2.626c.0126-.0261.0259-.0516.0379-.0784.6238-1.4041-.0087-3.0486-1.413-3.6726"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ug',
  64
);

export const UkIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#0052b4"
        d="M6.615 12.5176c-2.5136 3.2704-4.409 7.0397-5.5126 11.1346h16.6472zm56.2826 11.1347c-1.1036-4.0947-2.9991-7.8641-5.5126-11.1345L46.2506 23.6523zM1.1024 40.3479c1.1037 4.0948 2.999 7.8641 5.5126 11.1344l11.1342-11.1344zM51.4822 6.615c-3.2704-2.5136-7.0396-4.409-11.1345-5.5127v16.6471zM12.5177 57.3847c3.2704 2.5137 7.0398 4.409 11.1345 5.5128v-16.647zM23.6521 1.1023C19.5573 2.206 15.788 4.1014 12.5177 6.6149l11.1344 11.1344zm16.6957 61.7952c4.0948-1.1038 7.8642-2.9991 11.1344-5.5126L40.3478 46.2505zm5.9028-22.5496L57.385 51.4824c2.5135-3.2703 4.409-7.0397 5.5126-11.1345z"
      />
      <path
        fill="#d80027"
        d="M63.7291 27.8261H36.174V.2709A32.3 32.3 0 0 0 32 0c-1.4149 0-2.8076.093-4.1739.2709V27.826H.2709A32.3 32.3 0 0 0 0 32c0 1.4149.093 2.8076.2709 4.1739H27.826v27.5552a32.3 32.3 0 0 0 8.3479 0V36.174h27.5552A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1739"
      />
      <path
        fill="#d80027"
        d="m40.3479 40.348 14.2795 14.2795a32 32 0 0 0 1.881-2.0543L44.2832 40.3479zm-16.6958-.0001h-.0002L9.3725 54.6273a32 32 0 0 0 2.0544 1.881l12.2252-12.2255zm0-16.6955v-.0002L9.3726 9.3726a32 32 0 0 0-1.881 2.0543L19.717 23.6523zm16.6958-.0001L54.6275 9.3726a32 32 0 0 0-2.0543-1.8809L40.3479 19.7171z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Uk',
  64
);

export const UsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M30.6087 32H64c0-2.8882-.385-5.6862-1.1024-8.3479H30.6087zm0-16.6956h28.6945c-1.9589-3.1965-4.4635-6.0219-7.3837-8.3479H30.6087zM32 64c7.5311 0 14.4533-2.603 19.9195-6.9565h-39.839C17.5468 61.397 24.4689 64 32 64M4.6967 48.6957h54.6065a31.8 31.8 0 0 0 3.5944-8.3479H1.1024a31.81 31.81 0 0 0 3.5943 8.3479"
      />
      <path
        fill="#0052b4"
        d="M14.823 4.9973h2.9161l-2.7125 1.9706 1.0361 3.1886-2.7123-1.9706-2.7124 1.9706.895-2.7546a32.18 32.18 0 0 0-6.2065 6.9171h.9344l-1.7267 1.2544q-.4034.6732-.7742 1.3672l.8245 2.5377-1.5383-1.1177a31.7 31.7 0 0 0-1.0464 2.4841l.9083 2.7961H6.261l-2.7125 1.9706L4.5845 28.8l-2.7124-1.9706-1.6247 1.1805A32.3 32.3 0 0 0 0 32h32V0c-6.3215 0-12.2144 1.8338-17.177 4.9973M16.0627 28.8l-2.7123-1.9706L10.638 28.8l1.0361-3.1886-2.7125-1.9706h3.3528l1.036-3.1887 1.036 3.1887h3.3527l-2.7125 1.9706zm-1.0361-12.5104 1.0361 3.1887-2.7123-1.9707-2.7124 1.9707 1.0361-3.1887-2.7125-1.9706h3.3528l1.036-3.1886 1.036 3.1886h3.3527zM27.541 28.8l-2.7124-1.9706L22.1162 28.8l1.0362-3.1886-2.7125-1.9706h3.3527l1.036-3.1887 1.036 3.1887h3.3528l-2.7125 1.9706zm-1.0361-12.5104 1.0361 3.1887-2.7124-1.9707-2.7124 1.9707 1.0362-3.1887-2.7125-1.9706h3.3527l1.036-3.1886 1.036 3.1886h3.3528zm0-9.3217 1.0361 3.1886-2.7124-1.9706-2.7124 1.9706 1.0362-3.1886-2.7125-1.9706h3.3527l1.036-3.1887 1.036 3.1887h3.3528z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Us',
  64
);

export const UyIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#338af3"
        d="M32 23.6521h30.8976a31.82 31.82 0 0 0-3.5944-8.3479H32zM12.0804 57.0434h39.8391c2.9204-2.326 5.4249-5.1512 7.3836-8.3478H4.6968c1.9588 3.1965 4.4633 6.0218 7.3836 8.3478M32 0v6.9565h19.9196C46.4534 2.603 39.5311 0 32 0"
      />
      <path
        fill="#338af3"
        d="M32 23.6521h30.8976a31.82 31.82 0 0 0-3.5944-8.3479H32zM0 32c0 2.8884.385 5.6861 1.1024 8.3479h61.7954C63.615 37.6861 64 34.8884 64 32z"
      />
      <path
        fill="#ffda44"
        d="m27.8261 18.7276-3.9082 1.8384 2.0811 3.785-4.2438-.8117-.5377 4.2868-2.9558-3.153-2.956 3.153-.5376-4.2868-4.2437.8115 2.081-3.7849-3.908-1.8383 3.9081-1.8381-2.0811-3.785 4.2436.8118.5379-4.287 2.9558 3.1531 2.9559-3.153.5376 4.2869 4.2439-.8118-2.0811 3.7851z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Uy',
  64
);

export const UzIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M1.511 22.261C.5308 25.332-.0001 28.6036 0 31.9998c-.0001 3.3962.5309 6.6681 1.5111 9.7391L32 43.1304l30.4889-1.3913C63.469 38.668 64.0001 35.396 64.0001 32c-.0001-3.3962-.531-6.668-1.5112-9.7391L32 20.8696z"
      />
      <path
        fill="#d80027"
        d="m62.4887 22.2609-30.4888-1.3913-30.489 1.3913a32 32 0 0 0-.7503 2.7826h62.478a31.8 31.8 0 0 0-.7499-2.7826M.761 38.9563a31.9 31.9 0 0 0 .75 2.7825l.003.0001 30.4857 1.3913 30.4889-1.3913a31.9 31.9 0 0 0 .7501-2.7826z"
      />
      <path
        fill="#6da544"
        d="M31.9999 63.9999c14.277 0 26.3682-9.3504 30.4889-22.2609H1.5111C5.6318 54.6494 17.7233 63.9999 32 63.9999"
      />
      <path
        fill="#338af3"
        d="M31.9999.0002C17.7231.0004 5.6319 9.3507 1.5109 22.2611l60.9777.0001C58.3682 9.3506 46.2769.0002 31.9999.0002"
      />
      <path
        fill="#fff"
        d="M14.6233 13.2175c0-2.9971 2.1063-5.5008 4.9192-6.115a6.27 6.27 0 0 0-1.3416-.1457c-3.4578 0-6.2609 2.803-6.2609 6.2609 0 3.4578 2.8029 6.2608 6.2609 6.2608.4607 0 .9092-.0512 1.3416-.1456-2.8127-.6145-4.9192-3.1182-4.9192-6.1154m8.6197 2.846.4238 1.3044h1.3715l-1.1095.8062.4237 1.3044-1.1095-.8061-1.1097.8061.4238-1.3044-1.1096-.8062h1.3715zm4.3775 0 .4239 1.3044h1.3715l-1.1096.8062.4238 1.3044-1.1096-.8061-1.1096.8061.4239-1.3044-1.1095-.8062h1.3713zm4.3776 0 .4238 1.3044h1.3716l-1.1096.8062.4237 1.3044-1.1095-.8061-1.1097.8061.424-1.3044-1.1098-.8062h1.3717zm4.3777 0 .4238 1.3044h1.3714l-1.1095.8062.4239 1.3044-1.1096-.8061-1.1098.8061.424-1.3044-1.1097-.8062h1.3715zm4.3775 0 .4238 1.3044h1.3715l-1.1095.8062.4239 1.3044-1.1097-.8061-1.1097.8061.4239-1.3044-1.1095-.8062h1.3714zM27.6205 11.51l.4239 1.3043h1.3715l-1.1096.8063.4238 1.3043-1.1096-.8061-1.1096.8061.4239-1.3043-1.1095-.8063h1.3713zm4.3776 0 .4238 1.3043h1.3716l-1.1096.8063.4237 1.3043-1.1095-.8061-1.1097.8061.424-1.3043-1.1098-.8063h1.3717zm4.3777 0 .4238 1.3043h1.3714l-1.1095.8063.4239 1.3043-1.1096-.8061-1.1098.8061.424-1.3043-1.1097-.8063h1.3715zm4.3775 0 .4238 1.3043h1.3715l-1.1095.8063.4239 1.3043-1.1097-.8061-1.1097.8061.4239-1.3043-1.1095-.8063h1.3714zm-8.7552-4.5535.4238 1.3045h1.3716l-1.1096.8062.4237 1.3045-1.1095-.8062-1.1097.8062.424-1.3045-1.1098-.8062h1.3717zm4.3777 0 .4238 1.3045h1.3714l-1.1095.8062.4239 1.3045-1.1096-.8062-1.1098.8062.424-1.3045-1.1097-.8062h1.3715zm4.3775 0 .4238 1.3045h1.3715l-1.1095.8062.4239 1.3045-1.1097-.8062-1.1097.8062.4239-1.3045-1.1095-.8062h1.3714z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Uz',
  64
);

export const VaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 0c17.673 0 32 14.327 32 32S49.673 64 32 64c0-1.3913-4.1739-32-4.1739-32z"
      />
      <path fill="#ffda44" d="M32 64C14.327 64 0 49.673 0 32S14.327 0 32 0" />
      <path
        fill="#acabb1"
        d="m44.2538 27.8457 6.0138 7.9558c-.9475 1.4347-.9425 3.3677.1534 4.8174 1.39 1.8388 4.0076 2.2028 5.8466.8127s2.2029-4.0076.8127-5.8465c-1.0957-1.4496-2.9542-1.9816-4.5929-1.4614l-9.3726-12.3991-2.2198 1.678-3.33 2.5168 3.356 4.4393zm8.6578 9.1463c.613-.4635 1.4857-.342 1.949.2707.4633.613.3422 1.4857-.2708 1.9492-.6129.4631-1.4855.3421-1.9488-.271-.4636-.613-.3422-1.4857.2706-1.9489"
      />
      <path
        fill="#ffda44"
        d="m54.5688 30.3585 3.356-4.4394-3.3298-2.517-2.2197-1.678-9.3726 12.3991c-1.6385-.5202-3.4972.0119-4.5929 1.4614-1.3903 1.839-1.0263 4.4565.8126 5.8465s4.4565 1.0261 5.8465-.8127c1.0958-1.4497 1.1008-3.3827.1534-4.8174l6.0139-7.9558zm-11.7196 8.5821c-.4633.6131-1.3358.7343-1.9488.271-.613-.4635-.7342-1.3361-.2709-1.9491.4633-.6128 1.3359-.7343 1.949-.2708.6129.4634.734 1.336.2707 1.9489"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Va',
  64
);

export const VcIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#ffda44"
        d="M47.3044 3.8909C42.758 1.4104 37.5437 0 32 0c-5.5438 0-10.758 1.4104-15.3044 3.8909L13.913 32l2.7826 28.1091C21.242 62.5896 26.4562 64 32 64s10.758-1.4104 15.3044-3.8909L50.087 32z"
      />
      <path
        fill="#338af3"
        d="M16.6956 60.109V3.8909C6.7486 9.3184 0 19.8707 0 32s6.7486 22.6819 16.6956 28.109"
      />
      <path
        fill="#6da544"
        d="M64 32.0001c0-12.1294-6.7486-22.6817-16.6956-28.1092V60.109C57.2514 54.6819 64 44.1295 64 32.0001m-38.9565 8.348-5.5654-8.3479 5.5653-8.3479 5.5655 8.3479zm13.913 0-5.5653-8.3479 5.5653-8.3479 5.5652 8.3479zM32 51.4783l-5.5652-8.3478L32 34.7827l5.5653 8.3478z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Vc',
  64
);

export const VeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M60.8247 45.9131C62.8591 41.7061 64 36.9864 64 32.0001s-1.1409-9.706-3.1753-13.913L32 15.3044 3.1753 18.0871C1.1408 22.2941 0 27.0137 0 32.0001s1.1409 9.706 3.1753 13.913L32 48.6957z"
      />
      <path
        fill="#d80027"
        d="M32 64.0001c12.6866 0 23.6487-7.3831 28.8247-18.087H3.1752C8.3512 56.617 19.3132 64.0001 32 64.0001"
      />
      <path
        fill="#fff"
        d="m55.4208 38.2816-1.6901 1.3207.7335 2.0151-1.7784-1.1991-1.6902 1.3205.591-2.0619-1.7781-1.1995 2.1436-.0747.5915-2.0619.7337 2.0155zm-4.3282-7.4962-1.1364 1.8192 1.3789 1.6427-2.0814-.5182-1.1367 1.8186-.1499-2.1396-2.0811-.5192 1.989-.8036-.1495-2.1397 1.3786 1.6433zm-6.6309-5.5642-.4458 2.0981 1.8576 1.0725-2.1332.2249-.446 2.0975-.8725-1.9593-2.1333.2239 1.5942-1.4352-.8724-1.9593 1.8575 1.0723zm-8.134-2.9602.2989 2.1241 2.1121.3723-1.9277.9407.2986 2.124-1.49-1.543-1.9282.9403 1.0072-1.8942-1.4901-1.5427 2.1125.3724zm-8.6556 0 1.0071 1.8939 2.112-.3727-1.4896 1.5434 1.0066 1.894-1.9277-.9405-1.4903 1.5426.2989-2.1236-1.9279-.9402 2.1124-.3728zm-8.134 2.9602 1.5942 1.4354 1.8572-1.0723-.8722 1.96 1.5939 1.435-2.1331-.2244-.8728 1.9593-.4453-2.0979-2.1333-.224 1.8575-1.0727zm-6.6309 5.5641 1.9891.8035 1.3783-1.643-.1491 2.1401 1.9885.8037-2.0812.5186-.1498 2.1394-1.1363-1.8187-2.0814.5187 1.3788-1.6432zm-4.328 7.4963 2.144.0747.7333-2.0152.5918 2.062 2.1434.0748-1.7782 1.1995.591 2.0618-1.69-1.3205-1.7784 1.1991.7336-2.0155z"
      />
      <path
        fill="#ffda44"
        d="M60.8247 18.087C55.6487 7.3831 44.6866 0 32 0 19.3132 0 8.3512 7.3831 3.1752 18.087z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ve',
  64
);

export const VgIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#0052b4"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32C0 32.0076 32 .0035 32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#fff" d="M31.9144 32.0001H32v-.0857q-.0427.043-.0856.0857" />
      <path
        fill="#fff"
        d="M32 16.6956V0h-.0054C14.3239.003 0 14.3286 0 32h16.6956v-9.4014L26.097 32h5.8175l.0856-.0856v-5.8172l-9.4016-9.4016z"
      />
      <path
        fill="#d80027"
        d="M16.1894 4.1738c-5.0049 2.8499-9.1658 7.0107-12.0155 12.0155V32h8.3478V12.5217H32V4.1738z"
      />
      <path
        fill="#ffda44"
        d="m45.913 32-8.6491 8.6491c1.621 3.1264 4.8845 5.2639 8.6491 5.2639s7.0281-2.1375 8.6491-5.2639z"
      />
      <path
        fill="#d80027"
        d="M32 28.0649 20.6306 16.6958h-3.935v.0003l15.3041 15.304H32z"
      />
      <path
        fill="#6da544"
        d="M36.1739 16.6957v15.3044c.0001 7.4548 9.7391 9.7391 9.7391 9.7391s9.739-2.2843 9.7391-9.7391V16.6957z"
      />
      <path fill="#fff" d="M43.8261 23.6521H48v11.1304h-4.1739z" />
      <path
        fill="#a2001d"
        d="M45.913 25.7392c1.1526 0 2.087-.9344 2.087-2.087s-.9344-2.087-2.087-2.087-2.087.9344-2.087 2.087.9344 2.087 2.087 2.087"
      />
      <path
        fill="#ffda44"
        d="M38.9565 19.4783h2.7826v2.7826h-2.7826zm0 6.2608h2.7826v2.7827h-2.7826zm0 6.2609h2.7826v2.7826h-2.7826zM50.087 19.4783h2.7826v2.7826H50.087zm0 6.2608h2.7826v2.7827H50.087zm0 6.2609h2.7826v2.7826H50.087z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Vg',
  64
);

export const ViIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fcfcfc"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M37.4349 22.3556c0-3.0015-2.4333-5.4347-5.4349-5.4347s-5.4349 2.4332-5.4349 5.4347H14.6088c0 2.9552 2.5742 5.351 5.5293 5.351h-.178c0 2.9554 2.3955 5.3514 5.3512 5.3514 0 2.6166 1.8792 4.7909 4.3611 5.2557l-.0139.0312h4.6831l-.0138-.0312c2.482-.4651 4.3611-2.6392 4.3611-5.2557 2.9555 0 5.3511-2.396 5.3511-5.3514h-.1782c2.9551 0 5.5295-2.3958 5.5295-5.351z"
      />
      <path
        fill="#ffda44"
        d="m29.6109 37.7903-3.3698 7.6079a15.26 15.26 0 0 0 5.7591 1.1245c2.0376 0 3.9809-.4017 5.7588-1.1245l-3.3696-7.6079z"
      />
      <path
        fill="#fff"
        d="M25.0435 25.0283v9.3614c0 5.3247 6.9565 6.9565 6.9565 6.9565s6.9565-1.6318 6.9565-6.9565v-9.3614z"
      />
      <path
        fill="#338af3"
        d="m7.7599 32.2253 3.7624 10.523 3.7232-10.523h2.8415l-5.4282 13.913h-2.2732l-5.467-13.913zm43.7184 13.913v-13.913h2.7041v13.913z"
      />
      <path
        fill="#d80027"
        d="M27.8261 28.0513v11.3442c.9564.7039 1.9854 1.188 2.7826 1.498V28.0513zm8.3478 0v11.3442c-.9564.7039-1.9854 1.188-2.7827 1.498V28.0513z"
      />
      <path fill="#0052b4" d="M25.0435 25.0281h13.913v4.4145h-13.913z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Vi',
  64
);

export const VnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="m32 16.6956 3.4535 10.6286h11.1756l-9.0414 6.5687 3.4535 10.6288L32 37.9528l-9.0413 6.5689 3.4535-10.6288-9.0412-6.5687h11.1755z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Vn',
  64
);

export const VuIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#000"
        d="M63.9999 32a32.3 32.3 0 0 0-.2709-4.1739H27.8257C21.2881 21.2889 9.372 9.3736 9.3725 9.3726c-12.4967 12.4967-12.4967 32.7579 0 45.2549L27.826 36.174h35.903A32.3 32.3 0 0 0 63.9999 32"
      />
      <path
        fill="#fff"
        d="M63.96 33.6023c-.0029.0611-.0071.122-.0104.183.0033-.0609.0073-.1219.0104-.183m-.0431.6975c-.0064.0899-.0126.1798-.0199.2694.0073-.0896.0134-.1795.0199-.2694m-.1069-5.7876c.0117.107.0235.2139.0341.3211-.0106-.1073-.0225-.2141-.0341-.3211m.1395 1.7024c.0034.061.0075.1219.0104.183-.003-.0611-.007-.1221-.0104-.183m.0366.8723c.0018.0618.003.1238.0045.1855zm-.0891-1.6562c.0073.0896.0135.1795.0199.2693-.0065-.0898-.0126-.1797-.0199-.2693"
      />
      <path
        fill="#d80027"
        d="M63.729 27.8262c.0144.1096.0271.2199.0402.3297C61.87 12.2957 48.3718.0002 31.9999.0002c-8.8367 0-16.8368 3.582-22.6277 9.373l18.453 18.4531z"
      />
      <path
        fill="#6da544"
        d="M63.729 36.174H27.8252L9.3722 54.6271c5.7909 5.791 13.791 9.373 22.6277 9.373 16.3719 0 29.8702-12.2955 31.7693-28.1559-.0131.1099-.0261.2202-.0402.3298"
      />
      <path
        fill="#fff"
        d="M63.844 35.1665c-.0106.1073-.0224.2141-.0341.3211.0117-.107.0236-.2137.0341-.3211"
      />
      <path
        fill="#ffda44"
        d="M63.9694 30.5971H26.6501L7.4805 11.4304c-.6196.6535-1.2913 1.566-1.7066 2.2159l18.3323 18.342-18.3477 18.348c.3632.6463 1.1546 1.6028 1.7102 2.2252l19.1817-19.1817h37.3235c.0198-.4615.0261-.925.0261-1.3913a31 31 0 0 0-.0306-1.3914"
      />
      <path
        fill="#ffda44"
        d="M7.7734 38.8214v-2.6803c2.6747 0 4.8506-2.1762 4.8506-4.8507 0-1.8923-1.5397-3.4318-3.432-3.4318-1.289 0-2.3379 1.0487-2.3379 2.3381 0 .8244.6706 1.4951 1.4951 1.4951.466 0 .8451-.3794.8451-.8454h2.6803c0 1.9442-1.5815 3.5257-3.5253 3.5257-2.3023.0001-4.1752-1.8732-4.1752-4.1751 0-2.7672 2.2512-5.0183 5.0181-5.0183 3.3703 0 6.1123 2.742 6.1123 6.1121-.0002 4.1521-3.3785 7.5306-7.5312 7.5306"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Vu',
  64
);

export const WalesIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path fill="#496e2d" d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32" />
      <path
        fill="#d80027"
        d="M55.3767 22.2679c-1.1443-3.2454-4.2365-5.5722-7.8733-5.5722h-7.1555c-4.6104 0-8.3479 3.7375-8.3479 8.3479 0 1.5063.401 2.9539 1.0989 4.1739-2.6572-.0218-5.1163.0184-6.6642 0v-8.1789l.3288-.3287c1.4757-1.4758.9836-3.9353.9836-3.9353s-2.4592-.4919-3.935.9839l-1.7199 1.7199h-1.9183c-4.2263 0-7.6522 3.426-7.6522 7.6521h5.5653v6.2609c0 .9157.1846 1.7881.5182 2.5826l-1.9096 1.5912H13.913v-2.7826h-2.7826v5.5653h12.5217v5.5652h-2.7826v2.7826h5.5652v-5.5652l2.5507-3.0609h6.0291l2.5506 3.0609v2.7826h-2.7826v2.7826h11.1304V33.3912c0-2.3051 1.8687-4.1738 4.1738-4.1738.0593 0 .118.0021.1768.0045a5.57 5.57 0 0 1-.1768-1.3958c.0003-2.9811 2.3444-5.4146 5.29-5.5582M40.3479 45.913v-5.8435h.2318l2.5507 3.0609v2.7826z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Wales',
  64
);

export const WsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#d80027"
        d="M64 32c0 17.673-14.327 32-32 32S0 49.673 0 32L32 0c17.673 0 32 14.327 32 32"
      />
      <path fill="#0052b4" d="M32 32V0C14.327 0 0 14.327 0 32z" />
      <path
        fill="#fff"
        d="m25.6318 20.8696.5181 1.5944h1.6762l-1.3562.9851.5181 1.5944-1.3562-.9854-1.3563.9854.5181-1.5944-1.3562-.9851h1.6762zM17.2122 8.3479l.8634 2.6574h2.794l-2.2605 1.6419.8636 2.6572-2.2605-1.6424-2.2603 1.6424.8635-2.6572-2.2604-1.6419h2.7937zm8.3479 2.7825.8634 2.6575h2.7939l-2.2604 1.6418.8634 2.6573-2.2603-1.6424-2.2603 1.6424.8635-2.6573-2.2604-1.6418h2.7937zM18.9616 22.261l.8635 2.6574h2.7938l-2.2604 1.6418.8635 2.6573-2.2604-1.6423-2.2603 1.6423.8635-2.6573-2.2604-1.6418h2.7938zm-7.3146-6.9566.8635 2.6574h2.7939l-2.2605 1.6419.8635 2.6572-2.2604-1.6422-2.2603 1.6422.8634-2.6572-2.2602-1.6419h2.7937z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ws',
  64
);

export const YeIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="M32 64c13.7589 0 25.4882-8.684 30.0096-20.8696H1.9904C6.5118 55.316 18.241 64 32 64"
      />
      <path
        fill="#d80027"
        d="M32 0C18.2411 0 6.5118 8.684 1.9904 20.8696h60.0193C57.4882 8.684 45.7589 0 32 0"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Ye',
  64
);

export const ZaIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#000"
        d="M9.3725 54.6276c-12.4967-12.4969-12.4967-32.7582 0-45.255C9.3716 9.3739 27.8261 32 27.8261 32z"
      />
      <path
        fill="#ffda44"
        d="M27.8261 32.0001 4.2441 16.0642a31.9 31.9 0 0 0-1.9298 3.9704l11.9386 11.9656L2.3147 43.9665a31.85 31.85 0 0 0 1.9282 3.9676z"
      />
      <path
        fill="#6da544"
        d="M63.7291 27.8262H27.8252L9.3722 9.3731a32.12 32.12 0 0 0-5.128 6.6912L20.149 32 4.2429 47.9338a32.12 32.12 0 0 0 5.1293 6.6931l18.453-18.453h35.9039A32.3 32.3 0 0 0 64 32c0-1.4146-.093-2.8076-.2709-4.1738"
      />
      <path
        fill="#0052b4"
        d="M12.5173 57.3847C17.9134 61.5324 24.668 64 32 64c14.7849 0 27.2256-10.0276 30.8976-23.6521H29.5541z"
      />
      <path
        fill="#d80027"
        d="M62.8976 23.6521C59.2256 10.0276 46.7849 0 32 0c-7.332 0-14.0866 2.4676-19.4827 6.6154L29.554 23.652z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Za',
  64
);

export const ZmIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#496e2d"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#d80027"
        d="M44.5218 32H32v32c3.7405 0 7.3301-.6439 10.6666-1.8232z"
      />
      <path
        fill="#ff9811"
        d="M53.3332 55.8491C59.8792 49.9899 64 41.4766 64 32H51.4782z"
      />
      <path
        fill="#000"
        d="M42.6666 32v30.1768c3.9747-1.4052 7.5889-3.5725 10.6668-6.3275V32z"
      />
      <path
        fill="#ff9811"
        d="M59.1304 20.8695h-8.3479c0-1.5367-1.2459-2.7826-2.7826-2.7826s-2.7827 1.2459-2.7827 2.7826h-8.3478c0 1.5369 1.3386 2.7827 2.8752 2.7827h-.0926c0 1.5368 1.2456 2.7826 2.7826 2.7826 0 1.5369 1.2456 2.7826 2.7826 2.7826h5.5653c1.5367 0 2.7826-1.2457 2.7826-2.7826 1.5368 0 2.7826-1.2458 2.7826-2.7826h-.0926c1.5368-.0002 2.8753-1.2459 2.8753-2.7827"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Zm',
  64
);

export const ZwIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="#fff"
        d="M32 64c17.6731 0 32-14.3269 32-32S49.6731 0 32 0 0 14.3269 0 32s14.3269 32 32 32"
      />
      <path
        fill="#ffda44"
        d="M60.9371 18.3254c-1.6257-3.4342-3.8446-6.5321-6.5246-9.1627L32 6.9565 9.5875 9.1628c-.0715.0701-.1413.1419-.212.2127l8.95 8.95L32 18.7432zM9.3751 54.6249c.1178.1177.2353.2356.3548.3516L32 57.0435l22.2699-2.067c2.7076-2.625 4.9536-5.7231 6.6022-9.1628l-41.394-1.292c-3.5616 3.5618-7.6696 7.6695-10.103 10.1032"
      />
      <path
        fill="#000"
        d="m63.6818 27.4882-37.247-1.0534L32 32.0001l-5.5652 5.5652 37.2275-.9142A32.25 32.25 0 0 0 64 32.0001c0-1.5318-.11-3.0375-.3182-4.5119"
      />
      <path
        fill="#6da544"
        d="M32 0C23.2715 0 15.3607 3.4963 9.5875 9.1628h44.825C48.6392 3.4962 40.7285 0 32 0"
      />
      <path
        fill="#d80027"
        d="M27.4881 27.4882h36.1937a31.78 31.78 0 0 0-2.7447-9.1628H18.3254zm-9.3019 18.3257h42.686a31.78 31.78 0 0 0 2.7902-9.1628H27.349z"
      />
      <path
        fill="#6da544"
        d="M32 63.9999c8.6569 0 16.5094-3.439 22.2699-9.0236H9.7301c5.7605 5.5846 13.613 9.0236 22.2699 9.0236"
      />
      <path
        fill="#000"
        d="M11.4269 7.4917a32.2 32.2 0 0 0-2.0544 1.8808L32 32 9.3725 54.6274a32.2 32.2 0 0 0 2.0544 1.8808L35.9351 32z"
      />
      <path
        fill="#d80027"
        d="m12.8656 23.6521 2.0719 6.377h6.7056l-5.4247 3.9415 2.072 6.3772-5.4248-3.9413-5.4248 3.9413 2.0722-6.3772-5.4246-3.9415h6.7052z"
      />
      <path
        fill="#ffda44"
        d="m18.5649 32.5217-5.3998-1.913s-.399-3.7429-.4231-3.8697c-.1832-.9654-1.0316-1.6955-2.0504-1.6955-1.1525 0-2.087.9343-2.087 2.087 0 .1911.0279.3752.076.5512l-1.514 1.5241h2.692c0 2.7942-2.085 2.7942-2.085 5.5768l1.1566 2.7826h6.9566l1.1595-2.7826h-.0005a2.78 2.78 0 0 0 .2157-.8175c.9995-.4043 1.3034-1.4434 1.3034-1.4434"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Zw',
  64
);
